var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _construct = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e29) { throw _e29; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e30) { didErr = true; err = _e30; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*! For license information please see node.native.js.LICENSE.txt */
!function (e, a) {
  "object" == typeof exports && "object" == typeof module ? module.exports = a() : "function" == typeof define && define.amd ? define([], a) : "object" == typeof exports ? exports.transifex = a() : e.transifex = a();
}(global, function () {
  return function () {
    var e = {
      9182: function _(e, a, n) {
        "use strict";

        var i = n(7564),
            t = n(7249),
            s = n(7630),
            o = n(4534);

        function r(e) {
          if (e && e.__esModule) return e;
          var a = Object.create(null);
          return e && Object.keys(e).forEach(function (n) {
            if ("default" !== n) {
              var i = Object.getOwnPropertyDescriptor(e, n);
              Object.defineProperty(a, n, i.get ? i : {
                enumerable: !0,
                get: function get() {
                  return e[n];
                }
              });
            }
          }), a.default = e, Object.freeze(a);
        }

        var c = r(t),
            p = r(s);

        var l = /*#__PURE__*/function (_Error) {
          _inherits(l, _Error);

          var _super = _createSuper(l);

          function l(e, a, n) {
            var _this;

            _classCallCheck(this, l);

            _this = _super.call(this, e), _this.token = a, _this.type = n || "error";
            return _this;
          }

          return _createClass(l);
        }( /*#__PURE__*/_wrapNativeSuper(Error));

        var u = function u(e) {
          return e < 4 ? "short" : 4 === e ? "long" : "narrow";
        },
            m = function m(e) {
          return e % 2 == 0 ? "2-digit" : "numeric";
        };

        function d(e, a) {
          switch (e.width) {
            case 1:
              return "numeric";

            case 2:
              return "2-digit";

            case 3:
              return "short";

            case 4:
              return "long";

            case 5:
              return "narrow";

            default:
              return void a("".concat(e.desc, " is not supported with width ").concat(e.width));
          }
        }

        function f(e, a) {
          var n = e.char,
              i = e.desc,
              t = e.width;
          return "d" === n ? m(t) : void a("".concat(i, " is not supported"));
        }

        function h(e, a) {
          var n = e.char,
              i = e.desc,
              t = e.width;
          return ("c" === n || "e" === n) && t < 3 && a("Numeric value is not supported for ".concat(i, "; falling back to weekday:short"), l.WARNING), u(t);
        }

        function x(e, a) {
          var n = e.char,
              i = e.desc,
              t = e.width;

          switch (n) {
            case "v":
            case "z":
              return 4 === t ? "long" : "short";

            case "V":
              return 4 === t ? "long" : void a("".concat(i, " is not supported with width ").concat(t));

            case "X":
              return void a("".concat(i, " is not supported"));
          }

          return "short";
        }

        function v(e, a) {
          switch (e.field) {
            case "era":
              return {
                era: u(e.width)
              };

            case "year":
              return function (e, a) {
                switch (e.char) {
                  case "y":
                    return {
                      year: m(e.width)
                    };

                  case "r":
                    return {
                      calendar: "gregory",
                      year: "numeric"
                    };

                  default:
                    return a("".concat(e.desc, " is not supported; falling back to year:numeric"), l.WARNING), {
                      year: "numeric"
                    };
                }
              }(e, a);

            case "month":
              return {
                month: d(e, a)
              };

            case "day":
              return {
                day: f(e, a)
              };

            case "weekday":
              return {
                weekday: h(e, a)
              };

            case "period":
              return;

            case "hour":
              return function (e) {
                var a = m(e.width);
                var n;

                switch (e.char) {
                  case "h":
                    n = "h12";
                    break;

                  case "H":
                    n = "h23";
                    break;

                  case "k":
                    n = "h24";
                    break;

                  case "K":
                    n = "h11";
                }

                return n ? {
                  hour: a,
                  hourCycle: n
                } : {
                  hour: a
                };
              }(e);

            case "min":
              return {
                minute: m(e.width)
              };

            case "sec":
              return {
                second: m(e.width)
              };

            case "tz":
              return {
                timeZoneName: x(e, a)
              };

            case "quarter":
            case "week":
            case "sec-frac":
            case "ms":
              a("".concat(e.desc, " is not supported"));
          }
        }

        function g(e) {
          var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (e) {
            throw e;
          };
          var n = {},
              i = [];

          var _iterator = _createForOfIteratorHelper(e),
              _step;

          try {
            var _loop = function _loop() {
              var t = _step.value;
              var e = t.error,
                  s = t.field,
                  o = t.str;

              if (e) {
                var _n = new l(e.message, t);

                _n.stack = e.stack, a(_n);
              }

              o && a(new l("Ignoring string part: ".concat(o), t, l.WARNING)), s && (-1 === i.indexOf(s) ? i.push(s) : a(new l("Duplicate ".concat(s, " token"), t)));
              var r = v(t, function (e, n) {
                return a(new l(e, t, n));
              });
              r && Object.assign(n, r);
            };

            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return n;
        }

        var b = {
          G: {
            field: "era",
            desc: "Era"
          },
          y: {
            field: "year",
            desc: "Year"
          },
          Y: {
            field: "year",
            desc: 'Year of "Week of Year"'
          },
          u: {
            field: "year",
            desc: "Extended year"
          },
          U: {
            field: "year",
            desc: "Cyclic year name"
          },
          r: {
            field: "year",
            desc: "Related Gregorian year"
          },
          Q: {
            field: "quarter",
            desc: "Quarter"
          },
          q: {
            field: "quarter",
            desc: "Stand-alone quarter"
          },
          M: {
            field: "month",
            desc: "Month in year"
          },
          L: {
            field: "month",
            desc: "Stand-alone month in year"
          },
          w: {
            field: "week",
            desc: "Week of year"
          },
          W: {
            field: "week",
            desc: "Week of month"
          },
          d: {
            field: "day",
            desc: "Day in month"
          },
          D: {
            field: "day",
            desc: "Day of year"
          },
          F: {
            field: "day",
            desc: "Day of week in month"
          },
          g: {
            field: "day",
            desc: "Modified julian day"
          },
          E: {
            field: "weekday",
            desc: "Day of week"
          },
          e: {
            field: "weekday",
            desc: "Local day of week"
          },
          c: {
            field: "weekday",
            desc: "Stand-alone local day of week"
          },
          a: {
            field: "period",
            desc: "AM/PM marker"
          },
          b: {
            field: "period",
            desc: "AM/PM/noon/midnight marker"
          },
          B: {
            field: "period",
            desc: "Flexible day period"
          },
          h: {
            field: "hour",
            desc: "Hour in AM/PM (1~12)"
          },
          H: {
            field: "hour",
            desc: "Hour in day (0~23)"
          },
          k: {
            field: "hour",
            desc: "Hour in day (1~24)"
          },
          K: {
            field: "hour",
            desc: "Hour in AM/PM (0~11)"
          },
          j: {
            field: "hour",
            desc: "Hour in preferred cycle"
          },
          J: {
            field: "hour",
            desc: "Hour in preferred cycle without marker"
          },
          C: {
            field: "hour",
            desc: "Hour in preferred cycle with flexible marker"
          },
          m: {
            field: "min",
            desc: "Minute in hour"
          },
          s: {
            field: "sec",
            desc: "Second in minute"
          },
          S: {
            field: "sec-frac",
            desc: "Fractional second"
          },
          A: {
            field: "ms",
            desc: "Milliseconds in day"
          },
          z: {
            field: "tz",
            desc: "Time Zone: specific non-location"
          },
          Z: {
            field: "tz",
            desc: "Time Zone"
          },
          O: {
            field: "tz",
            desc: "Time Zone: localized"
          },
          v: {
            field: "tz",
            desc: "Time Zone: generic non-location"
          },
          V: {
            field: "tz",
            desc: "Time Zone: ID"
          },
          X: {
            field: "tz",
            desc: "Time Zone: ISO8601 with Z"
          },
          x: {
            field: "tz",
            desc: "Time Zone: ISO8601"
          }
        },
            y = function y(e) {
          return e >= "A" && e <= "Z" || e >= "a" && e <= "z";
        };

        function w(e, a) {
          var n = e[a];
          if (!n) return null;
          if (y(n)) return function (e, a) {
            var n = e[a];
            var i = 1;

            for (; e[++a] === n;) {
              ++i;
            }

            var t = b[n];
            return t ? {
              char: n,
              field: t.field,
              desc: t.desc,
              width: i
            } : {
              char: n,
              error: new Error("The letter ".concat(n, " is not a valid field identifier")),
              width: i
            };
          }(e, a);
          if ("'" === n) return function (e, a) {
            var n = e[++a],
                i = 2;
            if ("'" === n) return {
              char: "'",
              str: n,
              width: i
            };

            for (;;) {
              var _t = e[++a];
              if (++i, void 0 === _t) return {
                char: "'",
                error: new Error("Unterminated quoted literal in pattern: ".concat(n || e)),
                str: n,
                width: i
              };

              if ("'" === _t) {
                if ("'" !== e[++a]) return {
                  char: "'",
                  str: n,
                  width: i
                };
                ++i;
              }

              n += _t;
            }
          }(e, a);
          var i = n,
              t = 1;

          for (;;) {
            var _s = e[++a];
            if (!_s || y(_s) || "'" === _s) return {
              char: n,
              str: i,
              width: t
            };
            i += _s, t += 1;
          }
        }

        function k(e) {
          var a = [];
          var n = 0;

          for (;;) {
            var _i = w(e, n);

            if (!_i) return a;
            a.push(_i), n += _i.width;
          }
        }

        var j = /*#__PURE__*/function (_Error2) {
          _inherits(j, _Error2);

          var _super2 = _createSuper(j);

          function j(e, a) {
            var _this2;

            _classCallCheck(this, j);

            _this2 = _super2.call(this, a), _this2.code = e;
            return _this2;
          }

          return _createClass(j);
        }( /*#__PURE__*/_wrapNativeSuper(Error));

        var _ = /*#__PURE__*/function (_j) {
          _inherits(_, _j);

          var _super3 = _createSuper(_);

          function _(e, a) {
            var _this3;

            _classCallCheck(this, _);

            _this3 = _super3.call(this, "BAD_OPTION", "Unknown ".concat(e, " option: ").concat(a)), _this3.stem = e, _this3.option = a;
            return _this3;
          }

          return _createClass(_);
        }(j);

        var S = /*#__PURE__*/function (_j2) {
          _inherits(S, _j2);

          var _super4 = _createSuper(S);

          function S(e) {
            var _this4;

            _classCallCheck(this, S);

            _this4 = _super4.call(this, "BAD_STEM", "Unknown stem: ".concat(e)), _this4.stem = e;
            return _this4;
          }

          return _createClass(S);
        }(j);

        var E = /*#__PURE__*/function (_j3) {
          _inherits(E, _j3);

          var _super5 = _createSuper(E);

          function E(e, a) {
            var _this5;

            _classCallCheck(this, E);

            _this5 = _super5.call(this, "MASKED_VALUE", "Value for ".concat(e, " is set multiple times")), _this5.type = e, _this5.prev = a;
            return _this5;
          }

          return _createClass(E);
        }(j);

        var O = /*#__PURE__*/function (_j4) {
          _inherits(O, _j4);

          var _super6 = _createSuper(O);

          function O(e) {
            var _this6;

            _classCallCheck(this, O);

            _this6 = _super6.call(this, "MISSING_OPTION", "Required option missing for ".concat(e)), _this6.stem = e;
            return _this6;
          }

          return _createClass(O);
        }(j);

        var T = /*#__PURE__*/function (_j5) {
          _inherits(T, _j5);

          var _super7 = _createSuper(T);

          function T(e, a) {
            var _this7;

            _classCallCheck(this, T);

            _this7 = _super7.call(this, "BAD_PATTERN", a), _this7.char = e;
            return _this7;
          }

          return _createClass(T);
        }(j);

        var C = /*#__PURE__*/function (_j6) {
          _inherits(C, _j6);

          var _super8 = _createSuper(C);

          function C(e, a, n) {
            var _this8;

            _classCallCheck(this, C);

            _this8 = _super8.call(this, "TOO_MANY_OPTIONS", "Token ".concat(e, " only supports ").concat(n > 1 ? "".concat(n, " options") : "one option", " (got ").concat(a.length, ")")), _this8.stem = e, _this8.options = a;
            return _this8;
          }

          return _createClass(C);
        }(j);

        var z = /*#__PURE__*/function (_j7) {
          _inherits(z, _j7);

          var _super9 = _createSuper(z);

          function z(e, a) {
            var _this9;

            _classCallCheck(this, z);

            _this9 = _super9.call(this, "UNSUPPORTED", "The stem ".concat(e, " is not supported")), _this9.stem = e, a && (_this9.message += " with value ".concat(a), _this9.source = a);
            return _this9;
          }

          return _createClass(z);
        }(j);

        function N(e, _ref) {
          var a = _ref.numberingSystem;
          return Array.isArray(e) || (e = [e]), a ? e.map(function (e) {
            var n = -1 === e.indexOf("-u-") ? "u-nu" : "nu";
            return "".concat(e, "-").concat(n, "-").concat(a);
          }).concat(e) : e;
        }

        function R(_ref2) {
          var e = _ref2.scale,
              a = _ref2.unit;
          var n = "number" == typeof e && e >= 0 ? e : 1;
          return a && "percent" === a.style && (n *= .01), n;
        }

        function A(e, a) {
          var n = e.decimal,
              i = e.group,
              t = e.integerWidth,
              s = e.notation,
              o = e.precision,
              r = e.roundingMode,
              c = e.sign,
              p = e.unit,
              l = e.unitPer,
              u = e.unitWidth,
              m = function m(e, n) {
            a && a(new z(e, n));
          },
              d = {};

          if (p) switch (p.style) {
            case "base-unit":
              d.style = "decimal";
              break;

            case "currency":
              d.style = "currency", d.currency = p.currency;
              break;

            case "measure-unit":
              d.style = "unit", d.unit = p.unit.replace(/.*-/, ""), l && (d.unit += "-per-" + l.replace(/.*-/, ""));
              break;

            case "percent":
              d.style = "percent";
              break;

            case "permille":
              m("permille");
          }

          switch (u) {
            case "unit-width-full-name":
              d.currencyDisplay = "name", d.unitDisplay = "long";
              break;

            case "unit-width-hidden":
              m(u);
              break;

            case "unit-width-iso-code":
              d.currencyDisplay = "code";
              break;

            case "unit-width-narrow":
              d.currencyDisplay = "narrowSymbol", d.unitDisplay = "narrow";
              break;

            case "unit-width-short":
              d.currencyDisplay = "symbol", d.unitDisplay = "short";
          }

          switch (i) {
            case "group-off":
              d.useGrouping = !1;
              break;

            case "group-auto":
              d.useGrouping = !0;
              break;

            case "group-min2":
            case "group-on-aligned":
            case "group-thousands":
              m(i), d.useGrouping = !0;
          }

          if (o) switch (o.style) {
            case "precision-fraction":
              {
                var _e = o.minFraction,
                    _a = o.maxFraction,
                    _n2 = o.minSignificant,
                    _i2 = o.maxSignificant,
                    _t2 = o.source;
                "number" == typeof _e && (d.minimumFractionDigits = _e, "number" == typeof _n2 && m("precision-fraction", _t2)), "number" == typeof _a && (d.maximumFractionDigits = _a), "number" == typeof _n2 && (d.minimumSignificantDigits = _n2), "number" == typeof _i2 && (d.maximumSignificantDigits = _i2);
                break;
              }

            case "precision-integer":
              d.maximumFractionDigits = 0;
              break;

            case "precision-unlimited":
              d.maximumFractionDigits = 20;
              break;

            case "precision-increment":
            case "precision-currency-standard":
              break;

            case "precision-currency-cash":
              m(o.style);
          }
          if (s) switch (s.style) {
            case "compact-short":
              d.notation = "compact", d.compactDisplay = "short";
              break;

            case "compact-long":
              d.notation = "compact", d.compactDisplay = "long";
              break;

            case "notation-simple":
              d.notation = "standard";
              break;

            case "scientific":
            case "engineering":
              {
                var _e2 = s.expDigits,
                    _a2 = s.expSign,
                    _n3 = s.source,
                    _i3 = s.style;
                d.notation = _i3, (_e2 && _e2 > 1 || _a2 && "sign-auto" !== _a2) && m(_i3, _n3);
                break;
              }
          }

          if (t) {
            var _e3 = t.min,
                _a3 = t.max,
                _n4 = t.source;

            if (_e3 > 0 && (d.minimumIntegerDigits = _e3), Number(_a3) > 0) {
              var _e4 = "engineering" === d.notation || "scientific" === d.notation;

              3 === _a3 && _e4 ? d.notation = "engineering" : m("integer-width", _n4);
            }
          }

          switch (c) {
            case "sign-auto":
              d.signDisplay = "auto";
              break;

            case "sign-always":
              d.signDisplay = "always";
              break;

            case "sign-except-zero":
              d.signDisplay = "exceptZero";
              break;

            case "sign-never":
              d.signDisplay = "never";
              break;

            case "sign-accounting":
              d.currencySign = "accounting";
              break;

            case "sign-accounting-always":
              d.currencySign = "accounting", d.signDisplay = "always";
              break;

            case "sign-accounting-except-zero":
              d.currencySign = "accounting", d.signDisplay = "exceptZero";
          }

          return "decimal-always" === n && m(n), r && m(r), d;
        }

        function F(e, a, n) {
          var i = e[a];

          switch (i) {
            case "%":
              return {
                char: "%",
                style: "percent",
                width: 1
              };

            case "‰":
              return {
                char: "%",
                style: "permille",
                width: 1
              };

            case "¤":
              {
                var _t3 = 1;

                for (; "¤" === e[++a];) {
                  ++_t3;
                }

                switch (_t3) {
                  case 1:
                    return {
                      char: i,
                      currency: "default",
                      width: _t3
                    };

                  case 2:
                    return {
                      char: i,
                      currency: "iso-code",
                      width: _t3
                    };

                  case 3:
                    return {
                      char: i,
                      currency: "full-name",
                      width: _t3
                    };

                  case 5:
                    return {
                      char: i,
                      currency: "narrow",
                      width: _t3
                    };

                  default:
                    return n(new T("¤", "Invalid number (".concat(_t3, ") of \xA4 chars in pattern"))), null;
                }
              }

            case "*":
              {
                var _n5 = e[a + 1];
                if (_n5) return {
                  char: i,
                  pad: _n5,
                  width: 2
                };
                break;
              }

            case "+":
            case "-":
              return {
                char: i,
                width: 1
              };

            case "'":
              {
                var _t4 = e[++a],
                    _s2 = 2;
                if ("'" === _t4) return {
                  char: i,
                  str: _t4,
                  width: _s2
                };

                for (;;) {
                  var _o = e[++a];
                  if (++_s2, void 0 === _o) return n(new T("'", "Unterminated quoted literal in pattern: ".concat(_t4))), {
                    char: i,
                    str: _t4,
                    width: _s2
                  };

                  if ("'" === _o) {
                    if ("'" !== e[++a]) return {
                      char: i,
                      str: _t4,
                      width: _s2
                    };
                    ++_s2;
                  }

                  _t4 += _o;
                }
              }
          }

          return null;
        }

        var q = function q(e) {
          return e >= "0" && e <= "9";
        };

        function L(e, a) {
          var n = e[a];

          if (q(n)) {
            var _i4 = n;

            for (;;) {
              var _n6 = e[++a];
              if (!q(_n6)) return {
                char: "0",
                digits: _i4,
                width: _i4.length
              };
              _i4 += _n6;
            }
          }

          switch (n) {
            case "#":
              {
                var _i5 = 1;

                for (; "#" === e[++a];) {
                  ++_i5;
                }

                return {
                  char: n,
                  width: _i5
                };
              }

            case "@":
              {
                var _i6 = 1;

                for (; "@" === e[++a];) {
                  ++_i6;
                }

                var _t5 = _i6;

                for (a -= 1; "#" === e[++a];) {
                  ++_t5;
                }

                return {
                  char: n,
                  min: _i6,
                  width: _t5
                };
              }

            case "E":
              {
                var _i7 = "+" === e[a + 1];

                _i7 && ++a;
                var _t6 = 0;

                for (; "0" === e[++a];) {
                  ++_t6;
                }

                var _s3 = (_i7 ? 2 : 1) + _t6;

                if (_t6) return {
                  char: n,
                  expDigits: _t6,
                  plus: _i7,
                  width: _s3
                };
                break;
              }

            case ".":
            case ",":
              return {
                char: n,
                width: 1
              };
          }

          return null;
        }

        function B(e, a, n) {
          var i;
          !function (e) {
            e[e.Prefix = 0] = "Prefix", e[e.Number = 1] = "Number", e[e.Suffix = 2] = "Suffix";
          }(i || (i = {}));
          var t = [],
              s = [],
              o = [];
          var r = i.Prefix,
              c = "";

          for (; a < e.length;) {
            var _p = e[a];

            if (";" === _p) {
              a += 1;
              break;
            }

            switch (r) {
              case i.Prefix:
                {
                  var _o2 = F(e, a, n);

                  if (_o2) c && (t.push({
                    char: "'",
                    str: c,
                    width: c.length
                  }), c = ""), t.push(_o2), a += _o2.width;else {
                    var _n7 = L(e, a);

                    _n7 ? (c && (t.push({
                      char: "'",
                      str: c,
                      width: c.length
                    }), c = ""), r = i.Number, s.push(_n7), a += _n7.width) : (c += _p, a += 1);
                  }
                  break;
                }

              case i.Number:
                {
                  var _n8 = L(e, a);

                  _n8 ? (s.push(_n8), a += _n8.width) : r = i.Suffix;
                  break;
                }

              case i.Suffix:
                {
                  var _i8 = F(e, a, n);

                  _i8 ? (c && (o.push({
                    char: "'",
                    str: c,
                    width: c.length
                  }), c = ""), o.push(_i8), a += _i8.width) : (c += _p, a += 1);
                  break;
                }
            }
          }

          return c && o.push({
            char: "'",
            str: c,
            width: c.length
          }), {
            pattern: {
              prefix: t,
              number: s,
              suffix: o
            },
            pos: a
          };
        }

        function P(e, a, n, i, t) {
          var s = !1,
              o = "";

          var _iterator2 = _createForOfIteratorHelper(e),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _r = _step2.value;

              switch (_r.char) {
                case "%":
                  a.unit = {
                    style: _r.style
                  }, t ? s = !0 : o = "";
                  break;

                case "¤":
                  if (!n) {
                    i(new T("¤", "The ¤ pattern requires a currency"));
                    break;
                  }

                  switch (a.unit = {
                    style: "currency",
                    currency: n
                  }, _r.currency) {
                    case "iso-code":
                      a.unitWidth = "unit-width-iso-code";
                      break;

                    case "full-name":
                      a.unitWidth = "unit-width-full-name";
                      break;

                    case "narrow":
                      a.unitWidth = "unit-width-narrow";
                  }

                  t ? s = !0 : o = "";
                  break;

                case "*":
                  break;

                case "+":
                  s || (o += "+");
                  break;

                case "'":
                  s || (o += _r.str);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          return o;
        }

        function D(e, a) {
          var n = !1,
              i = "";

          var _iterator3 = _createForOfIteratorHelper(e),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _t7 = _step3.value;

              switch (_t7.char) {
                case "%":
                case "¤":
                  a ? n = !0 : i = "";
                  break;

                case "-":
                  n || (i += "-");
                  break;

                case "'":
                  n || (i += _t7.str);
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          return i;
        }

        function $(e, a) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (e) {
            throw e;
          };

          var _ref3 = function (e, a) {
            var _B = B(e, 0, a),
                n = _B.pattern,
                i = _B.pos;

            if (i < e.length) {
              var _B2 = B(e, i, a),
                  _t8 = _B2.pattern;

              return {
                tokens: n,
                negative: _t8
              };
            }

            return {
              tokens: n
            };
          }(e, n),
              i = _ref3.tokens,
              t = _ref3.negative,
              s = function (e, a) {
            var n = {};
            var i = !1,
                t = !1,
                s = 0,
                o = "",
                r = -1,
                c = "",
                p = 0;

            for (var _l = 0; _l < e.length; ++_l) {
              var _u = e[_l];

              switch (_u.char) {
                case "#":
                  -1 === r ? (o && a(new T("#", "Pattern has # after integer digits")), s += _u.width) : p += _u.width;
                  break;

                case "0":
                  -1 === r ? o += _u.digits : (p && a(new T("0", "Pattern has digits after # in fraction")), c += _u.digits);
                  break;

                case "@":
                  n.precision && a(new E("precision", n.precision)), n.precision = {
                    style: "precision-fraction",
                    minSignificant: _u.min,
                    maxSignificant: _u.width
                  };
                  break;

                case ",":
                  i = !0;
                  break;

                case ".":
                  1 === r && a(new T(".", "Pattern has more than one decimal separator")), r = _l;
                  break;

                case "E":
                  t && a(new E("exponent", n.notation)), i && a(new T("E", "Exponential patterns may not contain grouping separators")), n.notation = {
                    style: "scientific"
                  }, _u.expDigits > 1 && (n.notation.expDigits = _u.expDigits), _u.plus && (n.notation.expSign = "sign-always"), t = !0;
              }
            }

            i ? n.group = "group-auto" : s + o.length > 3 && (n.group = "group-off");
            var l = Number("".concat(o || "0", ".").concat(c));
            if (l && (n.precision = {
              style: "precision-increment",
              increment: l
            }), t) {
              if (n.precision && !l || (n.integerWidth = s ? {
                min: 1,
                max: s + o.length
              } : {
                min: Math.max(1, o.length)
              }), n.precision) l || (n.integerWidth = {
                min: 1,
                max: 1
              });else {
                var _e5 = o.length + c.length;

                -1 === r ? _e5 > 0 && (n.precision = {
                  style: "precision-fraction",
                  maxSignificant: _e5
                }) : (n.precision = {
                  style: "precision-fraction",
                  maxSignificant: Math.max(1, _e5) + p
                }, _e5 > 1 && (n.precision.minSignificant = _e5));
              }
            } else o.length > 1 && (n.integerWidth = {
              min: o.length
            }), n.precision || !c.length && !p || (n.precision = {
              style: "precision-fraction",
              minFraction: c.length,
              maxFraction: c.length + p
            });
            return n;
          }(i.number, n),
              o = P(i.prefix, s, a, n, !0),
              r = P(i.suffix, s, a, n, !1);

          if (t) {
            var _e6 = D(t.prefix, !0),
                _a4 = D(t.suffix, !1);

            s.affix = {
              pos: [o, r],
              neg: [_e6, _a4]
            }, s.sign = "sign-never";
          } else (o || r) && (s.affix = {
            pos: [o, r]
          });

          return s;
        }

        function I(e) {
          var _e$split = e.split("-", 1),
              _e$split2 = _slicedToArray(_e$split, 1),
              a = _e$split2[0];

          return -1 !== ["acceleration", "angle", "area", "concentr", "consumption", "digital", "duration", "electric", "energy", "force", "frequency", "graphics", "length", "light", "mass", "power", "pressure", "speed", "temperature", "torque", "volume"].indexOf(a);
        }

        var U = {
          "compact-short": 0,
          "compact-long": 0,
          "notation-simple": 0,
          scientific: 2,
          engineering: 2,
          percent: 0,
          permille: 0,
          "base-unit": 0,
          currency: 1,
          "measure-unit": 1,
          "per-measure-unit": 1,
          "unit-width-narrow": 0,
          "unit-width-short": 0,
          "unit-width-full-name": 0,
          "unit-width-iso-code": 0,
          "unit-width-hidden": 0,
          "precision-integer": 0,
          "precision-unlimited": 0,
          "precision-currency-standard": 0,
          "precision-currency-cash": 0,
          "precision-increment": 1,
          "rounding-mode-ceiling": 0,
          "rounding-mode-floor": 0,
          "rounding-mode-down": 0,
          "rounding-mode-up": 0,
          "rounding-mode-half-even": 0,
          "rounding-mode-half-down": 0,
          "rounding-mode-half-up": 0,
          "rounding-mode-unnecessary": 0,
          "integer-width": 1,
          scale: 1,
          "group-off": 0,
          "group-min2": 0,
          "group-auto": 0,
          "group-on-aligned": 0,
          "group-thousands": 0,
          latin: 0,
          "numbering-system": 1,
          "sign-auto": 0,
          "sign-always": 0,
          "sign-never": 0,
          "sign-accounting": 0,
          "sign-accounting-always": 0,
          "sign-except-zero": 0,
          "sign-accounting-except-zero": 0,
          "decimal-auto": 0,
          "decimal-always": 0
        },
            M = {
          currency: 1,
          "integer-width": 1,
          "measure-unit": 1,
          "numbering-system": 1,
          "per-measure-unit": 1,
          "precision-increment": 1,
          scale: 1
        };

        function H(e, a) {
          var n = "fraction" === a ? /^\.(0*)(\+|#*)$/ : /^(@+)(\+|#*)$/,
              i = e && e.match(n);

          if (i) {
            var _e7 = i[1].length;

            switch (i[2].charAt(0)) {
              case "":
                return {
                  min: _e7,
                  max: _e7
                };

              case "+":
                return {
                  min: _e7,
                  max: null
                };

              case "#":
                return {
                  min: _e7,
                  max: _e7 + i[2].length
                };
            }
          }

          return null;
        }

        var W = /*#__PURE__*/function () {
          function W(e) {
            _classCallCheck(this, W);

            this.skeleton = {}, this.onError = e;
          }

          _createClass(W, [{
            key: "badOption",
            value: function badOption(e, a) {
              this.onError(new _(e, a));
            }
          }, {
            key: "assertEmpty",
            value: function assertEmpty(e) {
              var a = this.skeleton[e];
              a && this.onError(new E(e, a));
            }
          }, {
            key: "parseToken",
            value: function parseToken(e, a) {
              if (!function (e, a, n) {
                if (function (e) {
                  return e in U;
                }(e)) {
                  var _i9 = U[e];

                  if (a.length > _i9) {
                    if (0 === _i9) {
                      var _iterator4 = _createForOfIteratorHelper(a),
                          _step4;

                      try {
                        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                          var _i10 = _step4.value;
                          n(new _(e, _i10));
                        }
                      } catch (err) {
                        _iterator4.e(err);
                      } finally {
                        _iterator4.f();
                      }
                    } else n(new C(e, a, _i9));

                    return !1;
                  }

                  if (function (e) {
                    return e in M;
                  }(e) && a.length < M[e]) return n(new O(e)), !1;
                }

                return !0;
              }(e, a, this.onError)) return;
              var n = a[0],
                  i = this.skeleton;

              switch (e) {
                case "compact-short":
                case "compact-long":
                case "notation-simple":
                  this.assertEmpty("notation"), i.notation = {
                    style: e
                  };
                  break;

                case "scientific":
                case "engineering":
                  {
                    var _n9,
                        _t9 = null;

                    var _iterator5 = _createForOfIteratorHelper(a),
                        _step5;

                    try {
                      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                        var _i11 = _step5.value;

                        switch (_i11) {
                          case "sign-auto":
                          case "sign-always":
                          case "sign-never":
                          case "sign-accounting":
                          case "sign-accounting-always":
                          case "sign-except-zero":
                          case "sign-accounting-except-zero":
                            _n9 = _i11;
                            break;

                          default:
                            /^\+e+$/.test(_i11) ? _t9 = _i11.length - 1 : this.badOption(e, _i11);
                        }
                      }
                    } catch (err) {
                      _iterator5.e(err);
                    } finally {
                      _iterator5.f();
                    }

                    this.assertEmpty("notation");

                    var _s4 = a.join("/");

                    i.notation = _t9 && _n9 ? {
                      style: e,
                      source: _s4,
                      expDigits: _t9,
                      expSign: _n9
                    } : _t9 ? {
                      style: e,
                      source: _s4,
                      expDigits: _t9
                    } : _n9 ? {
                      style: e,
                      source: _s4,
                      expSign: _n9
                    } : {
                      style: e,
                      source: _s4
                    };
                    break;
                  }

                case "percent":
                case "permille":
                case "base-unit":
                  this.assertEmpty("unit"), i.unit = {
                    style: e
                  };
                  break;

                case "currency":
                  /^[A-Z]{3}$/.test(n) ? (this.assertEmpty("unit"), i.unit = {
                    style: e,
                    currency: n
                  }) : this.badOption(e, n);
                  break;

                case "measure-unit":
                  I(n) ? (this.assertEmpty("unit"), i.unit = {
                    style: e,
                    unit: n
                  }) : this.badOption(e, n);
                  break;

                case "per-measure-unit":
                  I(n) ? (this.assertEmpty("unitPer"), i.unitPer = n) : this.badOption(e, n);
                  break;

                case "unit-width-narrow":
                case "unit-width-short":
                case "unit-width-full-name":
                case "unit-width-iso-code":
                case "unit-width-hidden":
                  this.assertEmpty("unitWidth"), i.unitWidth = e;
                  break;

                case "precision-integer":
                case "precision-unlimited":
                case "precision-currency-standard":
                case "precision-currency-cash":
                  this.assertEmpty("precision"), i.precision = {
                    style: e
                  };
                  break;

                case "precision-increment":
                  {
                    var _a5 = Number(n);

                    _a5 > 0 ? (this.assertEmpty("precision"), i.precision = {
                      style: e,
                      increment: _a5
                    }) : this.badOption(e, n);
                    break;
                  }

                case "rounding-mode-ceiling":
                case "rounding-mode-floor":
                case "rounding-mode-down":
                case "rounding-mode-up":
                case "rounding-mode-half-even":
                case "rounding-mode-half-down":
                case "rounding-mode-half-up":
                case "rounding-mode-unnecessary":
                  this.assertEmpty("roundingMode"), i.roundingMode = e;
                  break;

                case "integer-width":
                  if (/^\+0*$/.test(n)) this.assertEmpty("integerWidth"), i.integerWidth = {
                    source: n,
                    min: n.length - 1
                  };else {
                    var _a6 = n.match(/^#*(0*)$/);

                    _a6 ? (this.assertEmpty("integerWidth"), i.integerWidth = {
                      source: n,
                      min: _a6[1].length,
                      max: _a6[0].length
                    }) : this.badOption(e, n);
                  }
                  break;

                case "scale":
                  {
                    var _a7 = Number(n);

                    _a7 > 0 ? (this.assertEmpty("scale"), i.scale = _a7) : this.badOption(e, n);
                    break;
                  }

                case "group-off":
                case "group-min2":
                case "group-auto":
                case "group-on-aligned":
                case "group-thousands":
                  this.assertEmpty("group"), i.group = e;
                  break;

                case "latin":
                  this.assertEmpty("numberingSystem"), i.numberingSystem = "latn";
                  break;

                case "numbering-system":
                  -1 !== ["arab", "arabext", "bali", "beng", "deva", "fullwide", "gujr", "guru", "hanidec", "khmr", "knda", "laoo", "latn", "limb", "mlym", "mong", "mymr", "orya", "tamldec", "telu", "thai", "tibt"].indexOf(n) ? (this.assertEmpty("numberingSystem"), i.numberingSystem = n) : this.badOption(e, n);
                  break;

                case "sign-auto":
                case "sign-always":
                case "sign-never":
                case "sign-accounting":
                case "sign-accounting-always":
                case "sign-except-zero":
                case "sign-accounting-except-zero":
                  this.assertEmpty("sign"), i.sign = e;
                  break;

                case "decimal-auto":
                case "decimal-always":
                  this.assertEmpty("decimal"), i.decimal = e;
                  break;

                default:
                  {
                    var _n10 = function (e, a, n) {
                      var i = H(e, "fraction");

                      if (i) {
                        a.length > 1 && n(new C(e, a, 1));
                        var _t10 = {
                          style: "precision-fraction",
                          source: e,
                          minFraction: i.min
                        };
                        null != i.max && (_t10.maxFraction = i.max);

                        var _s5 = a[0],
                            _o3 = H(_s5, "significant");

                        return _o3 ? (_t10.source = "".concat(e, "/").concat(_s5), _t10.minSignificant = _o3.min, null != _o3.max && (_t10.maxSignificant = _o3.max)) : _s5 && n(new _(e, _s5)), _t10;
                      }

                      var t = H(e, "significant");

                      if (t) {
                        var _iterator6 = _createForOfIteratorHelper(a),
                            _step6;

                        try {
                          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                            var _i13 = _step6.value;
                            n(new _(e, _i13));
                          }
                        } catch (err) {
                          _iterator6.e(err);
                        } finally {
                          _iterator6.f();
                        }

                        var _i12 = {
                          style: "precision-fraction",
                          source: e,
                          minSignificant: t.min
                        };
                        return null != t.max && (_i12.maxSignificant = t.max), _i12;
                      }

                      return null;
                    }(e, a, this.onError);

                    _n10 ? (this.assertEmpty("precision"), i.precision = _n10) : this.onError(new S(e));
                  }
              }
            }
          }]);

          return W;
        }();

        function J(e) {
          var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (e) {
            throw e;
          };
          var n = [];

          var _iterator7 = _createForOfIteratorHelper(e.split(" ")),
              _step7;

          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var _a9 = _step7.value;

              if (_a9) {
                var _e9 = _a9.split("/"),
                    _i15 = _e9.shift() || "";

                n.push({
                  stem: _i15,
                  options: _e9
                });
              }
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }

          var i = new W(a);

          for (var _i14 = 0, _n11 = n; _i14 < _n11.length; _i14++) {
            var _n11$_i = _n11[_i14],
                _e8 = _n11$_i.stem,
                _a8 = _n11$_i.options;
            i.parseToken(_e8, _a8);
          }

          return i.skeleton;
        }

        var G = new RegExp("^" + ["ar", "ckb", "fa", "he", "ks($|[^bfh])", "lrc", "mzn", "pa-Arab", "ps", "ug", "ur", "uz-Arab", "yi"].join("|^")),
            K = "@messageformat/runtime/lib/plurals";

        function V(e) {
          return e in p;
        }

        e.exports = /*#__PURE__*/function () {
          function _class(e) {
            _classCallCheck(this, _class);

            this.arguments = [], this.runtime = {}, this.options = e;
          }

          _createClass(_class, [{
            key: "compile",
            value: function compile(e, a, n) {
              var _this10 = this;

              if ("object" == typeof e) {
                var _i16 = {};

                for (var _i17 = 0, _Object$keys = Object.keys(e); _i17 < _Object$keys.length; _i17++) {
                  var _t11 = _Object$keys[_i17];

                  var _s6 = n && n[_t11] || a;

                  _i16[_t11] = this.compile(e[_t11], _s6, n);
                }

                return _i16;
              }

              this.plural = a;
              var t = {
                cardinal: a.cardinals,
                ordinal: a.ordinals,
                strict: this.options.strict
              };
              this.arguments = [];
              var s = i.parse(e, t).map(function (e) {
                return _this10.token(e, null);
              }),
                  o = this.arguments.length > 0,
                  r = this.concatenate(s, !0);
              return this.options.requireAllArguments && o ? (this.setRuntimeFn("reqArgs"), "(d) => { reqArgs(".concat(JSON.stringify(this.arguments), ", d); return ").concat(r, "; }")) : "(".concat(o ? "d" : "", ") => ").concat(r);
            }
          }, {
            key: "cases",
            value: function cases(e, a) {
              var _this11 = this;

              var n = !0;
              var i = e.cases.map(function (_ref4) {
                var e = _ref4.key,
                    i = _ref4.tokens;
                "other" === e && (n = !1);
                var t = i.map(function (e) {
                  return _this11.token(e, a);
                });
                return "".concat(o.property(null, e.replace(/^=/, "")), ": ").concat(_this11.concatenate(t, !1));
              });

              if (n) {
                var _a10 = e.type,
                    _this$plural = this.plural,
                    _n12 = _this$plural.cardinals,
                    _i18 = _this$plural.ordinals;
                if ("select" === _a10 || "plural" === _a10 && _n12.includes("other") || "selectordinal" === _a10 && _i18.includes("other")) throw new Error("No 'other' form found in ".concat(JSON.stringify(e)));
              }

              return "{ ".concat(i.join(", "), " }");
            }
          }, {
            key: "concatenate",
            value: function concatenate(e, a) {
              return "values" === this.options.returnType && (a || e.length > 1) ? "[" + e.join(", ") + "]" : e.join(" + ") || '""';
            }
          }, {
            key: "token",
            value: function token(e, a) {
              if ("content" === e.type) return JSON.stringify(e.value);
              var _this$plural2 = this.plural,
                  n = _this$plural2.id,
                  i = _this$plural2.lc;
              var t, s;

              switch ("arg" in e ? (this.arguments.push(e.arg), t = [o.property("d", e.arg)]) : t = [], e.type) {
                case "argument":
                  return this.options.biDiSupport ? function (e, a) {
                    var n = G.test(a),
                        i = JSON.stringify(n ? "‏" : "‎");
                    return "".concat(i, " + ").concat(e, " + ").concat(i);
                  }(String(t[0]), i) : String(t[0]);

                case "select":
                  s = "select", a && this.options.strict && (a = null), t.push(this.cases(e, a)), this.setRuntimeFn("select");
                  break;

                case "selectordinal":
                  s = "plural", t.push(e.pluralOffset || 0, n, this.cases(e, e), 1), this.setLocale(n, !0), this.setRuntimeFn("plural");
                  break;

                case "plural":
                  s = "plural", t.push(e.pluralOffset || 0, n, this.cases(e, e)), this.setLocale(n, !1), this.setRuntimeFn("plural");
                  break;

                case "function":
                  if (!this.options.customFormatters[e.key]) {
                    if ("date" === e.key) {
                      s = this.setDateFormatter(e, t, a);
                      break;
                    }

                    if ("number" === e.key) {
                      s = this.setNumberFormatter(e, t, a);
                      break;
                    }
                  }

                  if (t.push(JSON.stringify(this.plural.locale)), e.param) {
                    a && this.options.strict && (a = null);

                    var _n13 = this.getFormatterArg(e, a);

                    _n13 && t.push(_n13);
                  }

                  s = e.key, this.setFormatter(s);
                  break;

                case "octothorpe":
                  if (!a) return '"#"';
                  t = [JSON.stringify(this.plural.locale), o.property("d", a.arg), a.pluralOffset || 0], this.options.strict ? (s = "strictNumber", t.push(JSON.stringify(a.arg)), this.setRuntimeFn("strictNumber")) : (s = "number", this.setRuntimeFn("number"));
              }

              if (!s) throw new Error("Parser error for token " + JSON.stringify(e));
              return "".concat(s, "(").concat(t.join(", "), ")");
            }
          }, {
            key: "runtimeIncludes",
            value: function runtimeIncludes(e, a) {
              if (o.identifier(e) !== e) throw new SyntaxError("Reserved word used as ".concat(a, " identifier: ").concat(e));
              var n = this.runtime[e];
              if (!n || n.type === a) return n;
              throw new TypeError("Cannot override ".concat(n.type, " runtime function as ").concat(a, ": ").concat(e));
            }
          }, {
            key: "setLocale",
            value: function setLocale(e, a) {
              var n = this.runtimeIncludes(e, "locale"),
                  _this$plural3 = this.plural,
                  i = _this$plural3.getCardinal,
                  t = _this$plural3.getPlural,
                  s = _this$plural3.isDefault;
              var o, r, c;

              if (!a && s && i) {
                if (n) return;
                o = function o(e) {
                  return i(e);
                }, r = "@messageformat/runtime/lib/cardinals", c = function c() {
                  return String(i);
                };
              } else {
                if (n && (!s || n.module === K)) return;
                o = function o(e, a) {
                  return t(e, a);
                }, r = s ? K : t.module || null, c = function c() {
                  return String(t);
                };
              }

              this.runtime[e] = Object.assign(o, {
                id: e,
                module: r,
                toString: c,
                type: "locale"
              });
            }
          }, {
            key: "setRuntimeFn",
            value: function setRuntimeFn(e) {
              this.runtimeIncludes(e, "runtime") || (this.runtime[e] = Object.assign(c[e], {
                id: e,
                module: "@messageformat/runtime",
                type: "runtime"
              }));
            }
          }, {
            key: "getFormatterArg",
            value: function getFormatterArg(_ref5, n) {
              var _this12 = this;

              var e = _ref5.key,
                  a = _ref5.param;
              var i = this.options.customFormatters[e] || V(e) && p[e];
              if (!i || !a) return null;
              var t = "arg" in i && i.arg || "string";

              if ("options" === t) {
                var _n14 = "";

                var _iterator8 = _createForOfIteratorHelper(a),
                    _step8;

                try {
                  for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                    var _i20 = _step8.value;
                    if ("content" !== _i20.type) throw new SyntaxError("Expected literal options for ".concat(e, " formatter"));
                    _n14 += _i20.value;
                  }
                } catch (err) {
                  _iterator8.e(err);
                } finally {
                  _iterator8.f();
                }

                var _i19 = {};

                var _iterator9 = _createForOfIteratorHelper(_n14.split(",")),
                    _step9;

                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    var _e10 = _step9.value;

                    var _a11 = _e10.indexOf(":");

                    if (-1 === _a11) _i19[_e10.trim()] = null;else {
                      var _n15 = _e10.substring(0, _a11).trim(),
                          _t12 = _e10.substring(_a11 + 1).trim();

                      if ("true" === _t12) _i19[_n15] = !0;else if ("false" === _t12) _i19[_n15] = !1;else if ("null" === _t12) _i19[_n15] = null;else {
                        var _e11 = Number(_t12);

                        _i19[_n15] = Number.isFinite(_e11) ? _e11 : _t12;
                      }
                    }
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }

                return JSON.stringify(_i19);
              }

              {
                var _e12 = a.map(function (e) {
                  return _this12.token(e, n);
                });

                if ("raw" === t) return "[".concat(_e12.join(", "), "]");

                var _i21 = _e12.join(" + ");

                return _i21 ? "(".concat(_i21, ").trim()") : '""';
              }
            }
          }, {
            key: "setFormatter",
            value: function setFormatter(e) {
              if (this.runtimeIncludes(e, "formatter")) return;
              var a = this.options.customFormatters[e];
              if (a) "function" == typeof a && (a = {
                formatter: a
              }), this.runtime[e] = Object.assign(a.formatter, {
                type: "formatter"
              }, "module" in a && a.module && a.id ? {
                id: o.identifier(a.id),
                module: a.module
              } : {
                id: null,
                module: null
              });else {
                if (!V(e)) throw new Error("Formatting function not found: ".concat(e));
                this.runtime[e] = Object.assign(p[e], {
                  type: "formatter"
                }, {
                  id: e,
                  module: "@messageformat/runtime/lib/formatters"
                });
              }
            }
          }, {
            key: "setDateFormatter",
            value: function setDateFormatter(_ref6, a, n) {
              var _this13 = this;

              var e = _ref6.param;
              var i = this.plural.locale,
                  t = e && 1 === e.length && e[0];

              if (t && "content" === t.type && /^\s*::/.test(t.value)) {
                var _e13 = t.value.trim().substr(2),
                    _a12 = o.identifier("date_".concat(i, "_").concat(_e13), !0);

                if (!this.runtimeIncludes(_a12, "formatter")) {
                  var _n16 = function (e, a, n) {
                    "string" == typeof a && (a = k(a));
                    var i = g(a, void 0),
                        t = new Intl.DateTimeFormat(e, i);
                    return function (e) {
                      return t.format(e);
                    };
                  }(i, _e13);

                  this.runtime[_a12] = Object.assign(_n16, {
                    id: _a12,
                    module: null,
                    toString: function toString() {
                      return function (e, a, n) {
                        "string" == typeof a && (a = k(a));
                        var i = g(a, void 0);
                        return ["(function() {", "var opt = ".concat(JSON.stringify(i), ";"), "var dtf = new Intl.DateTimeFormat(".concat(JSON.stringify(e), ", opt);"), "return function(value) { return dtf.format(value); }"].join("\n  ") + "\n})()";
                      }(i, _e13);
                    },
                    type: "formatter"
                  });
                }

                return _a12;
              }

              if (a.push(JSON.stringify(i)), e && e.length > 0) {
                n && this.options.strict && (n = null);

                var _i22 = e.map(function (e) {
                  return _this13.token(e, n);
                });

                a.push("(" + (_i22.join(" + ") || '""') + ").trim()");
              }

              return this.setFormatter("date"), "date";
            }
          }, {
            key: "setNumberFormatter",
            value: function setNumberFormatter(_ref7, a, n) {
              var _this14 = this;

              var e = _ref7.param;
              var i = this.plural.locale;
              if (!e || 0 === e.length) return a.unshift(JSON.stringify(i)), a.push("0"), this.setRuntimeFn("number"), "number";

              if (a.push(JSON.stringify(i)), 1 === e.length && "content" === e[0].type) {
                var _n17 = e[0].value.trim();

                switch (_n17) {
                  case "currency":
                    return a.push(JSON.stringify(this.options.currency)), this.setFormatter("numberCurrency"), "numberCurrency";

                  case "integer":
                    return this.setFormatter("numberInteger"), "numberInteger";

                  case "percent":
                    return this.setFormatter("numberPercent"), "numberPercent";
                }

                var _t13 = _n17.match(/^currency:([A-Z]+)$/);

                if (_t13) return a.push(JSON.stringify(_t13[1])), this.setFormatter("numberCurrency"), "numberCurrency";

                var _s7 = o.identifier("number_".concat(i, "_").concat(_n17), !0);

                if (!this.runtimeIncludes(_s7, "formatter")) {
                  var _e14 = this.options.currency,
                      _a13 = function (e, a, n, i) {
                    "string" == typeof a && (a = 0 === a.indexOf("::") ? J(a.slice(2), i) : $(a, n, i));

                    var t = N(e, a),
                        s = A(a, i),
                        o = function (e) {
                      var a = R(e),
                          n = e.precision;
                      return n && "precision-increment" === n.style ? function (e) {
                        return function (e, a) {
                          var n = +e + a / 2;
                          return n - n % +a;
                        }(e, n.increment) * a;
                      } : function (e) {
                        return e * a;
                      };
                    }(a),
                        r = new Intl.NumberFormat(t, s);

                    if (a.affix) {
                      var _a$affix$pos = _slicedToArray(a.affix.pos, 2),
                          _e15 = _a$affix$pos[0],
                          _n18 = _a$affix$pos[1],
                          _ref8 = a.affix.neg || ["", ""],
                          _ref9 = _slicedToArray(_ref8, 2),
                          _i23 = _ref9[0],
                          _t14 = _ref9[1];

                      return function (a) {
                        var s = r.format(o(a));
                        return a < 0 ? "".concat(_i23).concat(s).concat(_t14) : "".concat(_e15).concat(s).concat(_n18);
                      };
                    }

                    return function (e) {
                      return r.format(o(e));
                    };
                  }(i, _n17, _e14);

                  this.runtime[_s7] = Object.assign(_a13, {
                    id: null,
                    module: null,
                    toString: function toString() {
                      return function (e, a, n, i) {
                        "string" == typeof a && (a = 0 === a.indexOf("::") ? J(a.slice(2), i) : $(a, n, i));

                        var t = N(e, a),
                            s = A(a, i),
                            o = function (e) {
                          var a = R(e),
                              n = e.precision;

                          if (n && "precision-increment" === n.style) {
                            var _e16 = "+n + " + n.increment / 2;

                            var _i24 = "x - (x % +".concat(n.increment, ")");

                            return 1 !== a && (_i24 = "(".concat(_i24, ") * ").concat(a)), "function(n) { var x = ".concat(_e16, "; return ").concat(_i24, "; }");
                          }

                          return 1 !== a ? "function(n) { return n * ".concat(a, "; }") : null;
                        }(a),
                            r = ["(function() {", "var opt = ".concat(JSON.stringify(s), ";"), "var nf = new Intl.NumberFormat(".concat(JSON.stringify(t), ", opt);")];

                        var c = "nf.format(value)";

                        if (o && (r.push("var mod = ".concat(o, ";")), c = "nf.format(mod(value))"), a.affix) {
                          var _a$affix$pos$map = a.affix.pos.map(function (e) {
                            return JSON.stringify(e);
                          }),
                              _a$affix$pos$map2 = _slicedToArray(_a$affix$pos$map, 2),
                              _e17 = _a$affix$pos$map2[0],
                              _n19 = _a$affix$pos$map2[1];

                          if (a.affix.neg) {
                            var _a$affix$neg$map = a.affix.neg.map(function (e) {
                              return JSON.stringify(e);
                            }),
                                _a$affix$neg$map2 = _slicedToArray(_a$affix$neg$map, 2),
                                _i25 = _a$affix$neg$map2[0],
                                _t15 = _a$affix$neg$map2[1];

                            c = "value < 0 ? ".concat(_i25, " + ").concat(c, " + ").concat(_t15, " : ").concat(_e17, " + ").concat(c, " + ").concat(_n19);
                          } else c = "".concat(_e17, " + ").concat(c, " + ").concat(_n19);
                        }

                        return r.push("return function(value) { return ".concat(c, "; }")), r.join("\n  ") + "\n})()";
                      }(i, _n17, _e14);
                    },
                    type: "formatter"
                  });
                }

                return _s7;
              }

              n && this.options.strict && (n = null);
              var t = e.map(function (e) {
                return _this14.token(e, n);
              });
              return a.push("(" + (t.join(" + ") || '""') + ").trim()"), a.push(JSON.stringify(this.options.currency)), this.setFormatter("numberFmt"), "numberFmt";
            }
          }]);

          return _class;
        }();
      },
      5150: function _(e, a, n) {
        "use strict";

        var i = n(9182),
            t = n(7867),
            s = n(985),
            o = n(3585),
            r = n(4534);

        function c(e) {
          return e && "object" == typeof e && "default" in e ? e : {
            default: e
          };
        }

        function p(e) {
          if (e && e.__esModule) return e;
          var a = Object.create(null);
          return e && Object.keys(e).forEach(function (n) {
            if ("default" !== n) {
              var i = Object.getOwnPropertyDescriptor(e, n);
              Object.defineProperty(a, n, i.get ? i : {
                enumerable: !0,
                get: function get() {
                  return e[n];
                }
              });
            }
          }), a.default = e, Object.freeze(a);
        }

        var l = c(i),
            u = p(t),
            m = p(s),
            d = p(o);

        function f(e) {
          if ("string" != typeof e || e.length < 2) throw new RangeError("Invalid language tag: ".concat(e));
          if (e.startsWith("pt-PT")) return "pt-PT";
          var a = e.match(/.+?(?=[-_])/);
          return a ? a[0] : e;
        }

        function h(e) {
          if ("function" == typeof e) {
            var _a14 = f(e.name);

            return {
              isDefault: !1,
              id: r.identifier(_a14),
              lc: _a14,
              locale: e.name,
              getPlural: e,
              cardinals: e.cardinals || [],
              ordinals: e.ordinals || []
            };
          }

          var a = f(e),
              n = r.identifier(a);
          return function (e) {
            return e in d;
          }(n) ? {
            isDefault: !0,
            id: n,
            lc: a,
            locale: e,
            getCardinal: u[n],
            getPlural: d[n],
            cardinals: m[n].cardinal,
            ordinals: m[n].ordinal
          } : null;
        }

        function x(e) {
          var a = f(e);
          return r.identifier(a) in d;
        }

        var v = /*#__PURE__*/function () {
          function v(e, a) {
            _classCallCheck(this, v);

            if (this.plurals = [], this.options = Object.assign({
              biDiSupport: !1,
              currency: "USD",
              customFormatters: {},
              requireAllArguments: !1,
              returnType: "string",
              strict: a && a.strictNumberSign || !1
            }, a), "*" === e) this.plurals = function (e) {
              var a = Object.keys(d).filter(function (a) {
                return a !== e;
              });
              return a.unshift(e), a.map(h);
            }(v.defaultLocale);else if (Array.isArray(e)) this.plurals = e.map(h).filter(Boolean);else if (e) {
              var _a15 = h(e);

              _a15 && (this.plurals = [_a15]);
            }

            if (0 === this.plurals.length) {
              var _e18 = h(v.defaultLocale);

              this.plurals = [_e18];
            }
          }

          _createClass(v, [{
            key: "resolvedOptions",
            value: function resolvedOptions() {
              return Object.assign(Object.assign({}, this.options), {
                locale: this.plurals[0].locale,
                plurals: this.plurals
              });
            }
          }, {
            key: "compile",
            value: function compile(e) {
              var a = new l.default(this.options),
                  n = "return " + a.compile(e, this.plurals[0]),
                  i = [],
                  t = [];

              for (var _i26 = 0, _Object$entries = Object.entries(a.runtime); _i26 < _Object$entries.length; _i26++) {
                var _Object$entries$_i = _slicedToArray(_Object$entries[_i26], 2),
                    _e19 = _Object$entries$_i[0],
                    _n20 = _Object$entries$_i[1];

                i.push(_e19), t.push(_n20);
              }

              return _construct(Function, i.concat([n])).apply(void 0, t);
            }
          }], [{
            key: "escape",
            value: function escape(e, a) {
              var n = a ? /[#{}]/g : /[{}]/g;
              return String(e).replace(n, "'$&'");
            }
          }, {
            key: "supportedLocalesOf",
            value: function supportedLocalesOf(e) {
              return (Array.isArray(e) ? e : [e]).filter(x);
            }
          }]);

          return v;
        }();

        v.defaultLocale = "en", e.exports = v;
      },
      9118: function _(e, a, n) {
        e.exports = {
          parallel: n(9162),
          serial: n(1357),
          serialOrdered: n(9087)
        };
      },
      7651: function _(e) {
        function a(e) {
          "function" == typeof this.jobs[e] && this.jobs[e]();
        }

        e.exports = function (e) {
          Object.keys(e.jobs).forEach(a.bind(e)), e.jobs = {};
        };
      },
      5912: function _(e, a, n) {
        var i = n(9265);

        e.exports = function (e) {
          var a = !1;
          return i(function () {
            a = !0;
          }), function (n, t) {
            a ? e(n, t) : i(function () {
              e(n, t);
            });
          };
        };
      },
      9265: function _(e) {
        e.exports = function (e) {
          var a = "function" == typeof setImmediate ? setImmediate : "object" == typeof process && "function" == typeof process.nextTick ? process.nextTick : null;
          a ? a(e) : setTimeout(e, 0);
        };
      },
      7594: function _(e, a, n) {
        var i = n(5912),
            t = n(7651);

        e.exports = function (e, a, n, s) {
          var o = n.keyedList ? n.keyedList[n.index] : n.index;

          n.jobs[o] = function (e, a, n, t) {
            return 2 == e.length ? e(n, i(t)) : e(n, a, i(t));
          }(a, o, e[o], function (e, a) {
            o in n.jobs && (delete n.jobs[o], e ? t(n) : n.results[o] = a, s(e, n.results));
          });
        };
      },
      4528: function _(e) {
        e.exports = function (e, a) {
          var n = !Array.isArray(e),
              i = {
            index: 0,
            keyedList: n || a ? Object.keys(e) : null,
            jobs: {},
            results: n ? {} : [],
            size: n ? Object.keys(e).length : e.length
          };
          return a && i.keyedList.sort(n ? a : function (n, i) {
            return a(e[n], e[i]);
          }), i;
        };
      },
      5353: function _(e, a, n) {
        var i = n(7651),
            t = n(5912);

        e.exports = function (e) {
          Object.keys(this.jobs).length && (this.index = this.size, i(this), t(e)(null, this.results));
        };
      },
      9162: function _(e, a, n) {
        var i = n(7594),
            t = n(4528),
            s = n(5353);

        e.exports = function (e, a, n) {
          for (var o = t(e); o.index < (o.keyedList || e).length;) {
            i(e, a, o, function (e, a) {
              e ? n(e, a) : 0 !== Object.keys(o.jobs).length || n(null, o.results);
            }), o.index++;
          }

          return s.bind(o, n);
        };
      },
      1357: function _(e, a, n) {
        var i = n(9087);

        e.exports = function (e, a, n) {
          return i(e, a, null, n);
        };
      },
      9087: function _(e, a, n) {
        var i = n(7594),
            t = n(4528),
            s = n(5353);

        function o(e, a) {
          return e < a ? -1 : e > a ? 1 : 0;
        }

        e.exports = function (e, a, n, o) {
          var r = t(e, n);
          return i(e, a, r, function n(t, s) {
            t ? o(t, s) : (r.index++, r.index < (r.keyedList || e).length ? i(e, a, r, n) : o(null, r.results));
          }), s.bind(r, o);
        }, e.exports.ascending = o, e.exports.descending = function (e, a) {
          return -1 * o(e, a);
        };
      },
      9669: function _(e, a, n) {
        e.exports = n(1609);
      },
      7970: function _(e, a, n) {
        "use strict";

        var i = n(4867),
            t = n(6026),
            s = n(4097),
            o = n(5327),
            r = n(3685),
            c = n(5687),
            p = n(938).http,
            l = n(938).https,
            u = n(7310),
            m = n(9796),
            d = n(7288).version,
            f = n(7874),
            h = n(2648),
            x = n(644),
            v = /https:?/,
            g = ["http:", "https:", "file:"];

        function b(e, a, n) {
          if (e.hostname = a.host, e.host = a.host, e.port = a.port, e.path = n, a.auth) {
            var i = Buffer.from(a.auth.username + ":" + a.auth.password, "utf8").toString("base64");
            e.headers["Proxy-Authorization"] = "Basic " + i;
          }

          e.beforeRedirect = function (e) {
            e.headers.host = e.host, b(e, a, e.href);
          };
        }

        e.exports = function (e) {
          return new Promise(function (a, n) {
            var y;

            function w() {
              e.cancelToken && e.cancelToken.unsubscribe(y), e.signal && e.signal.removeEventListener("abort", y);
            }

            var k = function k(e) {
              w(), a(e);
            },
                j = !1,
                _ = function _(e) {
              w(), j = !0, n(e);
            },
                S = e.data,
                E = e.headers,
                O = {};

            if (Object.keys(E).forEach(function (e) {
              O[e.toLowerCase()] = e;
            }), "user-agent" in O ? E[O["user-agent"]] || delete E[O["user-agent"]] : E["User-Agent"] = "axios/" + d, i.isFormData(S) && i.isFunction(S.getHeaders)) Object.assign(E, S.getHeaders());else if (S && !i.isStream(S)) {
              if (Buffer.isBuffer(S)) ;else if (i.isArrayBuffer(S)) S = Buffer.from(new Uint8Array(S));else {
                if (!i.isString(S)) return _(new h("Data after transformation must be a string, an ArrayBuffer, a Buffer, or a Stream", h.ERR_BAD_REQUEST, e));
                S = Buffer.from(S, "utf-8");
              }
              if (e.maxBodyLength > -1 && S.length > e.maxBodyLength) return _(new h("Request body larger than maxBodyLength limit", h.ERR_BAD_REQUEST, e));
              O["content-length"] || (E["Content-Length"] = S.length);
            }
            var T = void 0;
            e.auth && (T = (e.auth.username || "") + ":" + (e.auth.password || ""));
            var C = s(e.baseURL, e.url),
                z = u.parse(C),
                N = z.protocol || g[0];
            if (-1 === g.indexOf(N)) return _(new h("Unsupported protocol " + N, h.ERR_BAD_REQUEST, e));

            if (!T && z.auth) {
              var R = z.auth.split(":");
              T = (R[0] || "") + ":" + (R[1] || "");
            }

            T && O.authorization && delete E[O.authorization];
            var A = v.test(N),
                F = A ? e.httpsAgent : e.httpAgent;

            try {
              o(z.path, e.params, e.paramsSerializer).replace(/^\?/, "");
            } catch (a) {
              var q = new Error(a.message);
              q.config = e, q.url = e.url, q.exists = !0, _(q);
            }

            var L = {
              path: o(z.path, e.params, e.paramsSerializer).replace(/^\?/, ""),
              method: e.method.toUpperCase(),
              headers: E,
              agent: F,
              agents: {
                http: e.httpAgent,
                https: e.httpsAgent
              },
              auth: T
            };
            e.socketPath ? L.socketPath = e.socketPath : (L.hostname = z.hostname, L.port = z.port);
            var B,
                P = e.proxy;

            if (!P && !1 !== P) {
              var D = N.slice(0, -1) + "_proxy",
                  $ = process.env[D] || process.env[D.toUpperCase()];

              if ($) {
                var I = u.parse($),
                    U = process.env.no_proxy || process.env.NO_PROXY,
                    M = !0;

                if (U && (M = !U.split(",").map(function (e) {
                  return e.trim();
                }).some(function (e) {
                  return !!e && ("*" === e || "." === e[0] && z.hostname.substr(z.hostname.length - e.length) === e || z.hostname === e);
                })), M && (P = {
                  host: I.hostname,
                  port: I.port,
                  protocol: I.protocol
                }, I.auth)) {
                  var H = I.auth.split(":");
                  P.auth = {
                    username: H[0],
                    password: H[1]
                  };
                }
              }
            }

            P && (L.headers.host = z.hostname + (z.port ? ":" + z.port : ""), b(L, P, N + "//" + z.hostname + (z.port ? ":" + z.port : "") + L.path));
            var W = A && (!P || v.test(P.protocol));
            e.transport ? B = e.transport : 0 === e.maxRedirects ? B = W ? c : r : (e.maxRedirects && (L.maxRedirects = e.maxRedirects), e.beforeRedirect && (L.beforeRedirect = e.beforeRedirect), B = W ? l : p), e.maxBodyLength > -1 && (L.maxBodyLength = e.maxBodyLength), e.insecureHTTPParser && (L.insecureHTTPParser = e.insecureHTTPParser);
            var J = B.request(L, function (a) {
              if (!J.aborted) {
                var n = a,
                    s = a.req || J;
                if (204 !== a.statusCode && "HEAD" !== s.method && !1 !== e.decompress) switch (a.headers["content-encoding"]) {
                  case "gzip":
                  case "compress":
                  case "deflate":
                    n = n.pipe(m.createUnzip()), delete a.headers["content-encoding"];
                }
                var o = {
                  status: a.statusCode,
                  statusText: a.statusMessage,
                  headers: a.headers,
                  config: e,
                  request: s
                };
                if ("stream" === e.responseType) o.data = n, t(k, _, o);else {
                  var r = [],
                      c = 0;
                  n.on("data", function (a) {
                    r.push(a), c += a.length, e.maxContentLength > -1 && c > e.maxContentLength && (j = !0, n.destroy(), _(new h("maxContentLength size of " + e.maxContentLength + " exceeded", h.ERR_BAD_RESPONSE, e, s)));
                  }), n.on("aborted", function () {
                    j || (n.destroy(), _(new h("maxContentLength size of " + e.maxContentLength + " exceeded", h.ERR_BAD_RESPONSE, e, s)));
                  }), n.on("error", function (a) {
                    J.aborted || _(h.from(a, null, e, s));
                  }), n.on("end", function () {
                    try {
                      var a = 1 === r.length ? r[0] : Buffer.concat(r);
                      "arraybuffer" !== e.responseType && (a = a.toString(e.responseEncoding), e.responseEncoding && "utf8" !== e.responseEncoding || (a = i.stripBOM(a))), o.data = a;
                    } catch (a) {
                      _(h.from(a, null, e, o.request, o));
                    }

                    t(k, _, o);
                  });
                }
              }
            });

            if (J.on("error", function (a) {
              _(h.from(a, null, e, J));
            }), J.on("socket", function (e) {
              e.setKeepAlive(!0, 6e4);
            }), e.timeout) {
              var G = parseInt(e.timeout, 10);
              if (isNaN(G)) return void _(new h("error trying to parse `config.timeout` to int", h.ERR_BAD_OPTION_VALUE, e, J));
              J.setTimeout(G, function () {
                J.abort();
                var a = e.transitional || f;

                _(new h("timeout of " + G + "ms exceeded", a.clarifyTimeoutError ? h.ETIMEDOUT : h.ECONNABORTED, e, J));
              });
            }

            (e.cancelToken || e.signal) && (y = function y(e) {
              J.aborted || (J.abort(), _(!e || e && e.type ? new x() : e));
            }, e.cancelToken && e.cancelToken.subscribe(y), e.signal && (e.signal.aborted ? y() : e.signal.addEventListener("abort", y))), i.isStream(S) ? S.on("error", function (a) {
              _(h.from(a, e, null, J));
            }).pipe(J) : J.end(S);
          });
        };
      },
      5448: function _(e, a, n) {
        "use strict";

        var i = n(4867),
            t = n(6026),
            s = n(4372),
            o = n(5327),
            r = n(4097),
            c = n(4109),
            p = n(7985),
            l = n(7874),
            u = n(2648),
            m = n(644),
            d = n(205);

        e.exports = function (e) {
          return new Promise(function (a, n) {
            var f,
                h = e.data,
                x = e.headers,
                v = e.responseType;

            function g() {
              e.cancelToken && e.cancelToken.unsubscribe(f), e.signal && e.signal.removeEventListener("abort", f);
            }

            i.isFormData(h) && i.isStandardBrowserEnv() && delete x["Content-Type"];
            var b = new XMLHttpRequest();

            if (e.auth) {
              var y = e.auth.username || "",
                  w = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
              x.Authorization = "Basic " + btoa(y + ":" + w);
            }

            var k = r(e.baseURL, e.url);

            function j() {
              if (b) {
                var i = "getAllResponseHeaders" in b ? c(b.getAllResponseHeaders()) : null,
                    s = {
                  data: v && "text" !== v && "json" !== v ? b.response : b.responseText,
                  status: b.status,
                  statusText: b.statusText,
                  headers: i,
                  config: e,
                  request: b
                };
                t(function (e) {
                  a(e), g();
                }, function (e) {
                  n(e), g();
                }, s), b = null;
              }
            }

            if (b.open(e.method.toUpperCase(), o(k, e.params, e.paramsSerializer), !0), b.timeout = e.timeout, "onloadend" in b ? b.onloadend = j : b.onreadystatechange = function () {
              b && 4 === b.readyState && (0 !== b.status || b.responseURL && 0 === b.responseURL.indexOf("file:")) && setTimeout(j);
            }, b.onabort = function () {
              b && (n(new u("Request aborted", u.ECONNABORTED, e, b)), b = null);
            }, b.onerror = function () {
              n(new u("Network Error", u.ERR_NETWORK, e, b, b)), b = null;
            }, b.ontimeout = function () {
              var a = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded",
                  i = e.transitional || l;
              e.timeoutErrorMessage && (a = e.timeoutErrorMessage), n(new u(a, i.clarifyTimeoutError ? u.ETIMEDOUT : u.ECONNABORTED, e, b)), b = null;
            }, i.isStandardBrowserEnv()) {
              var _ = (e.withCredentials || p(k)) && e.xsrfCookieName ? s.read(e.xsrfCookieName) : void 0;

              _ && (x[e.xsrfHeaderName] = _);
            }

            "setRequestHeader" in b && i.forEach(x, function (e, a) {
              void 0 === h && "content-type" === a.toLowerCase() ? delete x[a] : b.setRequestHeader(a, e);
            }), i.isUndefined(e.withCredentials) || (b.withCredentials = !!e.withCredentials), v && "json" !== v && (b.responseType = e.responseType), "function" == typeof e.onDownloadProgress && b.addEventListener("progress", e.onDownloadProgress), "function" == typeof e.onUploadProgress && b.upload && b.upload.addEventListener("progress", e.onUploadProgress), (e.cancelToken || e.signal) && (f = function f(e) {
              b && (n(!e || e && e.type ? new m() : e), b.abort(), b = null);
            }, e.cancelToken && e.cancelToken.subscribe(f), e.signal && (e.signal.aborted ? f() : e.signal.addEventListener("abort", f))), h || (h = null);
            var S = d(k);
            S && -1 === ["http", "https", "file"].indexOf(S) ? n(new u("Unsupported protocol " + S + ":", u.ERR_BAD_REQUEST, e)) : b.send(h);
          });
        };
      },
      1609: function _(e, a, n) {
        "use strict";

        var i = n(4867),
            t = n(1849),
            s = n(321),
            o = n(7185),
            r = function e(a) {
          var n = new s(a),
              r = t(s.prototype.request, n);
          return i.extend(r, s.prototype, n), i.extend(r, n), r.create = function (n) {
            return e(o(a, n));
          }, r;
        }(n(5546));

        r.Axios = s, r.CanceledError = n(644), r.CancelToken = n(4972), r.isCancel = n(6502), r.VERSION = n(7288).version, r.toFormData = n(7675), r.AxiosError = n(2648), r.Cancel = r.CanceledError, r.all = function (e) {
          return Promise.all(e);
        }, r.spread = n(8713), r.isAxiosError = n(6268), e.exports = r, e.exports.default = r;
      },
      4972: function _(e, a, n) {
        "use strict";

        var i = n(644);

        function t(e) {
          if ("function" != typeof e) throw new TypeError("executor must be a function.");
          var a;
          this.promise = new Promise(function (e) {
            a = e;
          });
          var n = this;
          this.promise.then(function (e) {
            if (n._listeners) {
              var a,
                  i = n._listeners.length;

              for (a = 0; a < i; a++) {
                n._listeners[a](e);
              }

              n._listeners = null;
            }
          }), this.promise.then = function (e) {
            var a,
                i = new Promise(function (e) {
              n.subscribe(e), a = e;
            }).then(e);
            return i.cancel = function () {
              n.unsubscribe(a);
            }, i;
          }, e(function (e) {
            n.reason || (n.reason = new i(e), a(n.reason));
          });
        }

        t.prototype.throwIfRequested = function () {
          if (this.reason) throw this.reason;
        }, t.prototype.subscribe = function (e) {
          this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : this._listeners = [e];
        }, t.prototype.unsubscribe = function (e) {
          if (this._listeners) {
            var a = this._listeners.indexOf(e);

            -1 !== a && this._listeners.splice(a, 1);
          }
        }, t.source = function () {
          var e;
          return {
            token: new t(function (a) {
              e = a;
            }),
            cancel: e
          };
        }, e.exports = t;
      },
      644: function _(e, a, n) {
        "use strict";

        var i = n(2648);

        function t(e) {
          i.call(this, null == e ? "canceled" : e, i.ERR_CANCELED), this.name = "CanceledError";
        }

        n(4867).inherits(t, i, {
          __CANCEL__: !0
        }), e.exports = t;
      },
      6502: function _(e) {
        "use strict";

        e.exports = function (e) {
          return !(!e || !e.__CANCEL__);
        };
      },
      321: function _(e, a, n) {
        "use strict";

        var i = n(4867),
            t = n(5327),
            s = n(782),
            o = n(3572),
            r = n(7185),
            c = n(4097),
            p = n(4875),
            l = p.validators;

        function u(e) {
          this.defaults = e, this.interceptors = {
            request: new s(),
            response: new s()
          };
        }

        u.prototype.request = function (e, a) {
          "string" == typeof e ? (a = a || {}).url = e : a = e || {}, (a = r(this.defaults, a)).method ? a.method = a.method.toLowerCase() : this.defaults.method ? a.method = this.defaults.method.toLowerCase() : a.method = "get";
          var n = a.transitional;
          void 0 !== n && p.assertOptions(n, {
            silentJSONParsing: l.transitional(l.boolean),
            forcedJSONParsing: l.transitional(l.boolean),
            clarifyTimeoutError: l.transitional(l.boolean)
          }, !1);
          var i = [],
              t = !0;
          this.interceptors.request.forEach(function (e) {
            "function" == typeof e.runWhen && !1 === e.runWhen(a) || (t = t && e.synchronous, i.unshift(e.fulfilled, e.rejected));
          });
          var s,
              c = [];

          if (this.interceptors.response.forEach(function (e) {
            c.push(e.fulfilled, e.rejected);
          }), !t) {
            var u = [o, void 0];

            for (Array.prototype.unshift.apply(u, i), u = u.concat(c), s = Promise.resolve(a); u.length;) {
              s = s.then(u.shift(), u.shift());
            }

            return s;
          }

          for (var m = a; i.length;) {
            var d = i.shift(),
                f = i.shift();

            try {
              m = d(m);
            } catch (e) {
              f(e);
              break;
            }
          }

          try {
            s = o(m);
          } catch (e) {
            return Promise.reject(e);
          }

          for (; c.length;) {
            s = s.then(c.shift(), c.shift());
          }

          return s;
        }, u.prototype.getUri = function (e) {
          e = r(this.defaults, e);
          var a = c(e.baseURL, e.url);
          return t(a, e.params, e.paramsSerializer);
        }, i.forEach(["delete", "get", "head", "options"], function (e) {
          u.prototype[e] = function (a, n) {
            return this.request(r(n || {}, {
              method: e,
              url: a,
              data: (n || {}).data
            }));
          };
        }), i.forEach(["post", "put", "patch"], function (e) {
          function a(a) {
            return function (n, i, t) {
              return this.request(r(t || {}, {
                method: e,
                headers: a ? {
                  "Content-Type": "multipart/form-data"
                } : {},
                url: n,
                data: i
              }));
            };
          }

          u.prototype[e] = a(), u.prototype[e + "Form"] = a(!0);
        }), e.exports = u;
      },
      2648: function _(e, a, n) {
        "use strict";

        var i = n(4867);

        function t(e, a, n, i, t) {
          Error.call(this), this.message = e, this.name = "AxiosError", a && (this.code = a), n && (this.config = n), i && (this.request = i), t && (this.response = t);
        }

        i.inherits(t, Error, {
          toJSON: function toJSON() {
            return {
              message: this.message,
              name: this.name,
              description: this.description,
              number: this.number,
              fileName: this.fileName,
              lineNumber: this.lineNumber,
              columnNumber: this.columnNumber,
              stack: this.stack,
              config: this.config,
              code: this.code,
              status: this.response && this.response.status ? this.response.status : null
            };
          }
        });
        var s = t.prototype,
            o = {};
        ["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED"].forEach(function (e) {
          o[e] = {
            value: e
          };
        }), Object.defineProperties(t, o), Object.defineProperty(s, "isAxiosError", {
          value: !0
        }), t.from = function (e, a, n, o, r, c) {
          var p = Object.create(s);
          return i.toFlatObject(e, p, function (e) {
            return e !== Error.prototype;
          }), t.call(p, e.message, a, n, o, r), p.name = e.name, c && Object.assign(p, c), p;
        }, e.exports = t;
      },
      782: function _(e, a, n) {
        "use strict";

        var i = n(4867);

        function t() {
          this.handlers = [];
        }

        t.prototype.use = function (e, a, n) {
          return this.handlers.push({
            fulfilled: e,
            rejected: a,
            synchronous: !!n && n.synchronous,
            runWhen: n ? n.runWhen : null
          }), this.handlers.length - 1;
        }, t.prototype.eject = function (e) {
          this.handlers[e] && (this.handlers[e] = null);
        }, t.prototype.forEach = function (e) {
          i.forEach(this.handlers, function (a) {
            null !== a && e(a);
          });
        }, e.exports = t;
      },
      4097: function _(e, a, n) {
        "use strict";

        var i = n(1793),
            t = n(7303);

        e.exports = function (e, a) {
          return e && !i(a) ? t(e, a) : a;
        };
      },
      3572: function _(e, a, n) {
        "use strict";

        var i = n(4867),
            t = n(8527),
            s = n(6502),
            o = n(5546),
            r = n(644);

        function c(e) {
          if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new r();
        }

        e.exports = function (e) {
          return c(e), e.headers = e.headers || {}, e.data = t.call(e, e.data, e.headers, e.transformRequest), e.headers = i.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers), i.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (a) {
            delete e.headers[a];
          }), (e.adapter || o.adapter)(e).then(function (a) {
            return c(e), a.data = t.call(e, a.data, a.headers, e.transformResponse), a;
          }, function (a) {
            return s(a) || (c(e), a && a.response && (a.response.data = t.call(e, a.response.data, a.response.headers, e.transformResponse))), Promise.reject(a);
          });
        };
      },
      7185: function _(e, a, n) {
        "use strict";

        var i = n(4867);

        e.exports = function (e, a) {
          a = a || {};
          var n = {};

          function t(e, a) {
            return i.isPlainObject(e) && i.isPlainObject(a) ? i.merge(e, a) : i.isPlainObject(a) ? i.merge({}, a) : i.isArray(a) ? a.slice() : a;
          }

          function s(n) {
            return i.isUndefined(a[n]) ? i.isUndefined(e[n]) ? void 0 : t(void 0, e[n]) : t(e[n], a[n]);
          }

          function o(e) {
            if (!i.isUndefined(a[e])) return t(void 0, a[e]);
          }

          function r(n) {
            return i.isUndefined(a[n]) ? i.isUndefined(e[n]) ? void 0 : t(void 0, e[n]) : t(void 0, a[n]);
          }

          function c(n) {
            return n in a ? t(e[n], a[n]) : n in e ? t(void 0, e[n]) : void 0;
          }

          var p = {
            url: o,
            method: o,
            data: o,
            baseURL: r,
            transformRequest: r,
            transformResponse: r,
            paramsSerializer: r,
            timeout: r,
            timeoutMessage: r,
            withCredentials: r,
            adapter: r,
            responseType: r,
            xsrfCookieName: r,
            xsrfHeaderName: r,
            onUploadProgress: r,
            onDownloadProgress: r,
            decompress: r,
            maxContentLength: r,
            maxBodyLength: r,
            beforeRedirect: r,
            transport: r,
            httpAgent: r,
            httpsAgent: r,
            cancelToken: r,
            socketPath: r,
            responseEncoding: r,
            validateStatus: c
          };
          return i.forEach(Object.keys(e).concat(Object.keys(a)), function (e) {
            var a = p[e] || s,
                t = a(e);
            i.isUndefined(t) && a !== c || (n[e] = t);
          }), n;
        };
      },
      6026: function _(e, a, n) {
        "use strict";

        var i = n(2648);

        e.exports = function (e, a, n) {
          var t = n.config.validateStatus;
          n.status && t && !t(n.status) ? a(new i("Request failed with status code " + n.status, [i.ERR_BAD_REQUEST, i.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n)) : e(n);
        };
      },
      8527: function _(e, a, n) {
        "use strict";

        var i = n(4867),
            t = n(5546);

        e.exports = function (e, a, n) {
          var s = this || t;
          return i.forEach(n, function (n) {
            e = n.call(s, e, a);
          }), e;
        };
      },
      3784: function _(e, a, n) {
        e.exports = n(6882);
      },
      5546: function _(e, a, n) {
        "use strict";

        var i = n(4867),
            t = n(6016),
            s = n(2648),
            o = n(7874),
            r = n(7675),
            c = {
          "Content-Type": "application/x-www-form-urlencoded"
        };

        function p(e, a) {
          !i.isUndefined(e) && i.isUndefined(e["Content-Type"]) && (e["Content-Type"] = a);
        }

        var l,
            u = {
          transitional: o,
          adapter: ("undefined" != typeof XMLHttpRequest ? l = n(5448) : "undefined" != typeof process && "[object process]" === Object.prototype.toString.call(process) && (l = n(7970)), l),
          transformRequest: [function (e, a) {
            if (t(a, "Accept"), t(a, "Content-Type"), i.isFormData(e) || i.isArrayBuffer(e) || i.isBuffer(e) || i.isStream(e) || i.isFile(e) || i.isBlob(e)) return e;
            if (i.isArrayBufferView(e)) return e.buffer;
            if (i.isURLSearchParams(e)) return p(a, "application/x-www-form-urlencoded;charset=utf-8"), e.toString();
            var n,
                s = i.isObject(e),
                o = a && a["Content-Type"];

            if ((n = i.isFileList(e)) || s && "multipart/form-data" === o) {
              var c = this.env && this.env.FormData;
              return r(n ? {
                "files[]": e
              } : e, c && new c());
            }

            return s || "application/json" === o ? (p(a, "application/json"), function (e, a, n) {
              if (i.isString(e)) try {
                return (0, JSON.parse)(e), i.trim(e);
              } catch (e) {
                if ("SyntaxError" !== e.name) throw e;
              }
              return (0, JSON.stringify)(e);
            }(e)) : e;
          }],
          transformResponse: [function (e) {
            var a = this.transitional || u.transitional,
                n = a && a.silentJSONParsing,
                t = a && a.forcedJSONParsing,
                o = !n && "json" === this.responseType;
            if (o || t && i.isString(e) && e.length) try {
              return JSON.parse(e);
            } catch (e) {
              if (o) {
                if ("SyntaxError" === e.name) throw s.from(e, s.ERR_BAD_RESPONSE, this, null, this.response);
                throw e;
              }
            }
            return e;
          }],
          timeout: 0,
          xsrfCookieName: "XSRF-TOKEN",
          xsrfHeaderName: "X-XSRF-TOKEN",
          maxContentLength: -1,
          maxBodyLength: -1,
          env: {
            FormData: n(3784)
          },
          validateStatus: function validateStatus(e) {
            return e >= 200 && e < 300;
          },
          headers: {
            common: {
              Accept: "application/json, text/plain, */*"
            }
          }
        };
        i.forEach(["delete", "get", "head"], function (e) {
          u.headers[e] = {};
        }), i.forEach(["post", "put", "patch"], function (e) {
          u.headers[e] = i.merge(c);
        }), e.exports = u;
      },
      7874: function _(e) {
        "use strict";

        e.exports = {
          silentJSONParsing: !0,
          forcedJSONParsing: !0,
          clarifyTimeoutError: !1
        };
      },
      7288: function _(e) {
        e.exports = {
          version: "0.27.2"
        };
      },
      1849: function _(e) {
        "use strict";

        e.exports = function (e, a) {
          return function () {
            for (var n = new Array(arguments.length), i = 0; i < n.length; i++) {
              n[i] = arguments[i];
            }

            return e.apply(a, n);
          };
        };
      },
      5327: function _(e, a, n) {
        "use strict";

        var i = n(4867);

        function t(e) {
          return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
        }

        e.exports = function (e, a, n) {
          if (!a) return e;
          var s;
          if (n) s = n(a);else if (i.isURLSearchParams(a)) s = a.toString();else {
            var o = [];
            i.forEach(a, function (e, a) {
              null != e && (i.isArray(e) ? a += "[]" : e = [e], i.forEach(e, function (e) {
                i.isDate(e) ? e = e.toISOString() : i.isObject(e) && (e = JSON.stringify(e)), o.push(t(a) + "=" + t(e));
              }));
            }), s = o.join("&");
          }

          if (s) {
            var r = e.indexOf("#");
            -1 !== r && (e = e.slice(0, r)), e += (-1 === e.indexOf("?") ? "?" : "&") + s;
          }

          return e;
        };
      },
      7303: function _(e) {
        "use strict";

        e.exports = function (e, a) {
          return a ? e.replace(/\/+$/, "") + "/" + a.replace(/^\/+/, "") : e;
        };
      },
      4372: function _(e, a, n) {
        "use strict";

        var i = n(4867);
        e.exports = i.isStandardBrowserEnv() ? {
          write: function write(e, a, n, t, s, o) {
            var r = [];
            r.push(e + "=" + encodeURIComponent(a)), i.isNumber(n) && r.push("expires=" + new Date(n).toGMTString()), i.isString(t) && r.push("path=" + t), i.isString(s) && r.push("domain=" + s), !0 === o && r.push("secure"), document.cookie = r.join("; ");
          },
          read: function read(e) {
            var a = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
            return a ? decodeURIComponent(a[3]) : null;
          },
          remove: function remove(e) {
            this.write(e, "", Date.now() - 864e5);
          }
        } : {
          write: function write() {},
          read: function read() {
            return null;
          },
          remove: function remove() {}
        };
      },
      1793: function _(e) {
        "use strict";

        e.exports = function (e) {
          return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
        };
      },
      6268: function _(e, a, n) {
        "use strict";

        var i = n(4867);

        e.exports = function (e) {
          return i.isObject(e) && !0 === e.isAxiosError;
        };
      },
      7985: function _(e, a, n) {
        "use strict";

        var i = n(4867);
        e.exports = i.isStandardBrowserEnv() ? function () {
          var e,
              a = /(msie|trident)/i.test(navigator.userAgent),
              n = document.createElement("a");

          function t(e) {
            var i = e;
            return a && (n.setAttribute("href", i), i = n.href), n.setAttribute("href", i), {
              href: n.href,
              protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
              host: n.host,
              search: n.search ? n.search.replace(/^\?/, "") : "",
              hash: n.hash ? n.hash.replace(/^#/, "") : "",
              hostname: n.hostname,
              port: n.port,
              pathname: "/" === n.pathname.charAt(0) ? n.pathname : "/" + n.pathname
            };
          }

          return e = t(window.location.href), function (a) {
            var n = i.isString(a) ? t(a) : a;
            return n.protocol === e.protocol && n.host === e.host;
          };
        }() : function () {
          return !0;
        };
      },
      6016: function _(e, a, n) {
        "use strict";

        var i = n(4867);

        e.exports = function (e, a) {
          i.forEach(e, function (n, i) {
            i !== a && i.toUpperCase() === a.toUpperCase() && (e[a] = n, delete e[i]);
          });
        };
      },
      4109: function _(e, a, n) {
        "use strict";

        var i = n(4867),
            t = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];

        e.exports = function (e) {
          var a,
              n,
              s,
              o = {};
          return e ? (i.forEach(e.split("\n"), function (e) {
            if (s = e.indexOf(":"), a = i.trim(e.substr(0, s)).toLowerCase(), n = i.trim(e.substr(s + 1)), a) {
              if (o[a] && t.indexOf(a) >= 0) return;
              o[a] = "set-cookie" === a ? (o[a] ? o[a] : []).concat([n]) : o[a] ? o[a] + ", " + n : n;
            }
          }), o) : o;
        };
      },
      205: function _(e) {
        "use strict";

        e.exports = function (e) {
          var a = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
          return a && a[1] || "";
        };
      },
      8713: function _(e) {
        "use strict";

        e.exports = function (e) {
          return function (a) {
            return e.apply(null, a);
          };
        };
      },
      7675: function _(e, a, n) {
        "use strict";

        var i = n(4867);

        e.exports = function (e, a) {
          a = a || new FormData();
          var n = [];

          function t(e) {
            return null === e ? "" : i.isDate(e) ? e.toISOString() : i.isArrayBuffer(e) || i.isTypedArray(e) ? "function" == typeof Blob ? new Blob([e]) : Buffer.from(e) : e;
          }

          return function e(s, o) {
            if (i.isPlainObject(s) || i.isArray(s)) {
              if (-1 !== n.indexOf(s)) throw Error("Circular reference detected in " + o);
              n.push(s), i.forEach(s, function (n, s) {
                if (!i.isUndefined(n)) {
                  var r,
                      c = o ? o + "." + s : s;
                  if (n && !o && "object" == typeof n) if (i.endsWith(s, "{}")) n = JSON.stringify(n);else if (i.endsWith(s, "[]") && (r = i.toArray(n))) return void r.forEach(function (e) {
                    !i.isUndefined(e) && a.append(c, t(e));
                  });
                  e(n, c);
                }
              }), n.pop();
            } else a.append(o, t(s));
          }(e), a;
        };
      },
      4875: function _(e, a, n) {
        "use strict";

        var i = n(7288).version,
            t = n(2648),
            s = {};
        ["object", "boolean", "number", "function", "string", "symbol"].forEach(function (e, a) {
          s[e] = function (n) {
            return typeof n === e || "a" + (a < 1 ? "n " : " ") + e;
          };
        });
        var o = {};
        s.transitional = function (e, a, n) {
          function s(e, a) {
            return "[Axios v" + i + "] Transitional option '" + e + "'" + a + (n ? ". " + n : "");
          }

          return function (n, i, r) {
            if (!1 === e) throw new t(s(i, " has been removed" + (a ? " in " + a : "")), t.ERR_DEPRECATED);
            return a && !o[i] && (o[i] = !0, console.warn(s(i, " has been deprecated since v" + a + " and will be removed in the near future"))), !e || e(n, i, r);
          };
        }, e.exports = {
          assertOptions: function assertOptions(e, a, n) {
            if ("object" != typeof e) throw new t("options must be an object", t.ERR_BAD_OPTION_VALUE);

            for (var i = Object.keys(e), s = i.length; s-- > 0;) {
              var o = i[s],
                  r = a[o];

              if (r) {
                var c = e[o],
                    p = void 0 === c || r(c, o, e);
                if (!0 !== p) throw new t("option " + o + " must be " + p, t.ERR_BAD_OPTION_VALUE);
              } else if (!0 !== n) throw new t("Unknown option " + o, t.ERR_BAD_OPTION);
            }
          },
          validators: s
        };
      },
      4867: function _(e, a, n) {
        "use strict";

        var i,
            t = n(1849),
            s = Object.prototype.toString,
            o = (i = Object.create(null), function (e) {
          var a = s.call(e);
          return i[a] || (i[a] = a.slice(8, -1).toLowerCase());
        });

        function r(e) {
          return e = e.toLowerCase(), function (a) {
            return o(a) === e;
          };
        }

        function c(e) {
          return Array.isArray(e);
        }

        function p(e) {
          return void 0 === e;
        }

        var l = r("ArrayBuffer");

        function u(e) {
          return null !== e && "object" == typeof e;
        }

        function m(e) {
          if ("object" !== o(e)) return !1;
          var a = Object.getPrototypeOf(e);
          return null === a || a === Object.prototype;
        }

        var d = r("Date"),
            f = r("File"),
            h = r("Blob"),
            x = r("FileList");

        function v(e) {
          return "[object Function]" === s.call(e);
        }

        var g = r("URLSearchParams");

        function b(e, a) {
          if (null != e) if ("object" != typeof e && (e = [e]), c(e)) for (var n = 0, i = e.length; n < i; n++) {
            a.call(null, e[n], n, e);
          } else for (var t in e) {
            Object.prototype.hasOwnProperty.call(e, t) && a.call(null, e[t], t, e);
          }
        }

        var y,
            w = (y = "undefined" != typeof Uint8Array && Object.getPrototypeOf(Uint8Array), function (e) {
          return y && e instanceof y;
        });
        e.exports = {
          isArray: c,
          isArrayBuffer: l,
          isBuffer: function isBuffer(e) {
            return null !== e && !p(e) && null !== e.constructor && !p(e.constructor) && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
          },
          isFormData: function isFormData(e) {
            var a = "[object FormData]";
            return e && ("function" == typeof FormData && e instanceof FormData || s.call(e) === a || v(e.toString) && e.toString() === a);
          },
          isArrayBufferView: function isArrayBufferView(e) {
            return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && l(e.buffer);
          },
          isString: function isString(e) {
            return "string" == typeof e;
          },
          isNumber: function isNumber(e) {
            return "number" == typeof e;
          },
          isObject: u,
          isPlainObject: m,
          isUndefined: p,
          isDate: d,
          isFile: f,
          isBlob: h,
          isFunction: v,
          isStream: function isStream(e) {
            return u(e) && v(e.pipe);
          },
          isURLSearchParams: g,
          isStandardBrowserEnv: function isStandardBrowserEnv() {
            return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
          },
          forEach: b,
          merge: function e() {
            var a = {};

            function n(n, i) {
              m(a[i]) && m(n) ? a[i] = e(a[i], n) : m(n) ? a[i] = e({}, n) : c(n) ? a[i] = n.slice() : a[i] = n;
            }

            for (var i = 0, t = arguments.length; i < t; i++) {
              b(arguments[i], n);
            }

            return a;
          },
          extend: function extend(e, a, n) {
            return b(a, function (a, i) {
              e[i] = n && "function" == typeof a ? t(a, n) : a;
            }), e;
          },
          trim: function trim(e) {
            return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
          },
          stripBOM: function stripBOM(e) {
            return 65279 === e.charCodeAt(0) && (e = e.slice(1)), e;
          },
          inherits: function inherits(e, a, n, i) {
            e.prototype = Object.create(a.prototype, i), e.prototype.constructor = e, n && Object.assign(e.prototype, n);
          },
          toFlatObject: function toFlatObject(e, a, n) {
            var i,
                t,
                s,
                o = {};
            a = a || {};

            do {
              for (t = (i = Object.getOwnPropertyNames(e)).length; t-- > 0;) {
                o[s = i[t]] || (a[s] = e[s], o[s] = !0);
              }

              e = Object.getPrototypeOf(e);
            } while (e && (!n || n(e, a)) && e !== Object.prototype);

            return a;
          },
          kindOf: o,
          kindOfTest: r,
          endsWith: function endsWith(e, a, n) {
            e = String(e), (void 0 === n || n > e.length) && (n = e.length), n -= a.length;
            var i = e.indexOf(a, n);
            return -1 !== i && i === n;
          },
          toArray: function toArray(e) {
            if (!e) return null;
            var a = e.length;
            if (p(a)) return null;

            for (var n = new Array(a); a-- > 0;) {
              n[a] = e[a];
            }

            return n;
          },
          isTypedArray: w,
          isFileList: x
        };
      },
      487: function _(e) {
        var a = {
          utf8: {
            stringToBytes: function stringToBytes(e) {
              return a.bin.stringToBytes(unescape(encodeURIComponent(e)));
            },
            bytesToString: function bytesToString(e) {
              return decodeURIComponent(escape(a.bin.bytesToString(e)));
            }
          },
          bin: {
            stringToBytes: function stringToBytes(e) {
              for (var a = [], n = 0; n < e.length; n++) {
                a.push(255 & e.charCodeAt(n));
              }

              return a;
            },
            bytesToString: function bytesToString(e) {
              for (var a = [], n = 0; n < e.length; n++) {
                a.push(String.fromCharCode(e[n]));
              }

              return a.join("");
            }
          }
        };
        e.exports = a;
      },
      9779: function _(e, a, n) {
        var i = n(3837),
            t = n(2781).Stream,
            s = n(3463);

        function o() {
          this.writable = !1, this.readable = !0, this.dataSize = 0, this.maxDataSize = 2097152, this.pauseStreams = !0, this._released = !1, this._streams = [], this._currentStream = null, this._insideLoop = !1, this._pendingNext = !1;
        }

        e.exports = o, i.inherits(o, t), o.create = function (e) {
          var a = new this();

          for (var n in e = e || {}) {
            a[n] = e[n];
          }

          return a;
        }, o.isStreamLike = function (e) {
          return "function" != typeof e && "string" != typeof e && "boolean" != typeof e && "number" != typeof e && !Buffer.isBuffer(e);
        }, o.prototype.append = function (e) {
          if (o.isStreamLike(e)) {
            if (!(e instanceof s)) {
              var a = s.create(e, {
                maxDataSize: 1 / 0,
                pauseStream: this.pauseStreams
              });
              e.on("data", this._checkDataSize.bind(this)), e = a;
            }

            this._handleErrors(e), this.pauseStreams && e.pause();
          }

          return this._streams.push(e), this;
        }, o.prototype.pipe = function (e, a) {
          return t.prototype.pipe.call(this, e, a), this.resume(), e;
        }, o.prototype._getNext = function () {
          if (this._currentStream = null, this._insideLoop) this._pendingNext = !0;else {
            this._insideLoop = !0;

            try {
              do {
                this._pendingNext = !1, this._realGetNext();
              } while (this._pendingNext);
            } finally {
              this._insideLoop = !1;
            }
          }
        }, o.prototype._realGetNext = function () {
          var e = this._streams.shift();

          void 0 !== e ? "function" == typeof e ? e(function (e) {
            o.isStreamLike(e) && (e.on("data", this._checkDataSize.bind(this)), this._handleErrors(e)), this._pipeNext(e);
          }.bind(this)) : this._pipeNext(e) : this.end();
        }, o.prototype._pipeNext = function (e) {
          if (this._currentStream = e, o.isStreamLike(e)) return e.on("end", this._getNext.bind(this)), void e.pipe(this, {
            end: !1
          });
          var a = e;
          this.write(a), this._getNext();
        }, o.prototype._handleErrors = function (e) {
          var a = this;
          e.on("error", function (e) {
            a._emitError(e);
          });
        }, o.prototype.write = function (e) {
          this.emit("data", e);
        }, o.prototype.pause = function () {
          this.pauseStreams && (this.pauseStreams && this._currentStream && "function" == typeof this._currentStream.pause && this._currentStream.pause(), this.emit("pause"));
        }, o.prototype.resume = function () {
          this._released || (this._released = !0, this.writable = !0, this._getNext()), this.pauseStreams && this._currentStream && "function" == typeof this._currentStream.resume && this._currentStream.resume(), this.emit("resume");
        }, o.prototype.end = function () {
          this._reset(), this.emit("end");
        }, o.prototype.destroy = function () {
          this._reset(), this.emit("close");
        }, o.prototype._reset = function () {
          this.writable = !1, this._streams = [], this._currentStream = null;
        }, o.prototype._checkDataSize = function () {
          if (this._updateDataSize(), !(this.dataSize <= this.maxDataSize)) {
            var e = "DelayedStream#maxDataSize of " + this.maxDataSize + " bytes exceeded.";

            this._emitError(new Error(e));
          }
        }, o.prototype._updateDataSize = function () {
          this.dataSize = 0;
          var e = this;
          this._streams.forEach(function (a) {
            a.dataSize && (e.dataSize += a.dataSize);
          }), this._currentStream && this._currentStream.dataSize && (this.dataSize += this._currentStream.dataSize);
        }, o.prototype._emitError = function (e) {
          this._reset(), this.emit("error", e);
        };
      },
      1012: function _(e) {
        var a, n;
        a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = {
          rotl: function rotl(e, a) {
            return e << a | e >>> 32 - a;
          },
          rotr: function rotr(e, a) {
            return e << 32 - a | e >>> a;
          },
          endian: function endian(e) {
            if (e.constructor == Number) return 16711935 & n.rotl(e, 8) | 4278255360 & n.rotl(e, 24);

            for (var a = 0; a < e.length; a++) {
              e[a] = n.endian(e[a]);
            }

            return e;
          },
          randomBytes: function randomBytes(e) {
            for (var a = []; e > 0; e--) {
              a.push(Math.floor(256 * Math.random()));
            }

            return a;
          },
          bytesToWords: function bytesToWords(e) {
            for (var a = [], n = 0, i = 0; n < e.length; n++, i += 8) {
              a[i >>> 5] |= e[n] << 24 - i % 32;
            }

            return a;
          },
          wordsToBytes: function wordsToBytes(e) {
            for (var a = [], n = 0; n < 32 * e.length; n += 8) {
              a.push(e[n >>> 5] >>> 24 - n % 32 & 255);
            }

            return a;
          },
          bytesToHex: function bytesToHex(e) {
            for (var a = [], n = 0; n < e.length; n++) {
              a.push((e[n] >>> 4).toString(16)), a.push((15 & e[n]).toString(16));
            }

            return a.join("");
          },
          hexToBytes: function hexToBytes(e) {
            for (var a = [], n = 0; n < e.length; n += 2) {
              a.push(parseInt(e.substr(n, 2), 16));
            }

            return a;
          },
          bytesToBase64: function bytesToBase64(e) {
            for (var n = [], i = 0; i < e.length; i += 3) {
              for (var t = e[i] << 16 | e[i + 1] << 8 | e[i + 2], s = 0; s < 4; s++) {
                8 * i + 6 * s <= 8 * e.length ? n.push(a.charAt(t >>> 6 * (3 - s) & 63)) : n.push("=");
              }
            }

            return n.join("");
          },
          base64ToBytes: function base64ToBytes(e) {
            e = e.replace(/[^A-Z0-9+\/]/gi, "");

            for (var n = [], i = 0, t = 0; i < e.length; t = ++i % 4) {
              0 != t && n.push((a.indexOf(e.charAt(i - 1)) & Math.pow(2, -2 * t + 8) - 1) << 2 * t | a.indexOf(e.charAt(i)) >>> 6 - 2 * t);
            }

            return n;
          }
        }, e.exports = n;
      },
      1227: function _(e, a, n) {
        a.formatArgs = function (a) {
          if (a[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + a[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !this.useColors) return;
          var n = "color: " + this.color;
          a.splice(1, 0, n, "color: inherit");
          var i = 0,
              t = 0;
          a[0].replace(/%[a-zA-Z%]/g, function (e) {
            "%%" !== e && (i++, "%c" === e && (t = i));
          }), a.splice(t, 0, n);
        }, a.save = function (e) {
          try {
            e ? a.storage.setItem("debug", e) : a.storage.removeItem("debug");
          } catch (e) {}
        }, a.load = function () {
          var e;

          try {
            e = a.storage.getItem("debug");
          } catch (e) {}

          return !e && "undefined" != typeof process && "env" in process && (e = process.env.DEBUG), e;
        }, a.useColors = function () {
          return !("undefined" == typeof window || !window.process || "renderer" !== window.process.type && !window.process.__nwjs) || ("undefined" == typeof navigator || !navigator.userAgent || !navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) && ("undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
        }, a.storage = function () {
          try {
            return localStorage;
          } catch (e) {}
        }(), a.destroy = function () {
          var e = !1;
          return function () {
            e || (e = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
          };
        }(), a.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], a.log = console.debug || console.log || function () {}, e.exports = n(2447)(a);
        var i = e.exports.formatters;

        i.j = function (e) {
          try {
            return JSON.stringify(e);
          } catch (e) {
            return "[UnexpectedJSONParseError]: " + e.message;
          }
        };
      },
      2447: function _(e, a, n) {
        e.exports = function (e) {
          function a(e) {
            var n,
                t,
                s,
                o = null;

            function r() {
              for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
                e[_key] = arguments[_key];
              }

              if (!r.enabled) return;
              var i = r,
                  t = Number(new Date()),
                  s = t - (n || t);
              i.diff = s, i.prev = n, i.curr = t, n = t, e[0] = a.coerce(e[0]), "string" != typeof e[0] && e.unshift("%O");
              var o = 0;
              e[0] = e[0].replace(/%([a-zA-Z%])/g, function (n, t) {
                if ("%%" === n) return "%";
                o++;
                var s = a.formatters[t];

                if ("function" == typeof s) {
                  var _a16 = e[o];
                  n = s.call(i, _a16), e.splice(o, 1), o--;
                }

                return n;
              }), a.formatArgs.call(i, e), (i.log || a.log).apply(i, e);
            }

            return r.namespace = e, r.useColors = a.useColors(), r.color = a.selectColor(e), r.extend = i, r.destroy = a.destroy, Object.defineProperty(r, "enabled", {
              enumerable: !0,
              configurable: !1,
              get: function get() {
                return null !== o ? o : (t !== a.namespaces && (t = a.namespaces, s = a.enabled(e)), s);
              },
              set: function set(e) {
                o = e;
              }
            }), "function" == typeof a.init && a.init(r), r;
          }

          function i(e, n) {
            var i = a(this.namespace + (void 0 === n ? ":" : n) + e);
            return i.log = this.log, i;
          }

          function t(e) {
            return e.toString().substring(2, e.toString().length - 2).replace(/\.\*\?$/, "*");
          }

          return a.debug = a, a.default = a, a.coerce = function (e) {
            return e instanceof Error ? e.stack || e.message : e;
          }, a.disable = function () {
            var e = [].concat(_toConsumableArray(a.names.map(t)), _toConsumableArray(a.skips.map(t).map(function (e) {
              return "-" + e;
            }))).join(",");
            return a.enable(""), e;
          }, a.enable = function (e) {
            var n;
            a.save(e), a.namespaces = e, a.names = [], a.skips = [];
            var i = ("string" == typeof e ? e : "").split(/[\s,]+/),
                t = i.length;

            for (n = 0; n < t; n++) {
              i[n] && ("-" === (e = i[n].replace(/\*/g, ".*?"))[0] ? a.skips.push(new RegExp("^" + e.slice(1) + "$")) : a.names.push(new RegExp("^" + e + "$")));
            }
          }, a.enabled = function (e) {
            if ("*" === e[e.length - 1]) return !0;
            var n, i;

            for (n = 0, i = a.skips.length; n < i; n++) {
              if (a.skips[n].test(e)) return !1;
            }

            for (n = 0, i = a.names.length; n < i; n++) {
              if (a.names[n].test(e)) return !0;
            }

            return !1;
          }, a.humanize = n(7824), a.destroy = function () {
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
          }, Object.keys(e).forEach(function (n) {
            a[n] = e[n];
          }), a.names = [], a.skips = [], a.formatters = {}, a.selectColor = function (e) {
            var n = 0;

            for (var _a17 = 0; _a17 < e.length; _a17++) {
              n = (n << 5) - n + e.charCodeAt(_a17), n |= 0;
            }

            return a.colors[Math.abs(n) % a.colors.length];
          }, a.enable(a.load()), a;
        };
      },
      5158: function _(e, a, n) {
        "undefined" == typeof process || "renderer" === process.type || !0 === process.browser || process.__nwjs ? e.exports = n(1227) : e.exports = n(39);
      },
      39: function _(e, a, n) {
        var i = n(6224),
            t = n(3837);
        a.init = function (e) {
          e.inspectOpts = {};
          var n = Object.keys(a.inspectOpts);

          for (var _i27 = 0; _i27 < n.length; _i27++) {
            e.inspectOpts[n[_i27]] = a.inspectOpts[n[_i27]];
          }
        }, a.log = function () {
          return process.stderr.write(t.format.apply(t, arguments) + "\n");
        }, a.formatArgs = function (n) {
          var i = this.namespace,
              t = this.useColors;

          if (t) {
            var _a18 = this.color,
                _t16 = "[3" + (_a18 < 8 ? _a18 : "8;5;" + _a18),
                _s8 = "  ".concat(_t16, ";1m").concat(i, " \x1B[0m");

            n[0] = _s8 + n[0].split("\n").join("\n" + _s8), n.push(_t16 + "m+" + e.exports.humanize(this.diff) + "[0m");
          } else n[0] = (a.inspectOpts.hideDate ? "" : new Date().toISOString() + " ") + i + " " + n[0];
        }, a.save = function (e) {
          e ? process.env.DEBUG = e : delete process.env.DEBUG;
        }, a.load = function () {
          return process.env.DEBUG;
        }, a.useColors = function () {
          return "colors" in a.inspectOpts ? Boolean(a.inspectOpts.colors) : i.isatty(process.stderr.fd);
        }, a.destroy = t.deprecate(function () {}, "Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."), a.colors = [6, 2, 3, 4, 5, 1];

        try {
          var _e20 = n(2130);

          _e20 && (_e20.stderr || _e20).level >= 2 && (a.colors = [20, 21, 26, 27, 32, 33, 38, 39, 40, 41, 42, 43, 44, 45, 56, 57, 62, 63, 68, 69, 74, 75, 76, 77, 78, 79, 80, 81, 92, 93, 98, 99, 112, 113, 128, 129, 134, 135, 148, 149, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 178, 179, 184, 185, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 214, 215, 220, 221]);
        } catch (e) {}

        a.inspectOpts = Object.keys(process.env).filter(function (e) {
          return /^debug_/i.test(e);
        }).reduce(function (e, a) {
          var n = a.substring(6).toLowerCase().replace(/_([a-z])/g, function (e, a) {
            return a.toUpperCase();
          });
          var i = process.env[a];
          return i = !!/^(yes|on|true|enabled)$/i.test(i) || !/^(no|off|false|disabled)$/i.test(i) && ("null" === i ? null : Number(i)), e[n] = i, e;
        }, {}), e.exports = n(2447)(a);
        var s = e.exports.formatters;
        s.o = function (e) {
          return this.inspectOpts.colors = this.useColors, t.inspect(e, this.inspectOpts).split("\n").map(function (e) {
            return e.trim();
          }).join(" ");
        }, s.O = function (e) {
          return this.inspectOpts.colors = this.useColors, t.inspect(e, this.inspectOpts);
        };
      },
      3463: function _(e, a, n) {
        var i = n(2781).Stream,
            t = n(3837);

        function s() {
          this.source = null, this.dataSize = 0, this.maxDataSize = 1048576, this.pauseStream = !0, this._maxDataSizeExceeded = !1, this._released = !1, this._bufferedEvents = [];
        }

        e.exports = s, t.inherits(s, i), s.create = function (e, a) {
          var n = new this();

          for (var i in a = a || {}) {
            n[i] = a[i];
          }

          n.source = e;
          var t = e.emit;
          return e.emit = function () {
            return n._handleEmit(arguments), t.apply(e, arguments);
          }, e.on("error", function () {}), n.pauseStream && e.pause(), n;
        }, Object.defineProperty(s.prototype, "readable", {
          configurable: !0,
          enumerable: !0,
          get: function get() {
            return this.source.readable;
          }
        }), s.prototype.setEncoding = function () {
          return this.source.setEncoding.apply(this.source, arguments);
        }, s.prototype.resume = function () {
          this._released || this.release(), this.source.resume();
        }, s.prototype.pause = function () {
          this.source.pause();
        }, s.prototype.release = function () {
          this._released = !0, this._bufferedEvents.forEach(function (e) {
            this.emit.apply(this, e);
          }.bind(this)), this._bufferedEvents = [];
        }, s.prototype.pipe = function () {
          var e = i.prototype.pipe.apply(this, arguments);
          return this.resume(), e;
        }, s.prototype._handleEmit = function (e) {
          this._released ? this.emit.apply(this, e) : ("data" === e[0] && (this.dataSize += e[1].length, this._checkIfMaxDataSizeExceeded()), this._bufferedEvents.push(e));
        }, s.prototype._checkIfMaxDataSizeExceeded = function () {
          if (!(this._maxDataSizeExceeded || this.dataSize <= this.maxDataSize)) {
            this._maxDataSizeExceeded = !0;
            var e = "DelayedStream#maxDataSize of " + this.maxDataSize + " bytes exceeded.";
            this.emit("error", new Error(e));
          }
        };
      },
      2261: function _(e, a, n) {
        var i;

        e.exports = function () {
          if (!i) {
            try {
              i = n(5158)("follow-redirects");
            } catch (e) {}

            "function" != typeof i && (i = function i() {});
          }

          i.apply(null, arguments);
        };
      },
      938: function _(e, a, n) {
        var i = n(7310),
            t = i.URL,
            s = n(3685),
            o = n(5687),
            r = n(2781).Writable,
            c = n(9491),
            p = n(2261),
            l = ["abort", "aborted", "connect", "error", "socket", "timeout"],
            u = Object.create(null);
        l.forEach(function (e) {
          u[e] = function (a, n, i) {
            this._redirectable.emit(e, a, n, i);
          };
        });
        var m = w("ERR_FR_REDIRECTION_FAILURE", "Redirected request failed"),
            d = w("ERR_FR_TOO_MANY_REDIRECTS", "Maximum number of redirects exceeded"),
            f = w("ERR_FR_MAX_BODY_LENGTH_EXCEEDED", "Request body larger than maxBodyLength limit"),
            h = w("ERR_STREAM_WRITE_AFTER_END", "write after end");

        function x(e, a) {
          r.call(this), this._sanitizeOptions(e), this._options = e, this._ended = !1, this._ending = !1, this._redirectCount = 0, this._redirects = [], this._requestBodyLength = 0, this._requestBodyBuffers = [], a && this.on("response", a);
          var n = this;
          this._onNativeResponse = function (e) {
            n._processResponse(e);
          }, this._performRequest();
        }

        function v(e) {
          var a = {
            maxRedirects: 21,
            maxBodyLength: 10485760
          },
              n = {};
          return Object.keys(e).forEach(function (s) {
            var o = s + ":",
                r = n[o] = e[s],
                l = a[s] = Object.create(r);
            Object.defineProperties(l, {
              request: {
                value: function value(e, s, r) {
                  if ("string" == typeof e) {
                    var l = e;

                    try {
                      e = b(new t(l));
                    } catch (a) {
                      e = i.parse(l);
                    }
                  } else t && e instanceof t ? e = b(e) : (r = s, s = e, e = {
                    protocol: o
                  });

                  return "function" == typeof s && (r = s, s = null), (s = Object.assign({
                    maxRedirects: a.maxRedirects,
                    maxBodyLength: a.maxBodyLength
                  }, e, s)).nativeProtocols = n, c.equal(s.protocol, o, "protocol mismatch"), p("options", s), new x(s, r);
                },
                configurable: !0,
                enumerable: !0,
                writable: !0
              },
              get: {
                value: function value(e, a, n) {
                  var i = l.request(e, a, n);
                  return i.end(), i;
                },
                configurable: !0,
                enumerable: !0,
                writable: !0
              }
            });
          }), a;
        }

        function g() {}

        function b(e) {
          var a = {
            protocol: e.protocol,
            hostname: e.hostname.startsWith("[") ? e.hostname.slice(1, -1) : e.hostname,
            hash: e.hash,
            search: e.search,
            pathname: e.pathname,
            path: e.pathname + e.search,
            href: e.href
          };
          return "" !== e.port && (a.port = Number(e.port)), a;
        }

        function y(e, a) {
          var n;

          for (var i in a) {
            e.test(i) && (n = a[i], delete a[i]);
          }

          return null == n ? void 0 : String(n).trim();
        }

        function w(e, a) {
          function n(e) {
            Error.captureStackTrace(this, this.constructor), e ? (this.message = a + ": " + e.message, this.cause = e) : this.message = a;
          }

          return n.prototype = new Error(), n.prototype.constructor = n, n.prototype.name = "Error [" + e + "]", n.prototype.code = e, n;
        }

        function k(e) {
          var _iterator10 = _createForOfIteratorHelper(l),
              _step10;

          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var a = _step10.value;
              e.removeListener(a, u[a]);
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }

          e.on("error", g), e.abort();
        }

        x.prototype = Object.create(r.prototype), x.prototype.abort = function () {
          k(this._currentRequest), this.emit("abort");
        }, x.prototype.write = function (e, a, n) {
          if (this._ending) throw new h();
          if (!("string" == typeof e || "object" == typeof e && "length" in e)) throw new TypeError("data should be a string, Buffer or Uint8Array");
          "function" == typeof a && (n = a, a = null), 0 !== e.length ? this._requestBodyLength + e.length <= this._options.maxBodyLength ? (this._requestBodyLength += e.length, this._requestBodyBuffers.push({
            data: e,
            encoding: a
          }), this._currentRequest.write(e, a, n)) : (this.emit("error", new f()), this.abort()) : n && n();
        }, x.prototype.end = function (e, a, n) {
          if ("function" == typeof e ? (n = e, e = a = null) : "function" == typeof a && (n = a, a = null), e) {
            var i = this,
                t = this._currentRequest;
            this.write(e, a, function () {
              i._ended = !0, t.end(null, null, n);
            }), this._ending = !0;
          } else this._ended = this._ending = !0, this._currentRequest.end(null, null, n);
        }, x.prototype.setHeader = function (e, a) {
          this._options.headers[e] = a, this._currentRequest.setHeader(e, a);
        }, x.prototype.removeHeader = function (e) {
          delete this._options.headers[e], this._currentRequest.removeHeader(e);
        }, x.prototype.setTimeout = function (e, a) {
          var n = this;

          function i(a) {
            a.setTimeout(e), a.removeListener("timeout", a.destroy), a.addListener("timeout", a.destroy);
          }

          function t(a) {
            n._timeout && clearTimeout(n._timeout), n._timeout = setTimeout(function () {
              n.emit("timeout"), s();
            }, e), i(a);
          }

          function s() {
            n._timeout && (clearTimeout(n._timeout), n._timeout = null), n.removeListener("abort", s), n.removeListener("error", s), n.removeListener("response", s), a && n.removeListener("timeout", a), n.socket || n._currentRequest.removeListener("socket", t);
          }

          return a && this.on("timeout", a), this.socket ? t(this.socket) : this._currentRequest.once("socket", t), this.on("socket", i), this.on("abort", s), this.on("error", s), this.on("response", s), this;
        }, ["flushHeaders", "getHeader", "setNoDelay", "setSocketKeepAlive"].forEach(function (e) {
          x.prototype[e] = function (a, n) {
            return this._currentRequest[e](a, n);
          };
        }), ["aborted", "connection", "socket"].forEach(function (e) {
          Object.defineProperty(x.prototype, e, {
            get: function get() {
              return this._currentRequest[e];
            }
          });
        }), x.prototype._sanitizeOptions = function (e) {
          if (e.headers || (e.headers = {}), e.host && (e.hostname || (e.hostname = e.host), delete e.host), !e.pathname && e.path) {
            var a = e.path.indexOf("?");
            a < 0 ? e.pathname = e.path : (e.pathname = e.path.substring(0, a), e.search = e.path.substring(a));
          }
        }, x.prototype._performRequest = function () {
          var e = this._options.protocol,
              a = this._options.nativeProtocols[e];

          if (a) {
            if (this._options.agents) {
              var n = e.slice(0, -1);
              this._options.agent = this._options.agents[n];
            }

            var t = this._currentRequest = a.request(this._options, this._onNativeResponse);

            var _iterator11 = _createForOfIteratorHelper((t._redirectable = this, l)),
                _step11;

            try {
              for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                var s = _step11.value;
                t.on(s, u[s]);
              }
            } catch (err) {
              _iterator11.e(err);
            } finally {
              _iterator11.f();
            }

            if (this._currentUrl = /^\//.test(this._options.path) ? i.format(this._options) : this._currentUrl = this._options.path, this._isRedirect) {
              var o = 0,
                  r = this,
                  c = this._requestBodyBuffers;
              !function e(a) {
                if (t === r._currentRequest) if (a) r.emit("error", a);else if (o < c.length) {
                  var n = c[o++];
                  t.finished || t.write(n.data, n.encoding, e);
                } else r._ended && t.end();
              }();
            }
          } else this.emit("error", new TypeError("Unsupported protocol " + e));
        }, x.prototype._processResponse = function (e) {
          var a = e.statusCode;
          this._options.trackRedirects && this._redirects.push({
            url: this._currentUrl,
            headers: e.headers,
            statusCode: a
          });
          var n = e.headers.location;
          if (!n || !1 === this._options.followRedirects || a < 300 || a >= 400) return e.responseUrl = this._currentUrl, e.redirects = this._redirects, this.emit("response", e), void (this._requestBodyBuffers = []);
          if (k(this._currentRequest), e.destroy(), ++this._redirectCount > this._options.maxRedirects) this.emit("error", new d());else {
            var t,
                s = this._options.beforeRedirect;
            s && (t = Object.assign({
              Host: e.req.getHeader("host")
            }, this._options.headers));
            var o = this._options.method;
            ((301 === a || 302 === a) && "POST" === this._options.method || 303 === a && !/^(?:GET|HEAD)$/.test(this._options.method)) && (this._options.method = "GET", this._requestBodyBuffers = [], y(/^content-/i, this._options.headers));
            var r,
                c = y(/^host$/i, this._options.headers),
                l = i.parse(this._currentUrl),
                u = c || l.host,
                f = /^\w+:/.test(n) ? this._currentUrl : i.format(Object.assign(l, {
              host: u
            }));

            try {
              r = i.resolve(f, n);
            } catch (e) {
              return void this.emit("error", new m(e));
            }

            p("redirecting to", r), this._isRedirect = !0;
            var h = i.parse(r);

            if (Object.assign(this._options, h), (h.protocol !== l.protocol && "https:" !== h.protocol || h.host !== u && !function (e, a) {
              var n = e.length - a.length - 1;
              return n > 0 && "." === e[n] && e.endsWith(a);
            }(h.host, u)) && y(/^(?:authorization|cookie)$/i, this._options.headers), "function" == typeof s) {
              var x = {
                headers: e.headers,
                statusCode: a
              },
                  v = {
                url: f,
                method: o,
                headers: t
              };

              try {
                s(this._options, x, v);
              } catch (e) {
                return void this.emit("error", e);
              }

              this._sanitizeOptions(this._options);
            }

            try {
              this._performRequest();
            } catch (e) {
              this.emit("error", new m(e));
            }
          }
        }, e.exports = v({
          http: s,
          https: o
        }), e.exports.wrap = v;
      },
      6882: function _(e, a, n) {
        var i = n(9779),
            t = n(3837),
            s = n(1017),
            o = n(3685),
            r = n(5687),
            c = n(7310).parse,
            p = n(7147),
            l = n(2781).Stream,
            u = n(983),
            m = n(9118),
            d = n(2275);

        function f(e) {
          if (!(this instanceof f)) return new f(e);

          for (var a in this._overheadLength = 0, this._valueLength = 0, this._valuesToMeasure = [], i.call(this), e = e || {}) {
            this[a] = e[a];
          }
        }

        e.exports = f, t.inherits(f, i), f.LINE_BREAK = "\r\n", f.DEFAULT_CONTENT_TYPE = "application/octet-stream", f.prototype.append = function (e, a, n) {
          "string" == typeof (n = n || {}) && (n = {
            filename: n
          });
          var s = i.prototype.append.bind(this);
          if ("number" == typeof a && (a = "" + a), t.isArray(a)) this._error(new Error("Arrays are not supported."));else {
            var o = this._multiPartHeader(e, a, n),
                r = this._multiPartFooter();

            s(o), s(a), s(r), this._trackLength(o, a, n);
          }
        }, f.prototype._trackLength = function (e, a, n) {
          var i = 0;
          null != n.knownLength ? i += +n.knownLength : Buffer.isBuffer(a) ? i = a.length : "string" == typeof a && (i = Buffer.byteLength(a)), this._valueLength += i, this._overheadLength += Buffer.byteLength(e) + f.LINE_BREAK.length, a && (a.path || a.readable && a.hasOwnProperty("httpVersion") || a instanceof l) && (n.knownLength || this._valuesToMeasure.push(a));
        }, f.prototype._lengthRetriever = function (e, a) {
          e.hasOwnProperty("fd") ? null != e.end && e.end != 1 / 0 && null != e.start ? a(null, e.end + 1 - (e.start ? e.start : 0)) : p.stat(e.path, function (n, i) {
            var t;
            n ? a(n) : (t = i.size - (e.start ? e.start : 0), a(null, t));
          }) : e.hasOwnProperty("httpVersion") ? a(null, +e.headers["content-length"]) : e.hasOwnProperty("httpModule") ? (e.on("response", function (n) {
            e.pause(), a(null, +n.headers["content-length"]);
          }), e.resume()) : a("Unknown stream");
        }, f.prototype._multiPartHeader = function (e, a, n) {
          if ("string" == typeof n.header) return n.header;

          var i,
              t = this._getContentDisposition(a, n),
              s = this._getContentType(a, n),
              o = "",
              r = {
            "Content-Disposition": ["form-data", 'name="' + e + '"'].concat(t || []),
            "Content-Type": [].concat(s || [])
          };

          for (var c in "object" == typeof n.header && d(r, n.header), r) {
            r.hasOwnProperty(c) && null != (i = r[c]) && (Array.isArray(i) || (i = [i]), i.length && (o += c + ": " + i.join("; ") + f.LINE_BREAK));
          }

          return "--" + this.getBoundary() + f.LINE_BREAK + o + f.LINE_BREAK;
        }, f.prototype._getContentDisposition = function (e, a) {
          var n, i;
          return "string" == typeof a.filepath ? n = s.normalize(a.filepath).replace(/\\/g, "/") : a.filename || e.name || e.path ? n = s.basename(a.filename || e.name || e.path) : e.readable && e.hasOwnProperty("httpVersion") && (n = s.basename(e.client._httpMessage.path || "")), n && (i = 'filename="' + n + '"'), i;
        }, f.prototype._getContentType = function (e, a) {
          var n = a.contentType;
          return !n && e.name && (n = u.lookup(e.name)), !n && e.path && (n = u.lookup(e.path)), !n && e.readable && e.hasOwnProperty("httpVersion") && (n = e.headers["content-type"]), n || !a.filepath && !a.filename || (n = u.lookup(a.filepath || a.filename)), n || "object" != typeof e || (n = f.DEFAULT_CONTENT_TYPE), n;
        }, f.prototype._multiPartFooter = function () {
          return function (e) {
            var a = f.LINE_BREAK;
            0 === this._streams.length && (a += this._lastBoundary()), e(a);
          }.bind(this);
        }, f.prototype._lastBoundary = function () {
          return "--" + this.getBoundary() + "--" + f.LINE_BREAK;
        }, f.prototype.getHeaders = function (e) {
          var a,
              n = {
            "content-type": "multipart/form-data; boundary=" + this.getBoundary()
          };

          for (a in e) {
            e.hasOwnProperty(a) && (n[a.toLowerCase()] = e[a]);
          }

          return n;
        }, f.prototype.setBoundary = function (e) {
          this._boundary = e;
        }, f.prototype.getBoundary = function () {
          return this._boundary || this._generateBoundary(), this._boundary;
        }, f.prototype.getBuffer = function () {
          for (var e = new Buffer.alloc(0), a = this.getBoundary(), n = 0, i = this._streams.length; n < i; n++) {
            "function" != typeof this._streams[n] && (e = Buffer.isBuffer(this._streams[n]) ? Buffer.concat([e, this._streams[n]]) : Buffer.concat([e, Buffer.from(this._streams[n])]), "string" == typeof this._streams[n] && this._streams[n].substring(2, a.length + 2) === a || (e = Buffer.concat([e, Buffer.from(f.LINE_BREAK)])));
          }

          return Buffer.concat([e, Buffer.from(this._lastBoundary())]);
        }, f.prototype._generateBoundary = function () {
          for (var e = "--------------------------", a = 0; a < 24; a++) {
            e += Math.floor(10 * Math.random()).toString(16);
          }

          this._boundary = e;
        }, f.prototype.getLengthSync = function () {
          var e = this._overheadLength + this._valueLength;
          return this._streams.length && (e += this._lastBoundary().length), this.hasKnownLength() || this._error(new Error("Cannot calculate proper length in synchronous way.")), e;
        }, f.prototype.hasKnownLength = function () {
          var e = !0;
          return this._valuesToMeasure.length && (e = !1), e;
        }, f.prototype.getLength = function (e) {
          var a = this._overheadLength + this._valueLength;
          this._streams.length && (a += this._lastBoundary().length), this._valuesToMeasure.length ? m.parallel(this._valuesToMeasure, this._lengthRetriever, function (n, i) {
            n ? e(n) : (i.forEach(function (e) {
              a += e;
            }), e(null, a));
          }) : process.nextTick(e.bind(this, null, a));
        }, f.prototype.submit = function (e, a) {
          var n,
              i,
              t = {
            method: "post"
          };
          return "string" == typeof e ? (e = c(e), i = d({
            port: e.port,
            path: e.pathname,
            host: e.hostname,
            protocol: e.protocol
          }, t)) : (i = d(e, t)).port || (i.port = "https:" == i.protocol ? 443 : 80), i.headers = this.getHeaders(e.headers), n = "https:" == i.protocol ? r.request(i) : o.request(i), this.getLength(function (e, i) {
            if (e && "Unknown stream" !== e) this._error(e);else if (i && n.setHeader("Content-Length", i), this.pipe(n), a) {
              var t,
                  s = function s(e, i) {
                return n.removeListener("error", s), n.removeListener("response", t), a.call(this, e, i);
              };

              t = s.bind(this, null), n.on("error", s), n.on("response", t);
            }
          }.bind(this)), n;
        }, f.prototype._error = function (e) {
          this.error || (this.error = e, this.pause(), this.emit("error", e));
        }, f.prototype.toString = function () {
          return "[object FormData]";
        };
      },
      2275: function _(e) {
        e.exports = function (e, a) {
          return Object.keys(a).forEach(function (n) {
            e[n] = e[n] || a[n];
          }), e;
        };
      },
      6560: function _(e) {
        "use strict";

        e.exports = function (e, a) {
          a = a || process.argv;
          var n = e.startsWith("-") ? "" : 1 === e.length ? "-" : "--",
              i = a.indexOf(n + e),
              t = a.indexOf("--");
          return -1 !== i && (-1 === t || i < t);
        };
      },
      8738: function _(e) {
        function a(e) {
          return !!e.constructor && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
        }

        e.exports = function (e) {
          return null != e && (a(e) || function (e) {
            return "function" == typeof e.readFloatLE && "function" == typeof e.slice && a(e.slice(0, 0));
          }(e) || !!e._isBuffer);
        };
      },
      2568: function _(e, a, n) {
        var i, t, s, o, _r2;

        i = n(1012), t = n(487).utf8, s = n(8738), o = n(487).bin, (_r2 = function r(e, a) {
          e.constructor == String ? e = a && "binary" === a.encoding ? o.stringToBytes(e) : t.stringToBytes(e) : s(e) ? e = Array.prototype.slice.call(e, 0) : Array.isArray(e) || e.constructor === Uint8Array || (e = e.toString());

          for (var n = i.bytesToWords(e), c = 8 * e.length, p = 1732584193, l = -271733879, u = -1732584194, m = 271733878, d = 0; d < n.length; d++) {
            n[d] = 16711935 & (n[d] << 8 | n[d] >>> 24) | 4278255360 & (n[d] << 24 | n[d] >>> 8);
          }

          n[c >>> 5] |= 128 << c % 32, n[14 + (c + 64 >>> 9 << 4)] = c;
          var f = _r2._ff,
              h = _r2._gg,
              x = _r2._hh,
              v = _r2._ii;

          for (d = 0; d < n.length; d += 16) {
            var g = p,
                b = l,
                y = u,
                w = m;
            p = f(p, l, u, m, n[d + 0], 7, -680876936), m = f(m, p, l, u, n[d + 1], 12, -389564586), u = f(u, m, p, l, n[d + 2], 17, 606105819), l = f(l, u, m, p, n[d + 3], 22, -1044525330), p = f(p, l, u, m, n[d + 4], 7, -176418897), m = f(m, p, l, u, n[d + 5], 12, 1200080426), u = f(u, m, p, l, n[d + 6], 17, -1473231341), l = f(l, u, m, p, n[d + 7], 22, -45705983), p = f(p, l, u, m, n[d + 8], 7, 1770035416), m = f(m, p, l, u, n[d + 9], 12, -1958414417), u = f(u, m, p, l, n[d + 10], 17, -42063), l = f(l, u, m, p, n[d + 11], 22, -1990404162), p = f(p, l, u, m, n[d + 12], 7, 1804603682), m = f(m, p, l, u, n[d + 13], 12, -40341101), u = f(u, m, p, l, n[d + 14], 17, -1502002290), p = h(p, l = f(l, u, m, p, n[d + 15], 22, 1236535329), u, m, n[d + 1], 5, -165796510), m = h(m, p, l, u, n[d + 6], 9, -1069501632), u = h(u, m, p, l, n[d + 11], 14, 643717713), l = h(l, u, m, p, n[d + 0], 20, -373897302), p = h(p, l, u, m, n[d + 5], 5, -701558691), m = h(m, p, l, u, n[d + 10], 9, 38016083), u = h(u, m, p, l, n[d + 15], 14, -660478335), l = h(l, u, m, p, n[d + 4], 20, -405537848), p = h(p, l, u, m, n[d + 9], 5, 568446438), m = h(m, p, l, u, n[d + 14], 9, -1019803690), u = h(u, m, p, l, n[d + 3], 14, -187363961), l = h(l, u, m, p, n[d + 8], 20, 1163531501), p = h(p, l, u, m, n[d + 13], 5, -1444681467), m = h(m, p, l, u, n[d + 2], 9, -51403784), u = h(u, m, p, l, n[d + 7], 14, 1735328473), p = x(p, l = h(l, u, m, p, n[d + 12], 20, -1926607734), u, m, n[d + 5], 4, -378558), m = x(m, p, l, u, n[d + 8], 11, -2022574463), u = x(u, m, p, l, n[d + 11], 16, 1839030562), l = x(l, u, m, p, n[d + 14], 23, -35309556), p = x(p, l, u, m, n[d + 1], 4, -1530992060), m = x(m, p, l, u, n[d + 4], 11, 1272893353), u = x(u, m, p, l, n[d + 7], 16, -155497632), l = x(l, u, m, p, n[d + 10], 23, -1094730640), p = x(p, l, u, m, n[d + 13], 4, 681279174), m = x(m, p, l, u, n[d + 0], 11, -358537222), u = x(u, m, p, l, n[d + 3], 16, -722521979), l = x(l, u, m, p, n[d + 6], 23, 76029189), p = x(p, l, u, m, n[d + 9], 4, -640364487), m = x(m, p, l, u, n[d + 12], 11, -421815835), u = x(u, m, p, l, n[d + 15], 16, 530742520), p = v(p, l = x(l, u, m, p, n[d + 2], 23, -995338651), u, m, n[d + 0], 6, -198630844), m = v(m, p, l, u, n[d + 7], 10, 1126891415), u = v(u, m, p, l, n[d + 14], 15, -1416354905), l = v(l, u, m, p, n[d + 5], 21, -57434055), p = v(p, l, u, m, n[d + 12], 6, 1700485571), m = v(m, p, l, u, n[d + 3], 10, -1894986606), u = v(u, m, p, l, n[d + 10], 15, -1051523), l = v(l, u, m, p, n[d + 1], 21, -2054922799), p = v(p, l, u, m, n[d + 8], 6, 1873313359), m = v(m, p, l, u, n[d + 15], 10, -30611744), u = v(u, m, p, l, n[d + 6], 15, -1560198380), l = v(l, u, m, p, n[d + 13], 21, 1309151649), p = v(p, l, u, m, n[d + 4], 6, -145523070), m = v(m, p, l, u, n[d + 11], 10, -1120210379), u = v(u, m, p, l, n[d + 2], 15, 718787259), l = v(l, u, m, p, n[d + 9], 21, -343485551), p = p + g >>> 0, l = l + b >>> 0, u = u + y >>> 0, m = m + w >>> 0;
          }

          return i.endian([p, l, u, m]);
        })._ff = function (e, a, n, i, t, s, o) {
          var r = e + (a & n | ~a & i) + (t >>> 0) + o;
          return (r << s | r >>> 32 - s) + a;
        }, _r2._gg = function (e, a, n, i, t, s, o) {
          var r = e + (a & i | n & ~i) + (t >>> 0) + o;
          return (r << s | r >>> 32 - s) + a;
        }, _r2._hh = function (e, a, n, i, t, s, o) {
          var r = e + (a ^ n ^ i) + (t >>> 0) + o;
          return (r << s | r >>> 32 - s) + a;
        }, _r2._ii = function (e, a, n, i, t, s, o) {
          var r = e + (n ^ (a | ~i)) + (t >>> 0) + o;
          return (r << s | r >>> 32 - s) + a;
        }, _r2._blocksize = 16, _r2._digestsize = 16, e.exports = function (e, a) {
          if (null == e) throw new Error("Illegal argument " + e);
          var n = i.wordsToBytes(_r2(e, a));
          return a && a.asBytes ? n : a && a.asString ? o.bytesToString(n) : i.bytesToHex(n);
        };
      },
      5234: function _(e, a, n) {
        e.exports = n(3765);
      },
      983: function _(e, a, n) {
        "use strict";

        var i,
            t,
            s,
            o = n(5234),
            r = n(1017).extname,
            c = /^\s*([^;\s]*)(?:;|\s|$)/,
            p = /^text\//i;

        function l(e) {
          if (!e || "string" != typeof e) return !1;
          var a = c.exec(e),
              n = a && o[a[1].toLowerCase()];
          return n && n.charset ? n.charset : !(!a || !p.test(a[1])) && "UTF-8";
        }

        a.charset = l, a.charsets = {
          lookup: l
        }, a.contentType = function (e) {
          if (!e || "string" != typeof e) return !1;
          var n = -1 === e.indexOf("/") ? a.lookup(e) : e;
          if (!n) return !1;

          if (-1 === n.indexOf("charset")) {
            var i = a.charset(n);
            i && (n += "; charset=" + i.toLowerCase());
          }

          return n;
        }, a.extension = function (e) {
          if (!e || "string" != typeof e) return !1;
          var n = c.exec(e),
              i = n && a.extensions[n[1].toLowerCase()];
          return !(!i || !i.length) && i[0];
        }, a.extensions = Object.create(null), a.lookup = function (e) {
          if (!e || "string" != typeof e) return !1;
          var n = r("x." + e).toLowerCase().substr(1);
          return n && a.types[n] || !1;
        }, a.types = Object.create(null), i = a.extensions, t = a.types, s = ["nginx", "apache", void 0, "iana"], Object.keys(o).forEach(function (e) {
          var a = o[e],
              n = a.extensions;

          if (n && n.length) {
            i[e] = n;

            for (var r = 0; r < n.length; r++) {
              var c = n[r];

              if (t[c]) {
                var p = s.indexOf(o[t[c]].source),
                    l = s.indexOf(a.source);
                if ("application/octet-stream" !== t[c] && (p > l || p === l && "application/" === t[c].substr(0, 12))) continue;
              }

              t[c] = e;
            }
          }
        });
      },
      9271: function _(e, a) {
        var n, i;
        void 0 === (i = "function" == typeof (n = function n() {
          "use strict";

          var e = Object.prototype.hasOwnProperty,
              a = Object.prototype.toString,
              n = "boolean" == typeof new RegExp().sticky;

          function i(e) {
            return e && "[object RegExp]" === a.call(e);
          }

          function t(e) {
            return e && "object" == typeof e && !i(e) && !Array.isArray(e);
          }

          function s(e) {
            return "(" + e + ")";
          }

          function o(e) {
            return e.length ? "(?:" + e.map(function (e) {
              return "(?:" + e + ")";
            }).join("|") + ")" : "(?!)";
          }

          function r(e) {
            if ("string" == typeof e) return "(?:" + (e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&") + ")");

            if (i(e)) {
              if (e.ignoreCase) throw new Error("RegExp /i flag not allowed");
              if (e.global) throw new Error("RegExp /g flag is implied");
              if (e.sticky) throw new Error("RegExp /y flag is implied");
              if (e.multiline) throw new Error("RegExp /m flag is implied");
              return e.source;
            }

            throw new Error("Not a pattern: " + e);
          }

          function c(a, n) {
            if (t(n) || (n = {
              match: n
            }), n.include) throw new Error("Matching rules cannot also include states");
            var s = {
              defaultType: a,
              lineBreaks: !!n.error || !!n.fallback,
              pop: !1,
              next: null,
              push: null,
              error: !1,
              fallback: !1,
              value: null,
              type: null,
              shouldThrow: !1
            };

            for (var o in n) {
              e.call(n, o) && (s[o] = n[o]);
            }

            if ("string" == typeof s.type && a !== s.type) throw new Error("Type transform cannot be a string (type '" + s.type + "' for token '" + a + "')");
            var r = s.match;
            return s.match = Array.isArray(r) ? r : r ? [r] : [], s.match.sort(function (e, a) {
              return i(e) && i(a) ? 0 : i(a) ? -1 : i(e) ? 1 : a.length - e.length;
            }), s;
          }

          function p(e) {
            return Array.isArray(e) ? function (e) {
              for (var a = [], n = 0; n < e.length; n++) {
                var i = e[n];
                if (i.include) for (var t = [].concat(i.include), s = 0; s < t.length; s++) {
                  a.push({
                    include: t[s]
                  });
                } else {
                  if (!i.type) throw new Error("Rule has no type: " + JSON.stringify(i));
                  a.push(c(i.type, i));
                }
              }

              return a;
            }(e) : function (e) {
              for (var a = Object.getOwnPropertyNames(e), n = [], i = 0; i < a.length; i++) {
                var s = a[i],
                    o = e[s],
                    r = [].concat(o);

                if ("include" !== s) {
                  var p = [];
                  r.forEach(function (e) {
                    t(e) ? (p.length && n.push(c(s, p)), n.push(c(s, e)), p = []) : p.push(e);
                  }), p.length && n.push(c(s, p));
                } else for (var l = 0; l < r.length; l++) {
                  n.push({
                    include: r[l]
                  });
                }
              }

              return n;
            }(e);
          }

          var l = c("error", {
            lineBreaks: !0,
            shouldThrow: !0
          });

          function u(e, a) {
            for (var t = null, c = Object.create(null), p = !0, u = null, m = [], d = [], f = 0; f < e.length; f++) {
              e[f].fallback && (p = !1);
            }

            for (f = 0; f < e.length; f++) {
              var h = e[f];
              if (h.include) throw new Error("Inheritance is not allowed in stateless lexers");

              if (h.error || h.fallback) {
                if (t) throw !h.fallback == !t.fallback ? new Error("Multiple " + (h.fallback ? "fallback" : "error") + " rules not allowed (for token '" + h.defaultType + "')") : new Error("fallback and error are mutually exclusive (for token '" + h.defaultType + "')");
                t = h;
              }

              var x = h.match.slice();
              if (p) for (; x.length && "string" == typeof x[0] && 1 === x[0].length;) {
                c[x.shift().charCodeAt(0)] = h;
              }

              if (h.pop || h.push || h.next) {
                if (!a) throw new Error("State-switching options are not allowed in stateless lexers (for token '" + h.defaultType + "')");
                if (h.fallback) throw new Error("State-switching options are not allowed on fallback tokens (for token '" + h.defaultType + "')");
              }

              if (0 !== x.length) {
                p = !1, m.push(h);

                for (var v = 0; v < x.length; v++) {
                  var g = x[v];
                  if (i(g)) if (null === u) u = g.unicode;else if (u !== g.unicode && !1 === h.fallback) throw new Error("If one rule is /u then all must be");
                }

                var b = o(x.map(r)),
                    y = new RegExp(b);
                if (y.test("")) throw new Error("RegExp matches empty string: " + y);
                if (new RegExp("|" + b).exec("").length - 1 > 0) throw new Error("RegExp has capture groups: " + y + "\nUse (?: … ) instead");
                if (!h.lineBreaks && y.test("\n")) throw new Error("Rule should declare lineBreaks: " + y);
                d.push(s(b));
              }
            }

            var w = t && t.fallback,
                k = n && !w ? "ym" : "gm",
                j = n || w ? "" : "|";
            return !0 === u && (k += "u"), {
              regexp: new RegExp(o(d) + j, k),
              groups: m,
              fast: c,
              error: t || l
            };
          }

          function m(e, a, n) {
            var i = e && (e.push || e.next);
            if (i && !n[i]) throw new Error("Missing state '" + i + "' (in token '" + e.defaultType + "' of state '" + a + "')");
            if (e && e.pop && 1 != +e.pop) throw new Error("pop must be 1 (in token '" + e.defaultType + "' of state '" + a + "')");
          }

          var d = function d(e, a) {
            this.startState = a, this.states = e, this.buffer = "", this.stack = [], this.reset();
          };

          d.prototype.reset = function (e, a) {
            return this.buffer = e || "", this.index = 0, this.line = a ? a.line : 1, this.col = a ? a.col : 1, this.queuedToken = a ? a.queuedToken : null, this.queuedThrow = a ? a.queuedThrow : null, this.setState(a ? a.state : this.startState), this.stack = a && a.stack ? a.stack.slice() : [], this;
          }, d.prototype.save = function () {
            return {
              line: this.line,
              col: this.col,
              state: this.state,
              stack: this.stack.slice(),
              queuedToken: this.queuedToken,
              queuedThrow: this.queuedThrow
            };
          }, d.prototype.setState = function (e) {
            if (e && this.state !== e) {
              this.state = e;
              var a = this.states[e];
              this.groups = a.groups, this.error = a.error, this.re = a.regexp, this.fast = a.fast;
            }
          }, d.prototype.popState = function () {
            this.setState(this.stack.pop());
          }, d.prototype.pushState = function (e) {
            this.stack.push(this.state), this.setState(e);
          };
          var f = n ? function (e, a) {
            return e.exec(a);
          } : function (e, a) {
            var n = e.exec(a);
            return 0 === n[0].length ? null : n;
          };

          function h() {
            return this.value;
          }

          if (d.prototype._getGroup = function (e) {
            for (var a = this.groups.length, n = 0; n < a; n++) {
              if (void 0 !== e[n + 1]) return this.groups[n];
            }

            throw new Error("Cannot find token type for matched text");
          }, d.prototype.next = function () {
            var e = this.index;

            if (this.queuedGroup) {
              var a = this._token(this.queuedGroup, this.queuedText, e);

              return this.queuedGroup = null, this.queuedText = "", a;
            }

            var n = this.buffer;

            if (e !== n.length) {
              if (o = this.fast[n.charCodeAt(e)]) return this._token(o, n.charAt(e), e);
              var i = this.re;
              i.lastIndex = e;
              var t = f(i, n),
                  s = this.error;
              if (null == t) return this._token(s, n.slice(e, n.length), e);

              var o = this._getGroup(t),
                  r = t[0];

              return s.fallback && t.index !== e ? (this.queuedGroup = o, this.queuedText = r, this._token(s, n.slice(e, t.index), e)) : this._token(o, r, e);
            }
          }, d.prototype._token = function (e, a, n) {
            var i = 0;

            if (e.lineBreaks) {
              var t = /\n/g,
                  s = 1;
              if ("\n" === a) i = 1;else for (; t.exec(a);) {
                i++, s = t.lastIndex;
              }
            }

            var o = {
              type: "function" == typeof e.type && e.type(a) || e.defaultType,
              value: "function" == typeof e.value ? e.value(a) : a,
              text: a,
              toString: h,
              offset: n,
              lineBreaks: i,
              line: this.line,
              col: this.col
            },
                r = a.length;
            if (this.index += r, this.line += i, 0 !== i ? this.col = r - s + 1 : this.col += r, e.shouldThrow) throw new Error(this.formatError(o, "invalid syntax"));
            return e.pop ? this.popState() : e.push ? this.pushState(e.push) : e.next && this.setState(e.next), o;
          }, "undefined" != typeof Symbol && Symbol.iterator) {
            var x = function x(e) {
              this.lexer = e;
            };

            x.prototype.next = function () {
              var e = this.lexer.next();
              return {
                value: e,
                done: !e
              };
            }, x.prototype[Symbol.iterator] = function () {
              return this;
            }, d.prototype[Symbol.iterator] = function () {
              return new x(this);
            };
          }

          return d.prototype.formatError = function (e, a) {
            if (null == e) {
              var n = this.buffer.slice(this.index);
              e = {
                text: n,
                offset: this.index,
                lineBreaks: -1 === n.indexOf("\n") ? 0 : 1,
                line: this.line,
                col: this.col
              };
            }

            var i = Math.max(0, e.offset - e.col + 1),
                t = e.lineBreaks ? e.text.indexOf("\n") : e.text.length,
                s = this.buffer.substring(i, e.offset + t);
            return a += " at line " + e.line + " col " + e.col + ":\n\n", (a += "  " + s + "\n") + "  " + Array(e.col).join(" ") + "^";
          }, d.prototype.clone = function () {
            return new d(this.states, this.state);
          }, d.prototype.has = function (e) {
            return !0;
          }, {
            compile: function compile(e) {
              var a = u(p(e));
              return new d({
                start: a
              }, "start");
            },
            states: function states(e, a) {
              var n = e.$all ? p(e.$all) : [];
              delete e.$all;
              var i = Object.getOwnPropertyNames(e);
              a || (a = i[0]);

              for (var t = Object.create(null), s = 0; s < i.length; s++) {
                t[b = i[s]] = p(e[b]).concat(n);
              }

              for (s = 0; s < i.length; s++) {
                for (var o = t[b = i[s]], r = Object.create(null), c = 0; c < o.length; c++) {
                  var l = o[c];

                  if (l.include) {
                    var f = [c, 1];

                    if (l.include !== b && !r[l.include]) {
                      r[l.include] = !0;
                      var h = t[l.include];
                      if (!h) throw new Error("Cannot include nonexistent state '" + l.include + "' (in state '" + b + "')");

                      for (var x = 0; x < h.length; x++) {
                        var v = h[x];
                        -1 === o.indexOf(v) && f.push(v);
                      }
                    }

                    o.splice.apply(o, f), c--;
                  }
                }
              }

              var g = Object.create(null);

              for (s = 0; s < i.length; s++) {
                var b;
                g[b = i[s]] = u(t[b], !0);
              }

              for (s = 0; s < i.length; s++) {
                var y = i[s],
                    w = g[y],
                    k = w.groups;

                for (c = 0; c < k.length; c++) {
                  m(k[c], y, g);
                }

                var j = Object.getOwnPropertyNames(w.fast);

                for (c = 0; c < j.length; c++) {
                  m(w.fast[j[c]], y, g);
                }
              }

              return new d(g, a);
            },
            error: Object.freeze({
              error: !0
            }),
            fallback: Object.freeze({
              fallback: !0
            }),
            keywords: function keywords(e) {
              for (var a = Object.create(null), n = Object.create(null), i = Object.getOwnPropertyNames(e), t = 0; t < i.length; t++) {
                var s = i[t],
                    o = e[s];
                (Array.isArray(o) ? o : [o]).forEach(function (e) {
                  if ((n[e.length] = n[e.length] || []).push(e), "string" != typeof e) throw new Error("keyword must be string (in keyword '" + s + "')");
                  a[e] = s;
                });
              }

              function r(e) {
                return JSON.stringify(e);
              }

              var c = "";

              for (var p in c += "switch (value.length) {\n", n) {
                var l = n[p];
                c += "case " + p + ":\n", c += "switch (value) {\n", l.forEach(function (e) {
                  var n = a[e];
                  c += "case " + r(e) + ": return " + r(n) + "\n";
                }), c += "}\n";
              }

              return c += "}\n", Function("value", c);
            }
          };
        }) ? n.apply(a, []) : n) || (e.exports = i);
      },
      7824: function _(e) {
        var a = 1e3,
            n = 60 * a,
            i = 60 * n,
            t = 24 * i;

        function s(e, a, n, i) {
          var t = a >= 1.5 * n;
          return Math.round(e / n) + " " + i + (t ? "s" : "");
        }

        e.exports = function (e, o) {
          o = o || {};
          var r,
              c,
              p = typeof e;
          if ("string" === p && e.length > 0) return function (e) {
            if (!((e = String(e)).length > 100)) {
              var s = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(e);

              if (s) {
                var o = parseFloat(s[1]);

                switch ((s[2] || "ms").toLowerCase()) {
                  case "years":
                  case "year":
                  case "yrs":
                  case "yr":
                  case "y":
                    return 315576e5 * o;

                  case "weeks":
                  case "week":
                  case "w":
                    return 6048e5 * o;

                  case "days":
                  case "day":
                  case "d":
                    return o * t;

                  case "hours":
                  case "hour":
                  case "hrs":
                  case "hr":
                  case "h":
                    return o * i;

                  case "minutes":
                  case "minute":
                  case "mins":
                  case "min":
                  case "m":
                    return o * n;

                  case "seconds":
                  case "second":
                  case "secs":
                  case "sec":
                  case "s":
                    return o * a;

                  case "milliseconds":
                  case "millisecond":
                  case "msecs":
                  case "msec":
                  case "ms":
                    return o;

                  default:
                    return;
                }
              }
            }
          }(e);
          if ("number" === p && isFinite(e)) return o.long ? (r = e, (c = Math.abs(r)) >= t ? s(r, c, t, "day") : c >= i ? s(r, c, i, "hour") : c >= n ? s(r, c, n, "minute") : c >= a ? s(r, c, a, "second") : r + " ms") : function (e) {
            var s = Math.abs(e);
            return s >= t ? Math.round(e / t) + "d" : s >= i ? Math.round(e / i) + "h" : s >= n ? Math.round(e / n) + "m" : s >= a ? Math.round(e / a) + "s" : e + "ms";
          }(e);
          throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(e));
        };
      },
      2130: function _(e, a, n) {
        "use strict";

        var i = n(2037),
            t = n(6560),
            s = process.env;
        var o;

        function r(e) {
          var a = function (e) {
            if (!1 === o) return 0;
            if (t("color=16m") || t("color=full") || t("color=truecolor")) return 3;
            if (t("color=256")) return 2;
            if (e && !e.isTTY && !0 !== o) return 0;
            var a = o ? 1 : 0;

            if ("win32" === process.platform) {
              var _e21 = i.release().split(".");

              return Number(process.versions.node.split(".")[0]) >= 8 && Number(_e21[0]) >= 10 && Number(_e21[2]) >= 10586 ? Number(_e21[2]) >= 14931 ? 3 : 2 : 1;
            }

            if ("CI" in s) return ["TRAVIS", "CIRCLECI", "APPVEYOR", "GITLAB_CI"].some(function (e) {
              return e in s;
            }) || "codeship" === s.CI_NAME ? 1 : a;
            if ("TEAMCITY_VERSION" in s) return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(s.TEAMCITY_VERSION) ? 1 : 0;
            if ("truecolor" === s.COLORTERM) return 3;

            if ("TERM_PROGRAM" in s) {
              var _e22 = parseInt((s.TERM_PROGRAM_VERSION || "").split(".")[0], 10);

              switch (s.TERM_PROGRAM) {
                case "iTerm.app":
                  return _e22 >= 3 ? 3 : 2;

                case "Apple_Terminal":
                  return 2;
              }
            }

            return /-256(color)?$/i.test(s.TERM) ? 2 : /^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(s.TERM) || "COLORTERM" in s ? 1 : (s.TERM, a);
          }(e);

          return function (e) {
            return 0 !== e && {
              level: e,
              hasBasic: !0,
              has256: e >= 2,
              has16m: e >= 3
            };
          }(a);
        }

        t("no-color") || t("no-colors") || t("color=false") ? o = !1 : (t("color") || t("colors") || t("color=true") || t("color=always")) && (o = !0), "FORCE_COLOR" in s && (o = 0 === s.FORCE_COLOR.length || 0 !== parseInt(s.FORCE_COLOR, 10)), e.exports = {
          supportsColor: r,
          stdout: r(process.stdout),
          stderr: r(process.stderr)
        };
      },
      9491: function _(e) {
        "use strict";

        e.exports = require("assert");
      },
      7147: function _(e) {
        "use strict";

        e.exports = require("fs");
      },
      3685: function _(e) {
        "use strict";

        e.exports = require("http");
      },
      5687: function _(e) {
        "use strict";

        e.exports = require("https");
      },
      2037: function _(e) {
        "use strict";

        e.exports = require("os");
      },
      1017: function _(e) {
        "use strict";

        e.exports = require("path");
      },
      2781: function _(e) {
        "use strict";

        e.exports = require("stream");
      },
      6224: function _(e) {
        "use strict";

        e.exports = require("tty");
      },
      7310: function _(e) {
        "use strict";

        e.exports = require("url");
      },
      3837: function _(e) {
        "use strict";

        e.exports = require("util");
      },
      9796: function _(e) {
        "use strict";

        e.exports = require("zlib");
      },
      5545: function _(e, a, n) {
        "use strict";

        var i = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        }), a.lexer = a.states = void 0;
        var t = i(n(9271));
        a.states = {
          body: {
            doubleapos: {
              match: "''",
              value: function value() {
                return "'";
              }
            },
            quoted: {
              lineBreaks: !0,
              match: /'[#\{\}](?:(?:(?![])[\s\S])*?(?:(?!')[\s\S]))?'(?!')/,
              value: function value(e) {
                return e.slice(1, -1).replace(/''/g, "'");
              }
            },
            argument: {
              lineBreaks: !0,
              match: /\{[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:(?![\t-\r -\/:-@\[-\^`\{-~\x85\xA1-\xA7\xA9\xAB\xAC\xAE\xB0\xB1\xB6\xBB\xBF\xD7\xF7\u200E-\u2029\u2030-\u203E\u2041-\u2053\u2055-\u205E\u2190-\u245F\u2500-\u2775\u2794-\u2BFF\u2E00-\u2E7F\u3001-\u3003\u3008-\u3020\u3030\uFD3E\uFD3F\uFE45\uFE46])[\s\S])+[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*/,
              push: "arg",
              value: function value(e) {
                return e.substring(1).trim();
              }
            },
            octothorpe: "#",
            end: {
              match: "}",
              pop: 1
            },
            content: {
              lineBreaks: !0,
              match: /(?:(?![])[\s\S])(?:(?![#'\{\}])[\s\S])*/
            }
          },
          arg: {
            select: {
              lineBreaks: !0,
              match: /,[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:plural|select|selectordinal)[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*,[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*/,
              next: "select",
              value: function value(e) {
                return e.split(",")[1].trim();
              }
            },
            "func-args": {
              lineBreaks: !0,
              match: /,[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:(?![\t-\r -\/:-@\[-\^`\{-~\x85\xA1-\xA7\xA9\xAB\xAC\xAE\xB0\xB1\xB6\xBB\xBF\xD7\xF7\u200E-\u2029\u2030-\u203E\u2041-\u2053\u2055-\u205E\u2190-\u245F\u2500-\u2775\u2794-\u2BFF\u2E00-\u2E7F\u3001-\u3003\u3008-\u3020\u3030\uFD3E\uFD3F\uFE45\uFE46])[\s\S])+[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*,/,
              next: "body",
              value: function value(e) {
                return e.split(",")[1].trim();
              }
            },
            "func-simple": {
              lineBreaks: !0,
              match: /,[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:(?![\t-\r -\/:-@\[-\^`\{-~\x85\xA1-\xA7\xA9\xAB\xAC\xAE\xB0\xB1\xB6\xBB\xBF\xD7\xF7\u200E-\u2029\u2030-\u203E\u2041-\u2053\u2055-\u205E\u2190-\u245F\u2500-\u2775\u2794-\u2BFF\u2E00-\u2E7F\u3001-\u3003\u3008-\u3020\u3030\uFD3E\uFD3F\uFE45\uFE46])[\s\S])+[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*/,
              value: function value(e) {
                return e.substring(1).trim();
              }
            },
            end: {
              match: "}",
              pop: 1
            }
          },
          select: {
            offset: {
              lineBreaks: !0,
              match: /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*offset[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*[0-9]+[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*/,
              value: function value(e) {
                return e.split(":")[1].trim();
              }
            },
            case: {
              lineBreaks: !0,
              match: /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:=[0-9]+|(?:(?![\t-\r -\/:-@\[-\^`\{-~\x85\xA1-\xA7\xA9\xAB\xAC\xAE\xB0\xB1\xB6\xBB\xBF\xD7\xF7\u200E-\u2029\u2030-\u203E\u2041-\u2053\u2055-\u205E\u2190-\u245F\u2500-\u2775\u2794-\u2BFF\u2E00-\u2E7F\u3001-\u3003\u3008-\u3020\u3030\uFD3E\uFD3F\uFE45\uFE46])[\s\S])+)[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\{/,
              push: "body",
              value: function value(e) {
                return e.substring(0, e.indexOf("{")).trim();
              }
            },
            end: {
              match: /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\}/,
              pop: 1
            }
          }
        }, a.lexer = t.default.states(a.states);
      },
      7564: function _(e, a, n) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        }), a.parse = a.ParseError = void 0;

        var i = n(5545),
            t = function t(e) {
          return {
            offset: e.offset,
            line: e.line,
            col: e.col,
            text: e.text,
            lineBreaks: e.lineBreaks
          };
        },
            s = function s(e) {
          return "plural" === e || "select" === e || "selectordinal" === e;
        },
            o = ["number", "date", "time", "spellout", "ordinal", "duration"],
            r = ["zero", "one", "two", "few", "many", "other"];

        var c = /*#__PURE__*/function (_Error3) {
          _inherits(c, _Error3);

          var _super10 = _createSuper(c);

          function c(e, a) {
            _classCallCheck(this, c);

            return _super10.call(this, i.lexer.formatError(e, a));
          }

          return _createClass(c);
        }( /*#__PURE__*/_wrapNativeSuper(Error));

        a.ParseError = c;

        var p = /*#__PURE__*/function () {
          function p(e, a) {
            _classCallCheck(this, p);

            this.lexer = i.lexer.reset(e), this.cardinalKeys = a && a.cardinal || r, this.ordinalKeys = a && a.ordinal || r, this.strict = a && a.strict || !1;
          }

          _createClass(p, [{
            key: "parse",
            value: function parse() {
              return this.parseBody(!1, !0);
            }
          }, {
            key: "checkSelectKey",
            value: function checkSelectKey(e, a, n) {
              if ("=" === n[0]) {
                if ("select" === a) throw new c(e, "The case ".concat(n, " is not valid with select"));
              } else if ("select" !== a) {
                var _i28 = "plural" === a ? this.cardinalKeys : this.ordinalKeys;

                if (_i28.length > 0 && !_i28.includes(n)) throw new c(e, "The ".concat(a, " case ").concat(n, " is not valid in this locale"));
              }
            }
          }, {
            key: "parseSelect",
            value: function parseSelect(_ref10, a, n, i) {
              var e = _ref10.value;
              var s = {
                type: i,
                arg: e,
                cases: [],
                ctx: n
              };
              "plural" === i || "selectordinal" === i ? a = !0 : this.strict && (a = !1);

              var _iterator12 = _createForOfIteratorHelper(this.lexer),
                  _step12;

              try {
                for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                  var _e23 = _step12.value;

                  switch (_e23.type) {
                    case "offset":
                      if ("select" === i) throw new c(_e23, "Unexpected plural offset for select");
                      if (s.cases.length > 0) throw new c(_e23, "Plural offset must be set before cases");
                      s.pluralOffset = Number(_e23.value), n.text += _e23.text, n.lineBreaks += _e23.lineBreaks;
                      break;

                    case "case":
                      this.checkSelectKey(_e23, i, _e23.value), s.cases.push({
                        key: _e23.value,
                        tokens: this.parseBody(a),
                        ctx: t(_e23)
                      });
                      break;

                    case "end":
                      return s;

                    default:
                      throw new c(_e23, "Unexpected lexer token: ".concat(_e23.type));
                  }
                }
              } catch (err) {
                _iterator12.e(err);
              } finally {
                _iterator12.f();
              }

              throw new c(null, "Unexpected message end");
            }
          }, {
            key: "parseArgToken",
            value: function parseArgToken(e, a) {
              var n = t(e),
                  i = this.lexer.next();
              if (!i) throw new c(null, "Unexpected message end");

              if (n.text += i.text, n.lineBreaks += i.lineBreaks, this.strict && ("func-simple" === i.type || "func-args" === i.type) && !o.includes(i.value)) {
                var _a19 = "Invalid strict mode function arg type: ".concat(i.value);

                throw new c(e, _a19);
              }

              switch (i.type) {
                case "end":
                  return {
                    type: "argument",
                    arg: e.value,
                    ctx: n
                  };

                case "func-simple":
                  {
                    var _a20 = this.lexer.next();

                    if (!_a20) throw new c(null, "Unexpected message end");
                    if ("end" !== _a20.type) throw new c(_a20, "Unexpected lexer token: ".concat(_a20.type));
                    if (n.text += _a20.text, s(i.value.toLowerCase())) throw new c(i, "Invalid type identifier: ".concat(i.value));
                    return {
                      type: "function",
                      arg: e.value,
                      key: i.value,
                      ctx: n
                    };
                  }

                case "func-args":
                  {
                    if (s(i.value.toLowerCase())) {
                      var _e24 = "Invalid type identifier: ".concat(i.value);

                      throw new c(i, _e24);
                    }

                    var _t17 = this.parseBody(!this.strict && a);

                    return this.strict && _t17.length > 0 && (_t17 = function (e, a) {
                      var n = "",
                          i = "";

                      var _iterator13 = _createForOfIteratorHelper(a),
                          _step13;

                      try {
                        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                          var _t18 = _step13.value;
                          var _a21 = _t18.ctx.text;

                          switch (i += _a21, _t18.type) {
                            case "content":
                              n += _t18.value;
                              break;

                            case "argument":
                            case "function":
                            case "octothorpe":
                              n += _a21;
                              break;

                            default:
                              throw new c(e, "Unsupported part in strict mode function arg style: ".concat(_a21));
                          }
                        }
                      } catch (err) {
                        _iterator13.e(err);
                      } finally {
                        _iterator13.f();
                      }

                      return [{
                        type: "content",
                        value: n.trim(),
                        ctx: Object.assign({}, a[0].ctx, {
                          text: i
                        })
                      }];
                    }(e, _t17)), {
                      type: "function",
                      arg: e.value,
                      key: i.value,
                      param: _t17,
                      ctx: n
                    };
                  }

                case "select":
                  if (s(i.value)) return this.parseSelect(e, a, n, i.value);
                  throw new c(i, "Unexpected select type ".concat(i.value));

                default:
                  throw new c(i, "Unexpected lexer token: ".concat(i.type));
              }
            }
          }, {
            key: "parseBody",
            value: function parseBody(e, a) {
              var n = [];
              var i = null;

              var _iterator14 = _createForOfIteratorHelper(this.lexer),
                  _step14;

              try {
                for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                  var _s9 = _step14.value;
                  if ("argument" === _s9.type) i && (i = null), n.push(this.parseArgToken(_s9, e));else if ("octothorpe" === _s9.type && e) i && (i = null), n.push({
                    type: "octothorpe",
                    ctx: t(_s9)
                  });else {
                    if ("end" === _s9.type && !a) return n;
                    {
                      var _a22 = _s9.value;

                      if (!e && "quoted" === _s9.type && "#" === _a22[0]) {
                        if (_a22.includes("{")) throw new c(_s9, "Unsupported escape pattern: ".concat(_a22));
                        _a22 = _s9.text;
                      }

                      i ? (i.value += _a22, i.ctx.text += _s9.text, i.ctx.lineBreaks += _s9.lineBreaks) : (i = {
                        type: "content",
                        value: _a22,
                        ctx: t(_s9)
                      }, n.push(i));
                    }
                  }
                }
              } catch (err) {
                _iterator14.e(err);
              } finally {
                _iterator14.f();
              }

              if (a) return n;
              throw new c(null, "Unexpected message end");
            }
          }]);

          return p;
        }();

        a.parse = function (e) {
          var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return new p(e, a).parse();
        };
      },
      8005: function _(e, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        }), a.date = void 0, a.date = function (e, a, n) {
          var i = {
            day: "numeric",
            month: "short",
            year: "numeric"
          };

          switch (n) {
            case "full":
              i.weekday = "long";

            case "long":
              i.month = "long";
              break;

            case "short":
              i.month = "numeric";
          }

          return new Date(e).toLocaleDateString(a, i);
        };
      },
      9840: function _(e, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        }), a.duration = void 0, a.duration = function (e) {
          if ("number" != typeof e && (e = Number(e)), !isFinite(e)) return String(e);
          var a = "";
          e < 0 ? (a = "-", e = Math.abs(e)) : e = Number(e);
          var n = e % 60,
              i = [Math.round(n) === n ? n : n.toFixed(3)];
          return e < 60 ? i.unshift(0) : (e = Math.round((e - Number(i[0])) / 60), i.unshift(e % 60), e >= 60 && (e = Math.round((e - Number(i[0])) / 60), i.unshift(e))), a + i.shift() + ":" + i.map(function (e) {
            return e < 10 ? "0" + String(e) : String(e);
          }).join(":");
        };
      },
      861: function _(e, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        }), a.numberPercent = a.numberInteger = a.numberCurrency = a.numberFmt = void 0;
        var n = {};

        function i(e, a) {
          var i = String(e) + JSON.stringify(a);
          return n[i] || (n[i] = new Intl.NumberFormat(e, a)), n[i];
        }

        a.numberFmt = function (e, a, n, t) {
          var s = n && n.split(":") || [],
              o = s[0],
              r = s[1];
          return i(a, {
            integer: {
              maximumFractionDigits: 0
            },
            percent: {
              style: "percent"
            },
            currency: {
              style: "currency",
              currency: r && r.trim() || t,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }
          }[o] || {}).format(e);
        }, a.numberCurrency = function (e, a, n) {
          return i(a, {
            style: "currency",
            currency: n,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(e);
        }, a.numberInteger = function (e, a) {
          return i(a, {
            maximumFractionDigits: 0
          }).format(e);
        }, a.numberPercent = function (e, a) {
          return i(a, {
            style: "percent"
          }).format(e);
        };
      },
      3597: function _(e, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        }), a.time = void 0, a.time = function (e, a, n) {
          var i = {
            second: "numeric",
            minute: "numeric",
            hour: "numeric"
          };

          switch (n) {
            case "full":
            case "long":
              i.timeZoneName = "short";
              break;

            case "short":
              delete i.second;
          }

          return new Date(e).toLocaleTimeString(a, i);
        };
      },
      7630: function _(e, a, n) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        }), a.time = a.numberPercent = a.numberInteger = a.numberFmt = a.numberCurrency = a.duration = a.date = void 0;
        var i = n(8005);
        Object.defineProperty(a, "date", {
          enumerable: !0,
          get: function get() {
            return i.date;
          }
        });
        var t = n(9840);
        Object.defineProperty(a, "duration", {
          enumerable: !0,
          get: function get() {
            return t.duration;
          }
        });
        var s = n(861);
        Object.defineProperty(a, "numberCurrency", {
          enumerable: !0,
          get: function get() {
            return s.numberCurrency;
          }
        }), Object.defineProperty(a, "numberFmt", {
          enumerable: !0,
          get: function get() {
            return s.numberFmt;
          }
        }), Object.defineProperty(a, "numberInteger", {
          enumerable: !0,
          get: function get() {
            return s.numberInteger;
          }
        }), Object.defineProperty(a, "numberPercent", {
          enumerable: !0,
          get: function get() {
            return s.numberPercent;
          }
        });
        var o = n(3597);
        Object.defineProperty(a, "time", {
          enumerable: !0,
          get: function get() {
            return o.time;
          }
        });
      },
      7249: function _(e, a) {
        "use strict";

        function n(e) {
          return n[e] || (n[e] = new Intl.NumberFormat(e));
        }

        Object.defineProperty(a, "__esModule", {
          value: !0
        }), a.reqArgs = a.select = a.plural = a.strictNumber = a.number = a._nf = void 0, a._nf = n, a.number = function (e, a, i) {
          return n(e).format(a - i);
        }, a.strictNumber = function (e, a, i, t) {
          var s = a - i;
          if (isNaN(s)) throw new Error("`" + t + "` or its offset is not a number");
          return n(e).format(s);
        }, a.plural = function (e, a, n, i, t) {
          if ({}.hasOwnProperty.call(i, e)) return i[e];
          a && (e -= a);
          var s = n(e, t);
          return s in i ? i[s] : i.other;
        }, a.select = function (e, a) {
          return {}.hasOwnProperty.call(a, e) ? a[e] : a.other;
        }, a.reqArgs = function (e, a) {
          for (var n = 0; n < e.length; ++n) {
            if (!a || void 0 === a[e[n]]) throw new Error("Message requires argument '".concat(e[n], "'"));
          }
        };
      },
      7867: function _(e, a, n) {
        var i, t;

        var s = function s(e) {
          return 1 == e ? "one" : "other";
        },
            o = function o(e) {
          return 0 == e || 1 == e ? "one" : "other";
        },
            r = function r(e) {
          return e >= 0 && e <= 1 ? "one" : "other";
        },
            c = function c(e) {
          var a = !String(e).split(".")[1];
          return 1 == e && a ? "one" : "other";
        },
            p = function p(e) {
          return "other";
        },
            l = function l(e) {
          return 1 == e ? "one" : 2 == e ? "two" : "other";
        };

        var u;
        u = {
          af: s,
          ak: o,
          am: r,
          an: s,
          ar: function ar(e) {
            var a = String(e).split("."),
                n = Number(a[0]) == e && a[0].slice(-2);
            return 0 == e ? "zero" : 1 == e ? "one" : 2 == e ? "two" : n >= 3 && n <= 10 ? "few" : n >= 11 && n <= 99 ? "many" : "other";
          },
          ars: function ars(e) {
            var a = String(e).split("."),
                n = Number(a[0]) == e && a[0].slice(-2);
            return 0 == e ? "zero" : 1 == e ? "one" : 2 == e ? "two" : n >= 3 && n <= 10 ? "few" : n >= 11 && n <= 99 ? "many" : "other";
          },
          as: r,
          asa: s,
          ast: c,
          az: s,
          bal: s,
          be: function be(e) {
            var a = String(e).split("."),
                n = Number(a[0]) == e,
                i = n && a[0].slice(-1),
                t = n && a[0].slice(-2);
            return 1 == i && 11 != t ? "one" : i >= 2 && i <= 4 && (t < 12 || t > 14) ? "few" : n && 0 == i || i >= 5 && i <= 9 || t >= 11 && t <= 14 ? "many" : "other";
          },
          bem: s,
          bez: s,
          bg: s,
          bho: o,
          bm: p,
          bn: r,
          bo: p,
          br: function br(e) {
            var a = String(e).split("."),
                n = Number(a[0]) == e,
                i = n && a[0].slice(-1),
                t = n && a[0].slice(-2),
                s = n && a[0].slice(-6);
            return 1 == i && 11 != t && 71 != t && 91 != t ? "one" : 2 == i && 12 != t && 72 != t && 92 != t ? "two" : (3 == i || 4 == i || 9 == i) && (t < 10 || t > 19) && (t < 70 || t > 79) && (t < 90 || t > 99) ? "few" : 0 != e && n && 0 == s ? "many" : "other";
          },
          brx: s,
          bs: function bs(e) {
            var a = String(e).split("."),
                n = a[0],
                i = a[1] || "",
                t = !a[1],
                s = n.slice(-1),
                o = n.slice(-2),
                r = i.slice(-1),
                c = i.slice(-2);
            return t && 1 == s && 11 != o || 1 == r && 11 != c ? "one" : t && s >= 2 && s <= 4 && (o < 12 || o > 14) || r >= 2 && r <= 4 && (c < 12 || c > 14) ? "few" : "other";
          },
          ca: c,
          ce: s,
          ceb: function ceb(e) {
            var a = String(e).split("."),
                n = a[0],
                i = a[1] || "",
                t = !a[1],
                s = n.slice(-1),
                o = i.slice(-1);
            return t && (1 == n || 2 == n || 3 == n) || t && 4 != s && 6 != s && 9 != s || !t && 4 != o && 6 != o && 9 != o ? "one" : "other";
          },
          cgg: s,
          chr: s,
          ckb: s,
          cs: function cs(e) {
            var a = String(e).split("."),
                n = a[0],
                i = !a[1];
            return 1 == e && i ? "one" : n >= 2 && n <= 4 && i ? "few" : i ? "other" : "many";
          },
          cy: function cy(e) {
            return 0 == e ? "zero" : 1 == e ? "one" : 2 == e ? "two" : 3 == e ? "few" : 6 == e ? "many" : "other";
          },
          da: function da(e) {
            var a = String(e).split("."),
                n = a[0],
                i = Number(a[0]) == e;
            return 1 != e && (i || 0 != n && 1 != n) ? "other" : "one";
          },
          de: c,
          doi: r,
          dsb: function dsb(e) {
            var a = String(e).split("."),
                n = a[0],
                i = a[1] || "",
                t = !a[1],
                s = n.slice(-2),
                o = i.slice(-2);
            return t && 1 == s || 1 == o ? "one" : t && 2 == s || 2 == o ? "two" : t && (3 == s || 4 == s) || 3 == o || 4 == o ? "few" : "other";
          },
          dv: s,
          dz: p,
          ee: s,
          el: s,
          en: c,
          eo: s,
          es: function es(e) {
            var a = String(e).split("."),
                n = a[0],
                i = !a[1],
                t = n.slice(-6);
            return 1 == e ? "one" : 0 != n && 0 == t && i ? "many" : "other";
          },
          et: c,
          eu: s,
          fa: r,
          ff: function ff(e) {
            return e >= 0 && e < 2 ? "one" : "other";
          },
          fi: c,
          fil: function fil(e) {
            var a = String(e).split("."),
                n = a[0],
                i = a[1] || "",
                t = !a[1],
                s = n.slice(-1),
                o = i.slice(-1);
            return t && (1 == n || 2 == n || 3 == n) || t && 4 != s && 6 != s && 9 != s || !t && 4 != o && 6 != o && 9 != o ? "one" : "other";
          },
          fo: s,
          fr: function fr(e) {
            var a = String(e).split("."),
                n = a[0],
                i = !a[1],
                t = n.slice(-6);
            return e >= 0 && e < 2 ? "one" : 0 != n && 0 == t && i ? "many" : "other";
          },
          fur: s,
          fy: c,
          ga: function ga(e) {
            var a = String(e).split("."),
                n = Number(a[0]) == e;
            return 1 == e ? "one" : 2 == e ? "two" : n && e >= 3 && e <= 6 ? "few" : n && e >= 7 && e <= 10 ? "many" : "other";
          },
          gd: function gd(e) {
            var a = String(e).split("."),
                n = Number(a[0]) == e;
            return 1 == e || 11 == e ? "one" : 2 == e || 12 == e ? "two" : n && e >= 3 && e <= 10 || n && e >= 13 && e <= 19 ? "few" : "other";
          },
          gl: c,
          gsw: s,
          gu: r,
          guw: o,
          gv: function gv(e) {
            var a = String(e).split("."),
                n = a[0],
                i = !a[1],
                t = n.slice(-1),
                s = n.slice(-2);
            return i && 1 == t ? "one" : i && 2 == t ? "two" : !i || 0 != s && 20 != s && 40 != s && 60 != s && 80 != s ? i ? "other" : "many" : "few";
          },
          ha: s,
          haw: s,
          he: function he(e) {
            var a = String(e).split("."),
                n = a[0],
                i = !a[1],
                t = Number(a[0]) == e,
                s = t && a[0].slice(-1);
            return 1 == e && i ? "one" : 2 == n && i ? "two" : i && (e < 0 || e > 10) && t && 0 == s ? "many" : "other";
          },
          hi: r,
          hnj: p,
          hr: function hr(e) {
            var a = String(e).split("."),
                n = a[0],
                i = a[1] || "",
                t = !a[1],
                s = n.slice(-1),
                o = n.slice(-2),
                r = i.slice(-1),
                c = i.slice(-2);
            return t && 1 == s && 11 != o || 1 == r && 11 != c ? "one" : t && s >= 2 && s <= 4 && (o < 12 || o > 14) || r >= 2 && r <= 4 && (c < 12 || c > 14) ? "few" : "other";
          },
          hsb: function hsb(e) {
            var a = String(e).split("."),
                n = a[0],
                i = a[1] || "",
                t = !a[1],
                s = n.slice(-2),
                o = i.slice(-2);
            return t && 1 == s || 1 == o ? "one" : t && 2 == s || 2 == o ? "two" : t && (3 == s || 4 == s) || 3 == o || 4 == o ? "few" : "other";
          },
          hu: s,
          hy: function hy(e) {
            return e >= 0 && e < 2 ? "one" : "other";
          },
          ia: c,
          id: p,
          ig: p,
          ii: p,
          io: c,
          is: function is(e) {
            var a = String(e).split("."),
                n = a[0],
                i = Number(a[0]) == e,
                t = n.slice(-1),
                s = n.slice(-2);
            return i && 1 == t && 11 != s || !i ? "one" : "other";
          },
          it: function it(e) {
            var a = String(e).split("."),
                n = a[0],
                i = !a[1],
                t = n.slice(-6);
            return 1 == e && i ? "one" : 0 != n && 0 == t && i ? "many" : "other";
          },
          iu: l,
          ja: p,
          jbo: p,
          jgo: s,
          jmc: s,
          jv: p,
          jw: p,
          ka: s,
          kab: function kab(e) {
            return e >= 0 && e < 2 ? "one" : "other";
          },
          kaj: s,
          kcg: s,
          kde: p,
          kea: p,
          kk: s,
          kkj: s,
          kl: s,
          km: p,
          kn: r,
          ko: p,
          ks: s,
          ksb: s,
          ksh: function ksh(e) {
            return 0 == e ? "zero" : 1 == e ? "one" : "other";
          },
          ku: s,
          kw: function kw(e) {
            var a = String(e).split("."),
                n = Number(a[0]) == e,
                i = n && a[0].slice(-2),
                t = n && a[0].slice(-3),
                s = n && a[0].slice(-5),
                o = n && a[0].slice(-6);
            return 0 == e ? "zero" : 1 == e ? "one" : 2 == i || 22 == i || 42 == i || 62 == i || 82 == i || n && 0 == t && (s >= 1e3 && s <= 2e4 || 4e4 == s || 6e4 == s || 8e4 == s) || 0 != e && 1e5 == o ? "two" : 3 == i || 23 == i || 43 == i || 63 == i || 83 == i ? "few" : 1 == e || 1 != i && 21 != i && 41 != i && 61 != i && 81 != i ? "other" : "many";
          },
          ky: s,
          lag: function lag(e) {
            var a = String(e).split(".")[0];
            return 0 == e ? "zero" : 0 != a && 1 != a || 0 == e ? "other" : "one";
          },
          lb: s,
          lg: s,
          lij: c,
          lkt: p,
          ln: o,
          lo: p,
          lt: function lt(e) {
            var a = String(e).split("."),
                n = a[1] || "",
                i = Number(a[0]) == e,
                t = i && a[0].slice(-1),
                s = i && a[0].slice(-2);
            return 1 == t && (s < 11 || s > 19) ? "one" : t >= 2 && t <= 9 && (s < 11 || s > 19) ? "few" : 0 != n ? "many" : "other";
          },
          lv: function lv(e) {
            var a = String(e).split("."),
                n = a[1] || "",
                i = n.length,
                t = Number(a[0]) == e,
                s = t && a[0].slice(-1),
                o = t && a[0].slice(-2),
                r = n.slice(-2),
                c = n.slice(-1);
            return t && 0 == s || o >= 11 && o <= 19 || 2 == i && r >= 11 && r <= 19 ? "zero" : 1 == s && 11 != o || 2 == i && 1 == c && 11 != r || 2 != i && 1 == c ? "one" : "other";
          },
          mas: s,
          mg: o,
          mgo: s,
          mk: function mk(e) {
            var a = String(e).split("."),
                n = a[0],
                i = a[1] || "",
                t = !a[1],
                s = n.slice(-1),
                o = n.slice(-2),
                r = i.slice(-1),
                c = i.slice(-2);
            return t && 1 == s && 11 != o || 1 == r && 11 != c ? "one" : "other";
          },
          ml: s,
          mn: s,
          mo: function mo(e) {
            var a = String(e).split("."),
                n = !a[1],
                i = Number(a[0]) == e && a[0].slice(-2);
            return 1 == e && n ? "one" : !n || 0 == e || i >= 2 && i <= 19 ? "few" : "other";
          },
          mr: s,
          ms: p,
          mt: function mt(e) {
            var a = String(e).split("."),
                n = Number(a[0]) == e && a[0].slice(-2);
            return 1 == e ? "one" : 0 == e || n >= 2 && n <= 10 ? "few" : n >= 11 && n <= 19 ? "many" : "other";
          },
          my: p,
          nah: s,
          naq: l,
          nb: s,
          nd: s,
          ne: s,
          nl: c,
          nn: s,
          nnh: s,
          no: s,
          nqo: p,
          nr: s,
          nso: o,
          ny: s,
          nyn: s,
          om: s,
          or: s,
          os: s,
          osa: p,
          pa: o,
          pap: s,
          pcm: r,
          pl: function pl(e) {
            var a = String(e).split("."),
                n = a[0],
                i = !a[1],
                t = n.slice(-1),
                s = n.slice(-2);
            return 1 == e && i ? "one" : i && t >= 2 && t <= 4 && (s < 12 || s > 14) ? "few" : i && 1 != n && (0 == t || 1 == t) || i && t >= 5 && t <= 9 || i && s >= 12 && s <= 14 ? "many" : "other";
          },
          prg: function prg(e) {
            var a = String(e).split("."),
                n = a[1] || "",
                i = n.length,
                t = Number(a[0]) == e,
                s = t && a[0].slice(-1),
                o = t && a[0].slice(-2),
                r = n.slice(-2),
                c = n.slice(-1);
            return t && 0 == s || o >= 11 && o <= 19 || 2 == i && r >= 11 && r <= 19 ? "zero" : 1 == s && 11 != o || 2 == i && 1 == c && 11 != r || 2 != i && 1 == c ? "one" : "other";
          },
          ps: s,
          pt: function pt(e) {
            var a = String(e).split("."),
                n = a[0],
                i = !a[1],
                t = n.slice(-6);
            return 0 == n || 1 == n ? "one" : 0 != n && 0 == t && i ? "many" : "other";
          },
          pt_PT: function pt_PT(e) {
            var a = String(e).split("."),
                n = a[0],
                i = !a[1],
                t = n.slice(-6);
            return 1 == e && i ? "one" : 0 != n && 0 == t && i ? "many" : "other";
          },
          rm: s,
          ro: function ro(e) {
            var a = String(e).split("."),
                n = !a[1],
                i = Number(a[0]) == e && a[0].slice(-2);
            return 1 == e && n ? "one" : !n || 0 == e || i >= 2 && i <= 19 ? "few" : "other";
          },
          rof: s,
          ru: function ru(e) {
            var a = String(e).split("."),
                n = a[0],
                i = !a[1],
                t = n.slice(-1),
                s = n.slice(-2);
            return i && 1 == t && 11 != s ? "one" : i && t >= 2 && t <= 4 && (s < 12 || s > 14) ? "few" : i && 0 == t || i && t >= 5 && t <= 9 || i && s >= 11 && s <= 14 ? "many" : "other";
          },
          rwk: s,
          sah: p,
          saq: s,
          sat: l,
          sc: c,
          scn: c,
          sd: s,
          sdh: s,
          se: l,
          seh: s,
          ses: p,
          sg: p,
          sh: function sh(e) {
            var a = String(e).split("."),
                n = a[0],
                i = a[1] || "",
                t = !a[1],
                s = n.slice(-1),
                o = n.slice(-2),
                r = i.slice(-1),
                c = i.slice(-2);
            return t && 1 == s && 11 != o || 1 == r && 11 != c ? "one" : t && s >= 2 && s <= 4 && (o < 12 || o > 14) || r >= 2 && r <= 4 && (c < 12 || c > 14) ? "few" : "other";
          },
          shi: function shi(e) {
            var a = String(e).split("."),
                n = Number(a[0]) == e;
            return e >= 0 && e <= 1 ? "one" : n && e >= 2 && e <= 10 ? "few" : "other";
          },
          si: function si(e) {
            var a = String(e).split("."),
                n = a[0],
                i = a[1] || "";
            return 0 == e || 1 == e || 0 == n && 1 == i ? "one" : "other";
          },
          sk: function sk(e) {
            var a = String(e).split("."),
                n = a[0],
                i = !a[1];
            return 1 == e && i ? "one" : n >= 2 && n <= 4 && i ? "few" : i ? "other" : "many";
          },
          sl: function sl(e) {
            var a = String(e).split("."),
                n = a[0],
                i = !a[1],
                t = n.slice(-2);
            return i && 1 == t ? "one" : i && 2 == t ? "two" : i && (3 == t || 4 == t) || !i ? "few" : "other";
          },
          sma: l,
          smi: l,
          smj: l,
          smn: l,
          sms: l,
          sn: s,
          so: s,
          sq: s,
          sr: function sr(e) {
            var a = String(e).split("."),
                n = a[0],
                i = a[1] || "",
                t = !a[1],
                s = n.slice(-1),
                o = n.slice(-2),
                r = i.slice(-1),
                c = i.slice(-2);
            return t && 1 == s && 11 != o || 1 == r && 11 != c ? "one" : t && s >= 2 && s <= 4 && (o < 12 || o > 14) || r >= 2 && r <= 4 && (c < 12 || c > 14) ? "few" : "other";
          },
          ss: s,
          ssy: s,
          st: s,
          su: p,
          sv: c,
          sw: c,
          syr: s,
          ta: s,
          te: s,
          teo: s,
          th: p,
          ti: o,
          tig: s,
          tk: s,
          tl: function tl(e) {
            var a = String(e).split("."),
                n = a[0],
                i = a[1] || "",
                t = !a[1],
                s = n.slice(-1),
                o = i.slice(-1);
            return t && (1 == n || 2 == n || 3 == n) || t && 4 != s && 6 != s && 9 != s || !t && 4 != o && 6 != o && 9 != o ? "one" : "other";
          },
          tn: s,
          to: p,
          tpi: p,
          tr: s,
          ts: s,
          tzm: function tzm(e) {
            var a = String(e).split("."),
                n = Number(a[0]) == e;
            return 0 == e || 1 == e || n && e >= 11 && e <= 99 ? "one" : "other";
          },
          ug: s,
          uk: function uk(e) {
            var a = String(e).split("."),
                n = a[0],
                i = !a[1],
                t = n.slice(-1),
                s = n.slice(-2);
            return i && 1 == t && 11 != s ? "one" : i && t >= 2 && t <= 4 && (s < 12 || s > 14) ? "few" : i && 0 == t || i && t >= 5 && t <= 9 || i && s >= 11 && s <= 14 ? "many" : "other";
          },
          und: p,
          ur: c,
          uz: s,
          ve: s,
          vi: p,
          vo: s,
          vun: s,
          wa: o,
          wae: s,
          wo: p,
          xh: s,
          xog: s,
          yi: c,
          yo: p,
          yue: p,
          zh: p,
          zu: r
        }, Object.defineProperty(u, "__esModule", {
          value: !0
        }), void 0 === (t = "function" == typeof (i = u) ? i.call(a, n, a, e) : i) || (e.exports = t);
      },
      985: function _(e, a, n) {
        var i,
            t,
            s,
            o = "zero",
            r = "one",
            c = "two",
            p = "few",
            l = "many",
            u = "other",
            m = {
          cardinal: [r, u],
          ordinal: [u]
        },
            d = {
          cardinal: [r, u],
          ordinal: [r, u]
        },
            f = {
          cardinal: [u],
          ordinal: [u]
        },
            h = {
          cardinal: [r, p, l, u],
          ordinal: [u]
        },
            x = {
          cardinal: [r, c, u],
          ordinal: [u]
        };
        s = {
          af: m,
          ak: m,
          am: m,
          an: m,
          ar: {
            cardinal: [o, r, c, p, l, u],
            ordinal: [u]
          },
          ars: {
            cardinal: [o, r, c, p, l, u],
            ordinal: [u]
          },
          as: {
            cardinal: [r, u],
            ordinal: [r, c, p, l, u]
          },
          asa: m,
          ast: m,
          az: {
            cardinal: [r, u],
            ordinal: [r, p, l, u]
          },
          bal: d,
          be: {
            cardinal: [r, p, l, u],
            ordinal: [p, u]
          },
          bem: m,
          bez: m,
          bg: m,
          bho: m,
          bm: f,
          bn: {
            cardinal: [r, u],
            ordinal: [r, c, p, l, u]
          },
          bo: f,
          br: {
            cardinal: [r, c, p, l, u],
            ordinal: [u]
          },
          brx: m,
          bs: {
            cardinal: [r, p, u],
            ordinal: [u]
          },
          ca: {
            cardinal: [r, u],
            ordinal: [r, c, p, u]
          },
          ce: m,
          ceb: m,
          cgg: m,
          chr: m,
          ckb: m,
          cs: h,
          cy: {
            cardinal: [o, r, c, p, l, u],
            ordinal: [o, r, c, p, l, u]
          },
          da: m,
          de: m,
          doi: m,
          dsb: {
            cardinal: [r, c, p, u],
            ordinal: [u]
          },
          dv: m,
          dz: f,
          ee: m,
          el: m,
          en: {
            cardinal: [r, u],
            ordinal: [r, c, p, u]
          },
          eo: m,
          es: {
            cardinal: [r, l, u],
            ordinal: [u]
          },
          et: m,
          eu: m,
          fa: m,
          ff: m,
          fi: m,
          fil: d,
          fo: m,
          fr: {
            cardinal: [r, l, u],
            ordinal: [r, u]
          },
          fur: m,
          fy: m,
          ga: {
            cardinal: [r, c, p, l, u],
            ordinal: [r, u]
          },
          gd: {
            cardinal: [r, c, p, u],
            ordinal: [r, c, p, u]
          },
          gl: m,
          gsw: m,
          gu: {
            cardinal: [r, u],
            ordinal: [r, c, p, l, u]
          },
          guw: m,
          gv: {
            cardinal: [r, c, p, l, u],
            ordinal: [u]
          },
          ha: m,
          haw: m,
          he: {
            cardinal: [r, c, l, u],
            ordinal: [u]
          },
          hi: {
            cardinal: [r, u],
            ordinal: [r, c, p, l, u]
          },
          hnj: f,
          hr: {
            cardinal: [r, p, u],
            ordinal: [u]
          },
          hsb: {
            cardinal: [r, c, p, u],
            ordinal: [u]
          },
          hu: d,
          hy: d,
          ia: m,
          id: f,
          ig: f,
          ii: f,
          io: m,
          is: m,
          it: {
            cardinal: [r, l, u],
            ordinal: [l, u]
          },
          iu: x,
          ja: f,
          jbo: f,
          jgo: m,
          jmc: m,
          jv: f,
          jw: f,
          ka: {
            cardinal: [r, u],
            ordinal: [r, l, u]
          },
          kab: m,
          kaj: m,
          kcg: m,
          kde: f,
          kea: f,
          kk: {
            cardinal: [r, u],
            ordinal: [l, u]
          },
          kkj: m,
          kl: m,
          km: f,
          kn: m,
          ko: f,
          ks: m,
          ksb: m,
          ksh: {
            cardinal: [o, r, u],
            ordinal: [u]
          },
          ku: m,
          kw: {
            cardinal: [o, r, c, p, l, u],
            ordinal: [r, l, u]
          },
          ky: m,
          lag: {
            cardinal: [o, r, u],
            ordinal: [u]
          },
          lb: m,
          lg: m,
          lij: {
            cardinal: [r, u],
            ordinal: [l, u]
          },
          lkt: f,
          ln: m,
          lo: {
            cardinal: [u],
            ordinal: [r, u]
          },
          lt: h,
          lv: {
            cardinal: [o, r, u],
            ordinal: [u]
          },
          mas: m,
          mg: m,
          mgo: m,
          mk: {
            cardinal: [r, u],
            ordinal: [r, c, l, u]
          },
          ml: m,
          mn: m,
          mo: {
            cardinal: [r, p, u],
            ordinal: [r, u]
          },
          mr: {
            cardinal: [r, u],
            ordinal: [r, c, p, u]
          },
          ms: {
            cardinal: [u],
            ordinal: [r, u]
          },
          mt: h,
          my: f,
          nah: m,
          naq: x,
          nb: m,
          nd: m,
          ne: d,
          nl: m,
          nn: m,
          nnh: m,
          no: m,
          nqo: f,
          nr: m,
          nso: m,
          ny: m,
          nyn: m,
          om: m,
          or: {
            cardinal: [r, u],
            ordinal: [r, c, p, l, u]
          },
          os: m,
          osa: f,
          pa: m,
          pap: m,
          pcm: m,
          pl: h,
          prg: {
            cardinal: [o, r, u],
            ordinal: [u]
          },
          ps: m,
          pt: {
            cardinal: [r, l, u],
            ordinal: [u]
          },
          pt_PT: {
            cardinal: [r, l, u],
            ordinal: [u]
          },
          rm: m,
          ro: {
            cardinal: [r, p, u],
            ordinal: [r, u]
          },
          rof: m,
          ru: h,
          rwk: m,
          sah: f,
          saq: m,
          sat: x,
          sc: {
            cardinal: [r, u],
            ordinal: [l, u]
          },
          scn: {
            cardinal: [r, u],
            ordinal: [l, u]
          },
          sd: m,
          sdh: m,
          se: x,
          seh: m,
          ses: f,
          sg: f,
          sh: {
            cardinal: [r, p, u],
            ordinal: [u]
          },
          shi: {
            cardinal: [r, p, u],
            ordinal: [u]
          },
          si: m,
          sk: h,
          sl: {
            cardinal: [r, c, p, u],
            ordinal: [u]
          },
          sma: x,
          smi: x,
          smj: x,
          smn: x,
          sms: x,
          sn: m,
          so: m,
          sq: {
            cardinal: [r, u],
            ordinal: [r, l, u]
          },
          sr: {
            cardinal: [r, p, u],
            ordinal: [u]
          },
          ss: m,
          ssy: m,
          st: m,
          su: f,
          sv: d,
          sw: m,
          syr: m,
          ta: m,
          te: m,
          teo: m,
          th: f,
          ti: m,
          tig: m,
          tk: {
            cardinal: [r, u],
            ordinal: [p, u]
          },
          tl: d,
          tn: m,
          to: f,
          tpi: f,
          tr: m,
          ts: m,
          tzm: m,
          ug: m,
          uk: {
            cardinal: [r, p, l, u],
            ordinal: [p, u]
          },
          und: f,
          ur: m,
          uz: m,
          ve: m,
          vi: {
            cardinal: [u],
            ordinal: [r, u]
          },
          vo: m,
          vun: m,
          wa: m,
          wae: m,
          wo: f,
          xh: m,
          xog: m,
          yi: m,
          yo: f,
          yue: f,
          zh: f,
          zu: m
        }, Object.defineProperty(s, "__esModule", {
          value: !0
        }), void 0 === (t = "function" == typeof (i = s) ? i.call(a, n, a, e) : i) || (e.exports = t);
      },
      3585: function _(e, a, n) {
        var i, t;

        var s = function s(e, a) {
          return a ? "other" : 1 == e ? "one" : "other";
        },
            o = function o(e, a) {
          return a ? "other" : 0 == e || 1 == e ? "one" : "other";
        },
            r = function r(e, a) {
          return a ? "other" : e >= 0 && e <= 1 ? "one" : "other";
        },
            c = function c(e, a) {
          var n = !String(e).split(".")[1];
          return a ? "other" : 1 == e && n ? "one" : "other";
        },
            p = function p(e, a) {
          return "other";
        },
            l = function l(e, a) {
          return a ? "other" : 1 == e ? "one" : 2 == e ? "two" : "other";
        };

        var u;
        u = {
          af: s,
          ak: o,
          am: r,
          an: s,
          ar: function ar(e, a) {
            var n = String(e).split("."),
                i = Number(n[0]) == e && n[0].slice(-2);
            return a ? "other" : 0 == e ? "zero" : 1 == e ? "one" : 2 == e ? "two" : i >= 3 && i <= 10 ? "few" : i >= 11 && i <= 99 ? "many" : "other";
          },
          ars: function ars(e, a) {
            var n = String(e).split("."),
                i = Number(n[0]) == e && n[0].slice(-2);
            return a ? "other" : 0 == e ? "zero" : 1 == e ? "one" : 2 == e ? "two" : i >= 3 && i <= 10 ? "few" : i >= 11 && i <= 99 ? "many" : "other";
          },
          as: function as(e, a) {
            return a ? 1 == e || 5 == e || 7 == e || 8 == e || 9 == e || 10 == e ? "one" : 2 == e || 3 == e ? "two" : 4 == e ? "few" : 6 == e ? "many" : "other" : e >= 0 && e <= 1 ? "one" : "other";
          },
          asa: s,
          ast: c,
          az: function az(e, a) {
            var n = String(e).split(".")[0],
                i = n.slice(-1),
                t = n.slice(-2),
                s = n.slice(-3);
            return a ? 1 == i || 2 == i || 5 == i || 7 == i || 8 == i || 20 == t || 50 == t || 70 == t || 80 == t ? "one" : 3 == i || 4 == i || 100 == s || 200 == s || 300 == s || 400 == s || 500 == s || 600 == s || 700 == s || 800 == s || 900 == s ? "few" : 0 == n || 6 == i || 40 == t || 60 == t || 90 == t ? "many" : "other" : 1 == e ? "one" : "other";
          },
          bal: function bal(e, a) {
            return 1 == e ? "one" : "other";
          },
          be: function be(e, a) {
            var n = String(e).split("."),
                i = Number(n[0]) == e,
                t = i && n[0].slice(-1),
                s = i && n[0].slice(-2);
            return a ? 2 != t && 3 != t || 12 == s || 13 == s ? "other" : "few" : 1 == t && 11 != s ? "one" : t >= 2 && t <= 4 && (s < 12 || s > 14) ? "few" : i && 0 == t || t >= 5 && t <= 9 || s >= 11 && s <= 14 ? "many" : "other";
          },
          bem: s,
          bez: s,
          bg: s,
          bho: o,
          bm: p,
          bn: function bn(e, a) {
            return a ? 1 == e || 5 == e || 7 == e || 8 == e || 9 == e || 10 == e ? "one" : 2 == e || 3 == e ? "two" : 4 == e ? "few" : 6 == e ? "many" : "other" : e >= 0 && e <= 1 ? "one" : "other";
          },
          bo: p,
          br: function br(e, a) {
            var n = String(e).split("."),
                i = Number(n[0]) == e,
                t = i && n[0].slice(-1),
                s = i && n[0].slice(-2),
                o = i && n[0].slice(-6);
            return a ? "other" : 1 == t && 11 != s && 71 != s && 91 != s ? "one" : 2 == t && 12 != s && 72 != s && 92 != s ? "two" : (3 == t || 4 == t || 9 == t) && (s < 10 || s > 19) && (s < 70 || s > 79) && (s < 90 || s > 99) ? "few" : 0 != e && i && 0 == o ? "many" : "other";
          },
          brx: s,
          bs: function bs(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = n[1] || "",
                s = !n[1],
                o = i.slice(-1),
                r = i.slice(-2),
                c = t.slice(-1),
                p = t.slice(-2);
            return a ? "other" : s && 1 == o && 11 != r || 1 == c && 11 != p ? "one" : s && o >= 2 && o <= 4 && (r < 12 || r > 14) || c >= 2 && c <= 4 && (p < 12 || p > 14) ? "few" : "other";
          },
          ca: function ca(e, a) {
            var n = !String(e).split(".")[1];
            return a ? 1 == e || 3 == e ? "one" : 2 == e ? "two" : 4 == e ? "few" : "other" : 1 == e && n ? "one" : "other";
          },
          ce: s,
          ceb: function ceb(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = n[1] || "",
                s = !n[1],
                o = i.slice(-1),
                r = t.slice(-1);
            return a ? "other" : s && (1 == i || 2 == i || 3 == i) || s && 4 != o && 6 != o && 9 != o || !s && 4 != r && 6 != r && 9 != r ? "one" : "other";
          },
          cgg: s,
          chr: s,
          ckb: s,
          cs: function cs(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = !n[1];
            return a ? "other" : 1 == e && t ? "one" : i >= 2 && i <= 4 && t ? "few" : t ? "other" : "many";
          },
          cy: function cy(e, a) {
            return a ? 0 == e || 7 == e || 8 == e || 9 == e ? "zero" : 1 == e ? "one" : 2 == e ? "two" : 3 == e || 4 == e ? "few" : 5 == e || 6 == e ? "many" : "other" : 0 == e ? "zero" : 1 == e ? "one" : 2 == e ? "two" : 3 == e ? "few" : 6 == e ? "many" : "other";
          },
          da: function da(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = Number(n[0]) == e;
            return a || 1 != e && (t || 0 != i && 1 != i) ? "other" : "one";
          },
          de: c,
          doi: r,
          dsb: function dsb(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = n[1] || "",
                s = !n[1],
                o = i.slice(-2),
                r = t.slice(-2);
            return a ? "other" : s && 1 == o || 1 == r ? "one" : s && 2 == o || 2 == r ? "two" : s && (3 == o || 4 == o) || 3 == r || 4 == r ? "few" : "other";
          },
          dv: s,
          dz: p,
          ee: s,
          el: s,
          en: function en(e, a) {
            var n = String(e).split("."),
                i = !n[1],
                t = Number(n[0]) == e,
                s = t && n[0].slice(-1),
                o = t && n[0].slice(-2);
            return a ? 1 == s && 11 != o ? "one" : 2 == s && 12 != o ? "two" : 3 == s && 13 != o ? "few" : "other" : 1 == e && i ? "one" : "other";
          },
          eo: s,
          es: function es(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = !n[1],
                s = i.slice(-6);
            return a ? "other" : 1 == e ? "one" : 0 != i && 0 == s && t ? "many" : "other";
          },
          et: c,
          eu: s,
          fa: r,
          ff: function ff(e, a) {
            return a ? "other" : e >= 0 && e < 2 ? "one" : "other";
          },
          fi: c,
          fil: function fil(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = n[1] || "",
                s = !n[1],
                o = i.slice(-1),
                r = t.slice(-1);
            return a ? 1 == e ? "one" : "other" : s && (1 == i || 2 == i || 3 == i) || s && 4 != o && 6 != o && 9 != o || !s && 4 != r && 6 != r && 9 != r ? "one" : "other";
          },
          fo: s,
          fr: function fr(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = !n[1],
                s = i.slice(-6);
            return a ? 1 == e ? "one" : "other" : e >= 0 && e < 2 ? "one" : 0 != i && 0 == s && t ? "many" : "other";
          },
          fur: s,
          fy: c,
          ga: function ga(e, a) {
            var n = String(e).split("."),
                i = Number(n[0]) == e;
            return a ? 1 == e ? "one" : "other" : 1 == e ? "one" : 2 == e ? "two" : i && e >= 3 && e <= 6 ? "few" : i && e >= 7 && e <= 10 ? "many" : "other";
          },
          gd: function gd(e, a) {
            var n = String(e).split("."),
                i = Number(n[0]) == e;
            return a ? 1 == e || 11 == e ? "one" : 2 == e || 12 == e ? "two" : 3 == e || 13 == e ? "few" : "other" : 1 == e || 11 == e ? "one" : 2 == e || 12 == e ? "two" : i && e >= 3 && e <= 10 || i && e >= 13 && e <= 19 ? "few" : "other";
          },
          gl: c,
          gsw: s,
          gu: function gu(e, a) {
            return a ? 1 == e ? "one" : 2 == e || 3 == e ? "two" : 4 == e ? "few" : 6 == e ? "many" : "other" : e >= 0 && e <= 1 ? "one" : "other";
          },
          guw: o,
          gv: function gv(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = !n[1],
                s = i.slice(-1),
                o = i.slice(-2);
            return a ? "other" : t && 1 == s ? "one" : t && 2 == s ? "two" : !t || 0 != o && 20 != o && 40 != o && 60 != o && 80 != o ? t ? "other" : "many" : "few";
          },
          ha: s,
          haw: s,
          he: function he(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = !n[1],
                s = Number(n[0]) == e,
                o = s && n[0].slice(-1);
            return a ? "other" : 1 == e && t ? "one" : 2 == i && t ? "two" : t && (e < 0 || e > 10) && s && 0 == o ? "many" : "other";
          },
          hi: function hi(e, a) {
            return a ? 1 == e ? "one" : 2 == e || 3 == e ? "two" : 4 == e ? "few" : 6 == e ? "many" : "other" : e >= 0 && e <= 1 ? "one" : "other";
          },
          hnj: p,
          hr: function hr(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = n[1] || "",
                s = !n[1],
                o = i.slice(-1),
                r = i.slice(-2),
                c = t.slice(-1),
                p = t.slice(-2);
            return a ? "other" : s && 1 == o && 11 != r || 1 == c && 11 != p ? "one" : s && o >= 2 && o <= 4 && (r < 12 || r > 14) || c >= 2 && c <= 4 && (p < 12 || p > 14) ? "few" : "other";
          },
          hsb: function hsb(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = n[1] || "",
                s = !n[1],
                o = i.slice(-2),
                r = t.slice(-2);
            return a ? "other" : s && 1 == o || 1 == r ? "one" : s && 2 == o || 2 == r ? "two" : s && (3 == o || 4 == o) || 3 == r || 4 == r ? "few" : "other";
          },
          hu: function hu(e, a) {
            return a ? 1 == e || 5 == e ? "one" : "other" : 1 == e ? "one" : "other";
          },
          hy: function hy(e, a) {
            return a ? 1 == e ? "one" : "other" : e >= 0 && e < 2 ? "one" : "other";
          },
          ia: c,
          id: p,
          ig: p,
          ii: p,
          io: c,
          is: function is(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = Number(n[0]) == e,
                s = i.slice(-1),
                o = i.slice(-2);
            return a ? "other" : t && 1 == s && 11 != o || !t ? "one" : "other";
          },
          it: function it(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = !n[1],
                s = i.slice(-6);
            return a ? 11 == e || 8 == e || 80 == e || 800 == e ? "many" : "other" : 1 == e && t ? "one" : 0 != i && 0 == s && t ? "many" : "other";
          },
          iu: l,
          ja: p,
          jbo: p,
          jgo: s,
          jmc: s,
          jv: p,
          jw: p,
          ka: function ka(e, a) {
            var n = String(e).split(".")[0],
                i = n.slice(-2);
            return a ? 1 == n ? "one" : 0 == n || i >= 2 && i <= 20 || 40 == i || 60 == i || 80 == i ? "many" : "other" : 1 == e ? "one" : "other";
          },
          kab: function kab(e, a) {
            return a ? "other" : e >= 0 && e < 2 ? "one" : "other";
          },
          kaj: s,
          kcg: s,
          kde: p,
          kea: p,
          kk: function kk(e, a) {
            var n = String(e).split("."),
                i = Number(n[0]) == e,
                t = i && n[0].slice(-1);
            return a ? 6 == t || 9 == t || i && 0 == t && 0 != e ? "many" : "other" : 1 == e ? "one" : "other";
          },
          kkj: s,
          kl: s,
          km: p,
          kn: r,
          ko: p,
          ks: s,
          ksb: s,
          ksh: function ksh(e, a) {
            return a ? "other" : 0 == e ? "zero" : 1 == e ? "one" : "other";
          },
          ku: s,
          kw: function kw(e, a) {
            var n = String(e).split("."),
                i = Number(n[0]) == e,
                t = i && n[0].slice(-2),
                s = i && n[0].slice(-3),
                o = i && n[0].slice(-5),
                r = i && n[0].slice(-6);
            return a ? i && e >= 1 && e <= 4 || t >= 1 && t <= 4 || t >= 21 && t <= 24 || t >= 41 && t <= 44 || t >= 61 && t <= 64 || t >= 81 && t <= 84 ? "one" : 5 == e || 5 == t ? "many" : "other" : 0 == e ? "zero" : 1 == e ? "one" : 2 == t || 22 == t || 42 == t || 62 == t || 82 == t || i && 0 == s && (o >= 1e3 && o <= 2e4 || 4e4 == o || 6e4 == o || 8e4 == o) || 0 != e && 1e5 == r ? "two" : 3 == t || 23 == t || 43 == t || 63 == t || 83 == t ? "few" : 1 == e || 1 != t && 21 != t && 41 != t && 61 != t && 81 != t ? "other" : "many";
          },
          ky: s,
          lag: function lag(e, a) {
            var n = String(e).split(".")[0];
            return a ? "other" : 0 == e ? "zero" : 0 != n && 1 != n || 0 == e ? "other" : "one";
          },
          lb: s,
          lg: s,
          lij: function lij(e, a) {
            var n = String(e).split("."),
                i = !n[1],
                t = Number(n[0]) == e;
            return a ? 11 == e || 8 == e || t && e >= 80 && e <= 89 || t && e >= 800 && e <= 899 ? "many" : "other" : 1 == e && i ? "one" : "other";
          },
          lkt: p,
          ln: o,
          lo: function lo(e, a) {
            return a && 1 == e ? "one" : "other";
          },
          lt: function lt(e, a) {
            var n = String(e).split("."),
                i = n[1] || "",
                t = Number(n[0]) == e,
                s = t && n[0].slice(-1),
                o = t && n[0].slice(-2);
            return a ? "other" : 1 == s && (o < 11 || o > 19) ? "one" : s >= 2 && s <= 9 && (o < 11 || o > 19) ? "few" : 0 != i ? "many" : "other";
          },
          lv: function lv(e, a) {
            var n = String(e).split("."),
                i = n[1] || "",
                t = i.length,
                s = Number(n[0]) == e,
                o = s && n[0].slice(-1),
                r = s && n[0].slice(-2),
                c = i.slice(-2),
                p = i.slice(-1);
            return a ? "other" : s && 0 == o || r >= 11 && r <= 19 || 2 == t && c >= 11 && c <= 19 ? "zero" : 1 == o && 11 != r || 2 == t && 1 == p && 11 != c || 2 != t && 1 == p ? "one" : "other";
          },
          mas: s,
          mg: o,
          mgo: s,
          mk: function mk(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = n[1] || "",
                s = !n[1],
                o = i.slice(-1),
                r = i.slice(-2),
                c = t.slice(-1),
                p = t.slice(-2);
            return a ? 1 == o && 11 != r ? "one" : 2 == o && 12 != r ? "two" : 7 != o && 8 != o || 17 == r || 18 == r ? "other" : "many" : s && 1 == o && 11 != r || 1 == c && 11 != p ? "one" : "other";
          },
          ml: s,
          mn: s,
          mo: function mo(e, a) {
            var n = String(e).split("."),
                i = !n[1],
                t = Number(n[0]) == e && n[0].slice(-2);
            return a ? 1 == e ? "one" : "other" : 1 == e && i ? "one" : !i || 0 == e || t >= 2 && t <= 19 ? "few" : "other";
          },
          mr: function mr(e, a) {
            return a ? 1 == e ? "one" : 2 == e || 3 == e ? "two" : 4 == e ? "few" : "other" : 1 == e ? "one" : "other";
          },
          ms: function ms(e, a) {
            return a && 1 == e ? "one" : "other";
          },
          mt: function mt(e, a) {
            var n = String(e).split("."),
                i = Number(n[0]) == e && n[0].slice(-2);
            return a ? "other" : 1 == e ? "one" : 0 == e || i >= 2 && i <= 10 ? "few" : i >= 11 && i <= 19 ? "many" : "other";
          },
          my: p,
          nah: s,
          naq: l,
          nb: s,
          nd: s,
          ne: function ne(e, a) {
            var n = String(e).split("."),
                i = Number(n[0]) == e;
            return a ? i && e >= 1 && e <= 4 ? "one" : "other" : 1 == e ? "one" : "other";
          },
          nl: c,
          nn: s,
          nnh: s,
          no: s,
          nqo: p,
          nr: s,
          nso: o,
          ny: s,
          nyn: s,
          om: s,
          or: function or(e, a) {
            var n = String(e).split("."),
                i = Number(n[0]) == e;
            return a ? 1 == e || 5 == e || i && e >= 7 && e <= 9 ? "one" : 2 == e || 3 == e ? "two" : 4 == e ? "few" : 6 == e ? "many" : "other" : 1 == e ? "one" : "other";
          },
          os: s,
          osa: p,
          pa: o,
          pap: s,
          pcm: r,
          pl: function pl(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = !n[1],
                s = i.slice(-1),
                o = i.slice(-2);
            return a ? "other" : 1 == e && t ? "one" : t && s >= 2 && s <= 4 && (o < 12 || o > 14) ? "few" : t && 1 != i && (0 == s || 1 == s) || t && s >= 5 && s <= 9 || t && o >= 12 && o <= 14 ? "many" : "other";
          },
          prg: function prg(e, a) {
            var n = String(e).split("."),
                i = n[1] || "",
                t = i.length,
                s = Number(n[0]) == e,
                o = s && n[0].slice(-1),
                r = s && n[0].slice(-2),
                c = i.slice(-2),
                p = i.slice(-1);
            return a ? "other" : s && 0 == o || r >= 11 && r <= 19 || 2 == t && c >= 11 && c <= 19 ? "zero" : 1 == o && 11 != r || 2 == t && 1 == p && 11 != c || 2 != t && 1 == p ? "one" : "other";
          },
          ps: s,
          pt: function pt(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = !n[1],
                s = i.slice(-6);
            return a ? "other" : 0 == i || 1 == i ? "one" : 0 != i && 0 == s && t ? "many" : "other";
          },
          pt_PT: function pt_PT(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = !n[1],
                s = i.slice(-6);
            return a ? "other" : 1 == e && t ? "one" : 0 != i && 0 == s && t ? "many" : "other";
          },
          rm: s,
          ro: function ro(e, a) {
            var n = String(e).split("."),
                i = !n[1],
                t = Number(n[0]) == e && n[0].slice(-2);
            return a ? 1 == e ? "one" : "other" : 1 == e && i ? "one" : !i || 0 == e || t >= 2 && t <= 19 ? "few" : "other";
          },
          rof: s,
          ru: function ru(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = !n[1],
                s = i.slice(-1),
                o = i.slice(-2);
            return a ? "other" : t && 1 == s && 11 != o ? "one" : t && s >= 2 && s <= 4 && (o < 12 || o > 14) ? "few" : t && 0 == s || t && s >= 5 && s <= 9 || t && o >= 11 && o <= 14 ? "many" : "other";
          },
          rwk: s,
          sah: p,
          saq: s,
          sat: l,
          sc: function sc(e, a) {
            var n = !String(e).split(".")[1];
            return a ? 11 == e || 8 == e || 80 == e || 800 == e ? "many" : "other" : 1 == e && n ? "one" : "other";
          },
          scn: function scn(e, a) {
            var n = !String(e).split(".")[1];
            return a ? 11 == e || 8 == e || 80 == e || 800 == e ? "many" : "other" : 1 == e && n ? "one" : "other";
          },
          sd: s,
          sdh: s,
          se: l,
          seh: s,
          ses: p,
          sg: p,
          sh: function sh(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = n[1] || "",
                s = !n[1],
                o = i.slice(-1),
                r = i.slice(-2),
                c = t.slice(-1),
                p = t.slice(-2);
            return a ? "other" : s && 1 == o && 11 != r || 1 == c && 11 != p ? "one" : s && o >= 2 && o <= 4 && (r < 12 || r > 14) || c >= 2 && c <= 4 && (p < 12 || p > 14) ? "few" : "other";
          },
          shi: function shi(e, a) {
            var n = String(e).split("."),
                i = Number(n[0]) == e;
            return a ? "other" : e >= 0 && e <= 1 ? "one" : i && e >= 2 && e <= 10 ? "few" : "other";
          },
          si: function si(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = n[1] || "";
            return a ? "other" : 0 == e || 1 == e || 0 == i && 1 == t ? "one" : "other";
          },
          sk: function sk(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = !n[1];
            return a ? "other" : 1 == e && t ? "one" : i >= 2 && i <= 4 && t ? "few" : t ? "other" : "many";
          },
          sl: function sl(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = !n[1],
                s = i.slice(-2);
            return a ? "other" : t && 1 == s ? "one" : t && 2 == s ? "two" : t && (3 == s || 4 == s) || !t ? "few" : "other";
          },
          sma: l,
          smi: l,
          smj: l,
          smn: l,
          sms: l,
          sn: s,
          so: s,
          sq: function sq(e, a) {
            var n = String(e).split("."),
                i = Number(n[0]) == e,
                t = i && n[0].slice(-1),
                s = i && n[0].slice(-2);
            return a ? 1 == e ? "one" : 4 == t && 14 != s ? "many" : "other" : 1 == e ? "one" : "other";
          },
          sr: function sr(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = n[1] || "",
                s = !n[1],
                o = i.slice(-1),
                r = i.slice(-2),
                c = t.slice(-1),
                p = t.slice(-2);
            return a ? "other" : s && 1 == o && 11 != r || 1 == c && 11 != p ? "one" : s && o >= 2 && o <= 4 && (r < 12 || r > 14) || c >= 2 && c <= 4 && (p < 12 || p > 14) ? "few" : "other";
          },
          ss: s,
          ssy: s,
          st: s,
          su: p,
          sv: function sv(e, a) {
            var n = String(e).split("."),
                i = !n[1],
                t = Number(n[0]) == e,
                s = t && n[0].slice(-1),
                o = t && n[0].slice(-2);
            return a ? 1 != s && 2 != s || 11 == o || 12 == o ? "other" : "one" : 1 == e && i ? "one" : "other";
          },
          sw: c,
          syr: s,
          ta: s,
          te: s,
          teo: s,
          th: p,
          ti: o,
          tig: s,
          tk: function tk(e, a) {
            var n = String(e).split("."),
                i = Number(n[0]) == e && n[0].slice(-1);
            return a ? 6 == i || 9 == i || 10 == e ? "few" : "other" : 1 == e ? "one" : "other";
          },
          tl: function tl(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = n[1] || "",
                s = !n[1],
                o = i.slice(-1),
                r = t.slice(-1);
            return a ? 1 == e ? "one" : "other" : s && (1 == i || 2 == i || 3 == i) || s && 4 != o && 6 != o && 9 != o || !s && 4 != r && 6 != r && 9 != r ? "one" : "other";
          },
          tn: s,
          to: p,
          tpi: p,
          tr: s,
          ts: s,
          tzm: function tzm(e, a) {
            var n = String(e).split("."),
                i = Number(n[0]) == e;
            return a ? "other" : 0 == e || 1 == e || i && e >= 11 && e <= 99 ? "one" : "other";
          },
          ug: s,
          uk: function uk(e, a) {
            var n = String(e).split("."),
                i = n[0],
                t = !n[1],
                s = Number(n[0]) == e,
                o = s && n[0].slice(-1),
                r = s && n[0].slice(-2),
                c = i.slice(-1),
                p = i.slice(-2);
            return a ? 3 == o && 13 != r ? "few" : "other" : t && 1 == c && 11 != p ? "one" : t && c >= 2 && c <= 4 && (p < 12 || p > 14) ? "few" : t && 0 == c || t && c >= 5 && c <= 9 || t && p >= 11 && p <= 14 ? "many" : "other";
          },
          und: p,
          ur: c,
          uz: s,
          ve: s,
          vi: function vi(e, a) {
            return a && 1 == e ? "one" : "other";
          },
          vo: s,
          vun: s,
          wa: o,
          wae: s,
          wo: p,
          xh: s,
          xog: s,
          yi: c,
          yo: p,
          yue: p,
          zh: p,
          zu: r
        }, Object.defineProperty(u, "__esModule", {
          value: !0
        }), void 0 === (t = "function" == typeof (i = u) ? i.call(a, n, a, e) : i) || (e.exports = t);
      },
      4534: function _(e, a, n) {
        var i = n(6309);
        e.exports = {
          identifier: function identifier(e, a) {
            a && (e += " " + function (e) {
              var a = 0;

              for (var _n21 = 0; _n21 < e.length; ++_n21) {
                a = (a << 5) - a + e.charCodeAt(_n21), a |= 0;
              }

              return a;
            }(e).toString(36));
            var n = e.trim().replace(/\W+/g, "_");
            return i.ES3[n] || i.ESnext[n] || /^\d/.test(n) ? "_" + n : n;
          },
          property: function property(e, a) {
            if (/^[A-Z_$][0-9A-Z_$]*$/i.test(a) && !i.ES3[a]) return e ? e + "." + a : a;
            {
              var _n22 = JSON.stringify(a);

              return e ? e + "[" + _n22 + "]" : _n22;
            }
          }
        };
      },
      6309: function _(e) {
        e.exports = {
          ES3: {
            break: !0,
            continue: !0,
            delete: !0,
            else: !0,
            for: !0,
            function: !0,
            if: !0,
            in: !0,
            new: !0,
            return: !0,
            this: !0,
            typeof: !0,
            var: !0,
            void: !0,
            while: !0,
            with: !0,
            case: !0,
            catch: !0,
            default: !0,
            do: !0,
            finally: !0,
            instanceof: !0,
            switch: !0,
            throw: !0,
            try: !0
          },
          ESnext: {
            await: !0,
            debugger: !0,
            class: !0,
            enum: !0,
            extends: !0,
            super: !0,
            const: !0,
            export: !0,
            import: !0,
            null: !0,
            true: !0,
            false: !0,
            implements: !0,
            let: !0,
            private: !0,
            public: !0,
            yield: !0,
            interface: !0,
            package: !0,
            protected: !0,
            static: !0
          }
        };
      },
      3765: function _(e) {
        "use strict";

        e.exports = JSON.parse('{"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/3gpp-ims+xml":{"source":"iana","compressible":true},"application/3gpphal+json":{"source":"iana","compressible":true},"application/3gpphalforms+json":{"source":"iana","compressible":true},"application/a2l":{"source":"iana"},"application/ace+cbor":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/activity+json":{"source":"iana","compressible":true},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/alto-updatestreamcontrol+json":{"source":"iana","compressible":true},"application/alto-updatestreamparams+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/at+jwt":{"source":"iana"},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","compressible":true,"extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana","compressible":true,"extensions":["atomdeleted"]},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","compressible":true,"extensions":["atomsvc"]},"application/atsc-dwd+xml":{"source":"iana","compressible":true,"extensions":["dwd"]},"application/atsc-dynamic-event-message":{"source":"iana"},"application/atsc-held+xml":{"source":"iana","compressible":true,"extensions":["held"]},"application/atsc-rdt+json":{"source":"iana","compressible":true},"application/atsc-rsat+xml":{"source":"iana","compressible":true,"extensions":["rsat"]},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana","compressible":true},"application/bacnet-xdd+zip":{"source":"iana","compressible":false},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana","compressible":true,"extensions":["xcs"]},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/captive+json":{"source":"iana","compressible":true},"application/cbor":{"source":"iana"},"application/cbor-seq":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana","compressible":true},"application/ccxml+xml":{"source":"iana","compressible":true,"extensions":["ccxml"]},"application/cdfx+xml":{"source":"iana","compressible":true,"extensions":["cdfx"]},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana","compressible":true},"application/cellml+xml":{"source":"iana","compressible":true},"application/cfw":{"source":"iana"},"application/city+json":{"source":"iana","compressible":true},"application/clr":{"source":"iana"},"application/clue+xml":{"source":"iana","compressible":true},"application/clue_info+xml":{"source":"iana","compressible":true},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana","compressible":true},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/conference-info+xml":{"source":"iana","compressible":true},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cpl+xml":{"source":"iana","compressible":true,"extensions":["cpl"]},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana","compressible":true},"application/cstadata+xml":{"source":"iana","compressible":true},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cwt":{"source":"iana"},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","compressible":true,"extensions":["mpd"]},"application/dash-patch+xml":{"source":"iana","compressible":true,"extensions":["mpp"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","compressible":true,"extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana","compressible":true},"application/dicom":{"source":"iana"},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana","compressible":true},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/dns+json":{"source":"iana","compressible":true},"application/dns-message":{"source":"iana"},"application/docbook+xml":{"source":"apache","compressible":true,"extensions":["dbk"]},"application/dots+cbor":{"source":"iana"},"application/dskpp+xml":{"source":"iana","compressible":true},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","compressible":true,"extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/ecmascript":{"source":"iana","compressible":true,"extensions":["es","ecma"]},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/elm+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/elm+xml":{"source":"iana","compressible":true},"application/emergencycalldata.cap+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/emergencycalldata.comment+xml":{"source":"iana","compressible":true},"application/emergencycalldata.control+xml":{"source":"iana","compressible":true},"application/emergencycalldata.deviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.providerinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.serviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.veds+xml":{"source":"iana","compressible":true},"application/emma+xml":{"source":"iana","compressible":true,"extensions":["emma"]},"application/emotionml+xml":{"source":"iana","compressible":true,"extensions":["emotionml"]},"application/encaprtp":{"source":"iana"},"application/epp+xml":{"source":"iana","compressible":true},"application/epub+zip":{"source":"iana","compressible":false,"extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/expect-ct-report+json":{"source":"iana","compressible":true},"application/express":{"source":"iana","extensions":["exp"]},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdt+xml":{"source":"iana","compressible":true,"extensions":["fdt"]},"application/fhir+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/fhir+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/flexfec":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false},"application/framework-attributes+xml":{"source":"iana","compressible":true},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geopackage+sqlite3":{"source":"iana"},"application/geoxacml+xml":{"source":"iana","compressible":true},"application/gltf-buffer":{"source":"iana"},"application/gml+xml":{"source":"iana","compressible":true,"extensions":["gml"]},"application/gpx+xml":{"source":"apache","compressible":true,"extensions":["gpx"]},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana","compressible":true},"application/hjson":{"extensions":["hjson"]},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana","compressible":true},"application/ibe-pkg-reply+xml":{"source":"iana","compressible":true},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","compressible":true,"extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana","compressible":true,"extensions":["its"]},"application/java-archive":{"source":"apache","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/jscalendar+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana","compressible":true},"application/kpml-response+xml":{"source":"iana","compressible":true},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana","compressible":true,"extensions":["lgr"]},"application/link-format":{"source":"iana"},"application/load-control+xml":{"source":"iana","compressible":true},"application/lost+xml":{"source":"iana","compressible":true,"extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana","compressible":true},"application/lpf+zip":{"source":"iana","compressible":false},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","compressible":true,"extensions":["mads"]},"application/manifest+json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","compressible":true,"extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","compressible":true,"extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana","compressible":true},"application/mathml-presentation+xml":{"source":"iana","compressible":true},"application/mbms-associated-procedure-description+xml":{"source":"iana","compressible":true},"application/mbms-deregister+xml":{"source":"iana","compressible":true},"application/mbms-envelope+xml":{"source":"iana","compressible":true},"application/mbms-msk+xml":{"source":"iana","compressible":true},"application/mbms-msk-response+xml":{"source":"iana","compressible":true},"application/mbms-protection-description+xml":{"source":"iana","compressible":true},"application/mbms-reception-report+xml":{"source":"iana","compressible":true},"application/mbms-register+xml":{"source":"iana","compressible":true},"application/mbms-register-response+xml":{"source":"iana","compressible":true},"application/mbms-schedule+xml":{"source":"iana","compressible":true},"application/mbms-user-service-description+xml":{"source":"iana","compressible":true},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana","compressible":true,"extensions":["mpf"]},"application/media_control+xml":{"source":"iana","compressible":true},"application/mediaservercontrol+xml":{"source":"iana","compressible":true,"extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","compressible":true,"extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","compressible":true,"extensions":["meta4"]},"application/mets+xml":{"source":"iana","compressible":true,"extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mipc":{"source":"iana"},"application/missing-blocks+cbor-seq":{"source":"iana"},"application/mmt-aei+xml":{"source":"iana","compressible":true,"extensions":["maei"]},"application/mmt-usd+xml":{"source":"iana","compressible":true,"extensions":["musd"]},"application/mods+xml":{"source":"iana","compressible":true,"extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana","compressible":true},"application/mrb-publish+xml":{"source":"iana","compressible":true},"application/msc-ivr+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msc-mixer+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/multipart-core":{"source":"iana"},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana","extensions":["nq"]},"application/n-triples":{"source":"iana","extensions":["nt"]},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana","charset":"US-ASCII"},"application/news-groupinfo":{"source":"iana","charset":"US-ASCII"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana","compressible":true},"application/node":{"source":"iana","extensions":["cjs"]},"application/nss":{"source":"iana"},"application/oauth-authz-req+jwt":{"source":"iana"},"application/oblivious-dns-message":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":false,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odm+xml":{"source":"iana","compressible":true},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","compressible":true,"extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/omdoc+xml":{"source":"apache","compressible":true,"extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg"]},"application/opc-nodeset+xml":{"source":"iana","compressible":true},"application/oscore":{"source":"iana"},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p21":{"source":"iana"},"application/p21+zip":{"source":"iana","compressible":false},"application/p2p-overlay+xml":{"source":"iana","compressible":true,"extensions":["relo"]},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","compressible":true,"extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pem-certificate-chain":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana","extensions":["asc"]},"application/pgp-signature":{"source":"iana","extensions":["asc","sig"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pidf-diff+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkcs8-encrypted":{"source":"iana"},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","compressible":true,"extensions":["pls"]},"application/poc-settings+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana","compressible":true},"application/provenance+xml":{"source":"iana","compressible":true,"extensions":["provx"]},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.cyn":{"source":"iana","charset":"7-BIT"},"application/prs.hpub+zip":{"source":"iana","compressible":false},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana","compressible":true},"application/pskc+xml":{"source":"iana","compressible":true,"extensions":["pskcxml"]},"application/pvd+json":{"source":"iana","compressible":true},"application/qsig":{"source":"iana"},"application/raml+yaml":{"compressible":true,"extensions":["raml"]},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf","owl"]},"application/reginfo+xml":{"source":"iana","compressible":true,"extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"iana"},"application/reputon+json":{"source":"iana","compressible":true},"application/resource-lists+xml":{"source":"iana","compressible":true,"extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","compressible":true,"extensions":["rld"]},"application/rfc+xml":{"source":"iana","compressible":true},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana","compressible":true},"application/rls-services+xml":{"source":"iana","compressible":true,"extensions":["rs"]},"application/route-apd+xml":{"source":"iana","compressible":true,"extensions":["rapd"]},"application/route-s-tsid+xml":{"source":"iana","compressible":true,"extensions":["sls"]},"application/route-usd+xml":{"source":"iana","compressible":true,"extensions":["rusd"]},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","compressible":true,"extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana","compressible":true},"application/samlmetadata+xml":{"source":"iana","compressible":true},"application/sarif+json":{"source":"iana","compressible":true},"application/sarif-external-properties+json":{"source":"iana","compressible":true},"application/sbe":{"source":"iana"},"application/sbml+xml":{"source":"iana","compressible":true,"extensions":["sbml"]},"application/scaip+xml":{"source":"iana","compressible":true},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/secevent+jwt":{"source":"iana"},"application/senml+cbor":{"source":"iana"},"application/senml+json":{"source":"iana","compressible":true},"application/senml+xml":{"source":"iana","compressible":true,"extensions":["senmlx"]},"application/senml-etch+cbor":{"source":"iana"},"application/senml-etch+json":{"source":"iana","compressible":true},"application/senml-exi":{"source":"iana"},"application/sensml+cbor":{"source":"iana"},"application/sensml+json":{"source":"iana","compressible":true},"application/sensml+xml":{"source":"iana","compressible":true,"extensions":["sensmlx"]},"application/sensml-exi":{"source":"iana"},"application/sep+xml":{"source":"iana","compressible":true},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","compressible":true,"extensions":["shf"]},"application/sieve":{"source":"iana","extensions":["siv","sieve"]},"application/simple-filter+xml":{"source":"iana","compressible":true},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/sipc":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"iana"},"application/smil+xml":{"source":"iana","compressible":true,"extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","compressible":true,"extensions":["srx"]},"application/spdx+json":{"source":"iana","compressible":true},"application/spirits-event+xml":{"source":"iana","compressible":true},"application/sql":{"source":"iana"},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","compressible":true,"extensions":["grxml"]},"application/sru+xml":{"source":"iana","compressible":true,"extensions":["sru"]},"application/ssdl+xml":{"source":"apache","compressible":true,"extensions":["ssdl"]},"application/ssml+xml":{"source":"iana","compressible":true,"extensions":["ssml"]},"application/stix+json":{"source":"iana","compressible":true},"application/swid+xml":{"source":"iana","compressible":true,"extensions":["swidtag"]},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/taxii+json":{"source":"iana","compressible":true},"application/td+json":{"source":"iana","compressible":true},"application/tei+xml":{"source":"iana","compressible":true,"extensions":["tei","teicorpus"]},"application/tetra_isi":{"source":"iana"},"application/thraud+xml":{"source":"iana","compressible":true,"extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/tlsrpt+gzip":{"source":"iana"},"application/tlsrpt+json":{"source":"iana","compressible":true},"application/tnauthlist":{"source":"iana"},"application/token-introspection+jwt":{"source":"iana"},"application/toml":{"compressible":true,"extensions":["toml"]},"application/trickle-ice-sdpfrag":{"source":"iana"},"application/trig":{"source":"iana","extensions":["trig"]},"application/ttml+xml":{"source":"iana","compressible":true,"extensions":["ttml"]},"application/tve-trigger":{"source":"iana"},"application/tzif":{"source":"iana"},"application/tzif-leap":{"source":"iana"},"application/ubjson":{"compressible":false,"extensions":["ubj"]},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana","compressible":true},"application/urc-ressheet+xml":{"source":"iana","compressible":true,"extensions":["rsheet"]},"application/urc-targetdesc+xml":{"source":"iana","compressible":true,"extensions":["td"]},"application/urc-uisocketdesc+xml":{"source":"iana","compressible":true},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana","compressible":true},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana","compressible":true,"extensions":["1km"]},"application/vnd.3gpp-prose+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-v2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.5gnas":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.bsf+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gmop+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gtpc":{"source":"iana"},"application/vnd.3gpp.interworking-data":{"source":"iana"},"application/vnd.3gpp.lpp":{"source":"iana"},"application/vnd.3gpp.mc-signalling-ear":{"source":"iana"},"application/vnd.3gpp.mcdata-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-payload":{"source":"iana"},"application/vnd.3gpp.mcdata-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-signalling":{"source":"iana"},"application/vnd.3gpp.mcdata-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-floor-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-signed+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-init-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-transmission-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mid-call+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ngap":{"source":"iana"},"application/vnd.3gpp.pfcp":{"source":"iana"},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.s1ap":{"source":"iana"},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ussd+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","compressible":false,"extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","compressible":true,"extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"iana","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.afpc.afplinedata":{"source":"iana"},"application/vnd.afpc.afplinedata-pagedef":{"source":"iana"},"application/vnd.afpc.cmoca-cmresource":{"source":"iana"},"application/vnd.afpc.foca-charset":{"source":"iana"},"application/vnd.afpc.foca-codedfont":{"source":"iana"},"application/vnd.afpc.foca-codepage":{"source":"iana"},"application/vnd.afpc.modca":{"source":"iana"},"application/vnd.afpc.modca-cmtable":{"source":"iana"},"application/vnd.afpc.modca-formdef":{"source":"iana"},"application/vnd.afpc.modca-mediummap":{"source":"iana"},"application/vnd.afpc.modca-objectcontainer":{"source":"iana"},"application/vnd.afpc.modca-overlay":{"source":"iana"},"application/vnd.afpc.modca-pagesegment":{"source":"iana"},"application/vnd.age":{"source":"iana","extensions":["age"]},"application/vnd.ah-barcode":{"source":"iana"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amadeus+json":{"source":"iana","compressible":true},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana","compressible":true},"application/vnd.android.ota":{"source":"iana"},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.arrow.file":{"source":"iana"},"application/vnd.apache.arrow.stream":{"source":"iana"},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.aplextor.warrp+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","compressible":true,"extensions":["mpkg"]},"application/vnd.apple.keynote":{"source":"iana","extensions":["key"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.numbers":{"source":"iana","extensions":["numbers"]},"application/vnd.apple.pages":{"source":"iana","extensions":["pages"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"iana"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artisan+json":{"source":"iana","compressible":true},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avalon+json":{"source":"iana","compressible":true},"application/vnd.avistar+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmml+xml":{"source":"iana","compressible":true,"extensions":["bmml"]},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.banana-accounting":{"source":"iana"},"application/vnd.bbf.usp.error":{"source":"iana"},"application/vnd.bbf.usp.msg":{"source":"iana"},"application/vnd.bbf.usp.msg+json":{"source":"iana","compressible":true},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana","compressible":true},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.bpf":{"source":"iana"},"application/vnd.bpf3":{"source":"iana"},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.byu.uapi+json":{"source":"iana","compressible":true},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","compressible":true,"extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.ciedi":{"source":"iana"},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana","compressible":true,"extensions":["csl"]},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collabio.xodocuments.document":{"source":"iana"},"application/vnd.collabio.xodocuments.document-template":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation-template":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet-template":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana","compressible":false},"application/vnd.comicbook-rar":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","compressible":true,"extensions":["wbs"]},"application/vnd.cryptii.pipe+json":{"source":"iana","compressible":true},"application/vnd.crypto-shade-file":{"source":"iana"},"application/vnd.cryptomator.encrypted":{"source":"iana"},"application/vnd.cryptomator.vault":{"source":"iana"},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana","compressible":true},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana","compressible":true},"application/vnd.cybank":{"source":"iana"},"application/vnd.cyclonedx+json":{"source":"iana","compressible":true},"application/vnd.cyclonedx+xml":{"source":"iana","compressible":true},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana","compressible":false},"application/vnd.d3m-dataset":{"source":"iana"},"application/vnd.d3m-problem":{"source":"iana"},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.dbf":{"source":"iana","extensions":["dbf"]},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","compressible":true,"extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume.movie":{"source":"iana"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana","compressible":true},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbisl+xml":{"source":"iana","compressible":true},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-container+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-generic+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-init+xml":{"source":"iana","compressible":true},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecip.rlp":{"source":"iana"},"application/vnd.eclipse.ditto+json":{"source":"iana","compressible":true},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.emclient.accessrequest+xml":{"source":"iana","compressible":true},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana","compressible":true},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana","compressible":false},"application/vnd.eszigno3+xml":{"source":"iana","compressible":true,"extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.asic-e+zip":{"source":"iana","compressible":false},"application/vnd.etsi.asic-s+zip":{"source":"iana","compressible":false},"application/vnd.etsi.cug+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvcommand+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvservice+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsync+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mcid+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana","compressible":true},"application/vnd.etsi.pstn+xml":{"source":"iana","compressible":true},"application/vnd.etsi.sci+xml":{"source":"iana","compressible":true},"application/vnd.etsi.simservs+xml":{"source":"iana","compressible":true},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana","compressible":true},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eu.kasparian.car+json":{"source":"iana","compressible":true},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.exstream-empower+zip":{"source":"iana","compressible":false},"application/vnd.exstream-package":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.familysearch.gedcom+zip":{"source":"iana","compressible":false},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"iana","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.ffsns":{"source":"iana"},"application/vnd.ficlab.flb+zip":{"source":"iana","compressible":false},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.frogans.fnc":{"source":"iana","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"iana","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujifilm.fb.docuworks":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.binder":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.container":{"source":"iana"},"application/vnd.fujifilm.fb.jfi+xml":{"source":"iana","compressible":true},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.futoin+cbor":{"source":"iana"},"application/vnd.futoin+json":{"source":"iana","compressible":true},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.gentics.grd+json":{"source":"iana","compressible":true},"application/vnd.geo+json":{"source":"iana","compressible":true},"application/vnd.geocube+xml":{"source":"iana","compressible":true},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.slides":{"source":"iana"},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"iana","compressible":true},"application/vnd.gov.sk.e-form+zip":{"source":"iana","compressible":false},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana","compressible":true},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","compressible":true,"extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","compressible":true,"extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hl7cda+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hl7v2+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper+json":{"source":"iana","compressible":true},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"iana"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"iana","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana","compressible":false},"application/vnd.imagemeter.image+zip":{"source":"iana","compressible":false},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana","compressible":true},"application/vnd.informix-visionary":{"source":"iana"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana","compressible":true},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana","compressible":true},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","compressible":true,"extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.iso11783-10+zip":{"source":"iana","compressible":false},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las":{"source":"iana"},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","compressible":true,"extensions":["lasxml"]},"application/vnd.laszip":{"source":"iana"},"application/vnd.leap+json":{"source":"iana","compressible":true},"application/vnd.liberty-request+xml":{"source":"iana","compressible":true},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","compressible":true,"extensions":["lbe"]},"application/vnd.logipipe.circuit+zip":{"source":"iana","compressible":false},"application/vnd.loom":{"source":"iana"},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana","extensions":["mvt"]},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.license+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxar.archive.3tz+zip":{"source":"iana","compressible":false},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana","compressible":true},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana","compressible":true},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana","compressible":true},"application/vnd.ms-printing.printticket+xml":{"source":"apache","compressible":true},"application/vnd.ms-printschematicket+xml":{"source":"iana","compressible":true},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.nacamar.ybrid+json":{"source":"iana","compressible":true},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nebumind.line":{"source":"iana"},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nimn":{"source":"iana"},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana","compressible":true},"application/vnd.nokia.iptv.config+xml":{"source":"iana","compressible":true},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana","compressible":true},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana","compressible":true,"extensions":["ac"]},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"iana","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana","compressible":true},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"iana","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oci.image.manifest.v1+json":{"source":"iana","compressible":true},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana","compressible":true},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana","compressible":true},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana","compressible":true},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana","compressible":true},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.oipf.spdlist+xml":{"source":"iana","compressible":true},"application/vnd.oipf.ueprofile+xml":{"source":"iana","compressible":true},"application/vnd.oipf.userprofile+xml":{"source":"iana","compressible":true},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.imd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sprov+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-pcc+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana","compressible":true},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","compressible":true,"extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana","compressible":true},"application/vnd.oma.group-usage-list+xml":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+cbor":{"source":"iana"},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.final-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.groups+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana","compressible":true},"application/vnd.oma.xcap-directory+xml":{"source":"iana","compressible":true},"application/vnd.omads-email+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-file+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-folder+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana","compressible":true,"extensions":["obgx"]},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana","compressible":true,"extensions":["osm"]},"application/vnd.opentimestamps.ots":{"source":"iana"},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"iana","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"iana","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"iana","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana","compressible":true},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana","compressible":true},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos.xml":{"source":"iana"},"application/vnd.patentdive":{"source":"iana"},"application/vnd.patientecommsdoc":{"source":"iana"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana","compressible":true},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.psfs":{"source":"iana"},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana","compressible":true},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana","compressible":true},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana","extensions":["rar"]},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","compressible":true,"extensions":["musicxml"]},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.resilient.logic":{"source":"iana"},"application/vnd.restful+json":{"source":"iana","compressible":true},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","compressible":true,"extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sar":{"source":"iana"},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.seis+json":{"source":"iana","compressible":true},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shade-save-file":{"source":"iana"},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.shootproof+json":{"source":"iana","compressible":true},"application/vnd.shopkick+json":{"source":"iana","compressible":true},"application/vnd.shp":{"source":"iana"},"application/vnd.shx":{"source":"iana"},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.snesdev-page-table":{"source":"iana"},"application/vnd.software602.filler.form+xml":{"source":"iana","compressible":true,"extensions":["fo"]},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","compressible":true,"extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sqlite3":{"source":"iana"},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.sycle+xml":{"source":"iana","compressible":true},"application/vnd.syft+json":{"source":"iana","compressible":true},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","charset":"UTF-8","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["ddf"]},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.think-cell.ppttc+json":{"source":"iana","compressible":true},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana","compressible":true},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","compressible":true,"extensions":["uoml"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.veritone.aion+json":{"source":"iana","compressible":true},"application/vnd.veryant.thin":{"source":"iana"},"application/vnd.ves.encrypted":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","charset":"UTF-8","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.dpp":{"source":"iana"},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana","compressible":true},"application/vnd.wv.ssp+xml":{"source":"iana","compressible":true},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana","compressible":true},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","compressible":true,"extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.youtube.yt":{"source":"iana"},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","compressible":true,"extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","compressible":true,"extensions":["vxml"]},"application/voucher-cms+json":{"source":"iana","compressible":true},"application/vq-rtcpxr":{"source":"iana"},"application/wasm":{"source":"iana","compressible":true,"extensions":["wasm"]},"application/watcherinfo+xml":{"source":"iana","compressible":true,"extensions":["wif"]},"application/webpush-options+json":{"source":"iana","compressible":true},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","compressible":true,"extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","compressible":true,"extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","compressible":true,"extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","compressible":true,"extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","compressible":true,"extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-iwork-keynote-sffkey":{"extensions":["key"]},"application/x-iwork-numbers-sffnumbers":{"extensions":["numbers"]},"application/x-iwork-pages-sffpages":{"extensions":["pages"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-keepass2":{"extensions":["kdbx"]},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-pki-message":{"source":"iana"},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"iana","extensions":["der","crt","pem"]},"application/x-x509-ca-ra-cert":{"source":"iana"},"application/x-x509-next-ca-cert":{"source":"iana"},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","compressible":true,"extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana","compressible":true},"application/xaml+xml":{"source":"apache","compressible":true,"extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana","compressible":true,"extensions":["xav"]},"application/xcap-caps+xml":{"source":"iana","compressible":true,"extensions":["xca"]},"application/xcap-diff+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana","compressible":true,"extensions":["xel"]},"application/xcap-error+xml":{"source":"iana","compressible":true},"application/xcap-ns+xml":{"source":"iana","compressible":true,"extensions":["xns"]},"application/xcon-conference-info+xml":{"source":"iana","compressible":true},"application/xcon-conference-info-diff+xml":{"source":"iana","compressible":true},"application/xenc+xml":{"source":"iana","compressible":true,"extensions":["xenc"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache","compressible":true},"application/xliff+xml":{"source":"iana","compressible":true,"extensions":["xlf"]},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana","compressible":true},"application/xmpp+xml":{"source":"iana","compressible":true},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","compressible":true,"extensions":["xpl"]},"application/xslt+xml":{"source":"iana","compressible":true,"extensions":["xsl","xslt"]},"application/xspf+xml":{"source":"apache","compressible":true,"extensions":["xspf"]},"application/xv+xml":{"source":"iana","compressible":true,"extensions":["mxml","xhvml","xvml","xvm"]},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana","compressible":true},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana","compressible":true},"application/yin+xml":{"source":"iana","compressible":true,"extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zlib":{"source":"iana"},"application/zstd":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/aac":{"source":"iana"},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana","extensions":["amr"]},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/flexfec":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/mhas":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/mobile-xmf":{"source":"iana","extensions":["mxmf"]},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx","opus"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/scip":{"source":"iana"},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sofa":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tetra_acelp":{"source":"iana"},"audio/tetra_acelp_bb":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/tsvcis":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/usac":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dts.uhd":{"source":"iana"},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"iana"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/collection":{"source":"iana","extensions":["ttc"]},"font/otf":{"source":"iana","compressible":true,"extensions":["otf"]},"font/sfnt":{"source":"iana"},"font/ttf":{"source":"iana","compressible":true,"extensions":["ttf"]},"font/woff":{"source":"iana","extensions":["woff"]},"font/woff2":{"source":"iana","extensions":["woff2"]},"image/aces":{"source":"iana","extensions":["exr"]},"image/apng":{"compressible":false,"extensions":["apng"]},"image/avci":{"source":"iana","extensions":["avci"]},"image/avcs":{"source":"iana","extensions":["avcs"]},"image/avif":{"source":"iana","compressible":false,"extensions":["avif"]},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana","extensions":["drle"]},"image/emf":{"source":"iana","extensions":["emf"]},"image/fits":{"source":"iana","extensions":["fits"]},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/heic":{"source":"iana","extensions":["heic"]},"image/heic-sequence":{"source":"iana","extensions":["heics"]},"image/heif":{"source":"iana","extensions":["heif"]},"image/heif-sequence":{"source":"iana","extensions":["heifs"]},"image/hej2k":{"source":"iana","extensions":["hej2"]},"image/hsj2":{"source":"iana","extensions":["hsj2"]},"image/ief":{"source":"iana","extensions":["ief"]},"image/jls":{"source":"iana","extensions":["jls"]},"image/jp2":{"source":"iana","compressible":false,"extensions":["jp2","jpg2"]},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpeg","jpg","jpe"]},"image/jph":{"source":"iana","extensions":["jph"]},"image/jphc":{"source":"iana","extensions":["jhc"]},"image/jpm":{"source":"iana","compressible":false,"extensions":["jpm"]},"image/jpx":{"source":"iana","compressible":false,"extensions":["jpx","jpf"]},"image/jxr":{"source":"iana","extensions":["jxr"]},"image/jxra":{"source":"iana","extensions":["jxra"]},"image/jxrs":{"source":"iana","extensions":["jxrs"]},"image/jxs":{"source":"iana","extensions":["jxs"]},"image/jxsc":{"source":"iana","extensions":["jxsc"]},"image/jxsi":{"source":"iana","extensions":["jxsi"]},"image/jxss":{"source":"iana","extensions":["jxss"]},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/ktx2":{"source":"iana","extensions":["ktx2"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif"]},"image/prs.pti":{"source":"iana","extensions":["pti"]},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana","extensions":["t38"]},"image/tiff":{"source":"iana","compressible":false,"extensions":["tif","tiff"]},"image/tiff-fx":{"source":"iana","extensions":["tfx"]},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana","extensions":["azv"]},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana","compressible":true,"extensions":["ico"]},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-dds":{"compressible":true,"extensions":["dds"]},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.pco.b16":{"source":"iana","extensions":["b16"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana","extensions":["tap"]},"image/vnd.valve.source.texture":{"source":"iana","extensions":["vtf"]},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana","extensions":["pcx"]},"image/webp":{"source":"apache","extensions":["webp"]},"image/wmf":{"source":"iana","extensions":["wmf"]},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana","extensions":["disposition-notification"]},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana","extensions":["u8msg"]},"message/global-delivery-status":{"source":"iana","extensions":["u8dsn"]},"message/global-disposition-notification":{"source":"iana","extensions":["u8mdn"]},"message/global-headers":{"source":"iana","extensions":["u8hdr"]},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/news":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime"]},"message/s-http":{"source":"iana"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"iana"},"message/vnd.wfa.wsc":{"source":"iana","extensions":["wsc"]},"model/3mf":{"source":"iana","extensions":["3mf"]},"model/e57":{"source":"iana"},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"source":"iana","compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/mtl":{"source":"iana","extensions":["mtl"]},"model/obj":{"source":"iana","extensions":["obj"]},"model/step":{"source":"iana"},"model/step+xml":{"source":"iana","compressible":true,"extensions":["stpx"]},"model/step+zip":{"source":"iana","compressible":false,"extensions":["stpz"]},"model/step-xml+zip":{"source":"iana","compressible":false,"extensions":["stpxz"]},"model/stl":{"source":"iana","extensions":["stl"]},"model/vnd.collada+xml":{"source":"iana","compressible":true,"extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana","compressible":true},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana","extensions":["ogex"]},"model/vnd.parasolid.transmit.binary":{"source":"iana","extensions":["x_b"]},"model/vnd.parasolid.transmit.text":{"source":"iana","extensions":["x_t"]},"model/vnd.pytha.pyox":{"source":"iana"},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.sap.vds":{"source":"iana","extensions":["vds"]},"model/vnd.usdz+zip":{"source":"iana","compressible":false,"extensions":["usdz"]},"model/vnd.valve.source.compiled-map":{"source":"iana","extensions":["bsp"]},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana","extensions":["x3db"]},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana","extensions":["x3dv"]},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana"},"multipart/multilingual":{"source":"iana"},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/cql":{"source":"iana"},"text/cql-expression":{"source":"iana"},"text/cql-identifier":{"source":"iana"},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"iana"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/fhirpath":{"source":"iana"},"text/flexfec":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/gff3":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","compressible":true},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"compressible":true,"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["markdown","md"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mdx":{"compressible":true,"extensions":["mdx"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana","charset":"UTF-8"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana","charset":"UTF-8"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/shaclc":{"source":"iana"},"text/shex":{"source":"iana","extensions":["shex"]},"text/slim":{"extensions":["slim","slm"]},"text/spdx":{"source":"iana","extensions":["spdx"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","charset":"UTF-8","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana","charset":"UTF-8"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana","charset":"UTF-8"},"text/vnd.familysearch.gedcom":{"source":"iana","extensions":["ged"]},"text/vnd.ficlab.flt":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.gml":{"source":"iana"},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.hans":{"source":"iana"},"text/vnd.hgl":{"source":"iana"},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.senx.warpscript":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"iana"},"text/vnd.sosi":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","charset":"UTF-8","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana","charset":"UTF-8"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vtt":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"compressible":true,"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/av1":{"source":"iana"},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/ffv1":{"source":"iana"},"video/flexfec":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/iso.segment":{"source":"iana","extensions":["m4s"]},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/jxsv":{"source":"iana"},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/scip":{"source":"iana"},"video/smpte291":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vc2":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.mp4vr":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"iana"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vnd.youtube.yt":{"source":"iana"},"video/vp8":{"source":"iana"},"video/vp9":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}');
      }
    },
        a = {};

    function n(i) {
      var t = a[i];
      if (void 0 !== t) return t.exports;
      var s = a[i] = {
        exports: {}
      };
      return e[i].call(s.exports, s, s.exports, n), s.exports;
    }

    n.n = function (e) {
      var a = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(a, {
        a: a
      }), a;
    }, n.d = function (e, a) {
      for (var i in a) {
        n.o(a, i) && !n.o(e, i) && Object.defineProperty(e, i, {
          enumerable: !0,
          get: a[i]
        });
      }
    }, n.o = function (e, a) {
      return Object.prototype.hasOwnProperty.call(e, a);
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var i = {};
    return function () {
      "use strict";

      n.r(i), n.d(i, {
        FETCHING_LOCALES: function FETCHING_LOCALES() {
          return j;
        },
        FETCHING_TRANSLATIONS: function FETCHING_TRANSLATIONS() {
          return b;
        },
        LOCALES_FETCHED: function LOCALES_FETCHED() {
          return _;
        },
        LOCALES_FETCH_FAILED: function LOCALES_FETCH_FAILED() {
          return S;
        },
        LOCALE_CHANGED: function LOCALE_CHANGED() {
          return k;
        },
        MessageFormatRenderer: function MessageFormatRenderer() {
          return U;
        },
        PseudoTranslationPolicy: function PseudoTranslationPolicy() {
          return P;
        },
        SourceErrorPolicy: function SourceErrorPolicy() {
          return $;
        },
        SourceStringPolicy: function SourceStringPolicy() {
          return D;
        },
        TRANSLATIONS_FETCHED: function TRANSLATIONS_FETCHED() {
          return y;
        },
        TRANSLATIONS_FETCH_FAILED: function TRANSLATIONS_FETCH_FAILED() {
          return w;
        },
        ThrowErrorPolicy: function ThrowErrorPolicy() {
          return I;
        },
        createNativeInstance: function createNativeInstance() {
          return M;
        },
        escape: function escape() {
          return h;
        },
        explodePlurals: function explodePlurals() {
          return A;
        },
        generateHashedKey: function generateHashedKey() {
          return f;
        },
        generateKey: function generateKey() {
          return d;
        },
        implodePlurals: function implodePlurals() {
          return F;
        },
        isPluralized: function isPluralized() {
          return q;
        },
        isString: function isString() {
          return x;
        },
        normalizeLocale: function normalizeLocale() {
          return v;
        },
        offEvent: function offEvent() {
          return T;
        },
        onEvent: function onEvent() {
          return O;
        },
        sendEvent: function sendEvent() {
          return C;
        },
        sleep: function sleep() {
          return g;
        },
        t: function t() {
          return W;
        },
        tx: function tx() {
          return H;
        }
      });
      var e = n(9669),
          a = n.n(e);

      var t = /*#__PURE__*/function () {
        function t() {
          _classCallCheck(this, t);

          this.translationsByLocale = {};
        }

        _createClass(t, [{
          key: "update",
          value: function update(e, a) {
            this.translationsByLocale[e] || (this.translationsByLocale[e] = {}), Object.assign(this.translationsByLocale[e], a);
          }
        }, {
          key: "getTranslations",
          value: function getTranslations(e) {
            return this.translationsByLocale[e] || {};
          }
        }, {
          key: "hasTranslations",
          value: function hasTranslations(e) {
            return !!this.translationsByLocale[e];
          }
        }, {
          key: "isStale",
          value: function isStale(e) {
            return !this.hasTranslations(e);
          }
        }, {
          key: "get",
          value: function get(e, a) {
            return this.getTranslations(a)[e] || "";
          }
        }]);

        return t;
      }();

      var s = /*#__PURE__*/function () {
        function s() {
          _classCallCheck(this, s);
        }

        _createClass(s, [{
          key: "handle",
          value: function handle(e, a, n, i) {
            return a;
          }
        }]);

        return s;
      }();

      var o = /*#__PURE__*/function () {
        function o() {
          _classCallCheck(this, o);
        }

        _createClass(o, [{
          key: "handle",
          value: function handle(e, a) {
            return e;
          }
        }]);

        return o;
      }();

      var r = n(5150),
          c = n.n(r);
      var p = {};

      var l = /*#__PURE__*/function () {
        function l() {
          _classCallCheck(this, l);
        }

        _createClass(l, [{
          key: "render",
          value: function render(e, a, n) {
            var i = (a || "").split("_")[0];
            if (!p[i]) try {
              p[i] = new (c())(i);
            } catch (e) {
              p[i] = new (c())();
            }
            return p[i].compile(e)(n);
          }
        }]);

        return l;
      }();

      var u = n(2568),
          m = n.n(u);

      function d(e) {
        var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return a._key ? a._key : a._context ? "".concat(e, "::").concat(a._context) : "".concat(e);
      }

      function f(e) {
        var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (a._key) return a._key;
        var n = "";
        return a._context && (n = a._context, n = n.replace(/,/g, ":")), m()("5:".concat(e, ":").concat(n));
      }

      function h(e) {
        return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
      }

      function x(e) {
        return "[object String]" === Object.prototype.toString.call(e);
      }

      function v(e) {
        var a = e.split("-");
        var n;
        return n = 1 === a.length ? e : [a[0], a[1].toUpperCase()].join("_"), n;
      }

      function g(e) {
        return new Promise(function (a) {
          setTimeout(function () {
            a();
          }, e);
        });
      }

      var b = "FETCHING_TRANSLATIONS",
          y = "TRANSLATIONS_FETCHED",
          w = "TRANSLATIONS_FETCH_FAILED",
          k = "LOCALE_CHANGED",
          j = "FETCHING_LOCALES",
          _ = "LOCALES_FETCHED",
          S = "LOCALES_FETCH_FAILED",
          E = {};

      function O(e, a) {
        E[e] = E[e] || [], E[e].push(a);
      }

      function T(e, a) {
        var n = E[e] || [],
            i = n.indexOf(a);
        -1 !== i && n.splice(i, 1);
      }

      function C(e, a, n) {
        (E[e] || []).forEach(function (e) {
          e(a, n);
        });
      }

      var z = ["zero", "one", "two", "few", "many", "other"];

      function N(e) {
        var a = e.indexOf("{");
        if (-1 === a) return [null, null];
        var n = e.substring(0, a).trim();

        if ("=" === n[0]) {
          if (n = n.substring(1), Number.isNaN(parseInt(n, 10)) || parseInt(n, 10) !== parseFloat(n)) return [null, null];
          if (n = parseInt(n, 10), n = z[n], void 0 === n) return [null, null];
        } else if (-1 === z.indexOf(n)) return [null, null];

        return [n, e.substring(a)];
      }

      function R(e) {
        var a = 0,
            n = !1,
            i = 0;

        for (; i < e.length;) {
          var _t19 = e[i];

          if ("'" === _t19) {
            var _a23 = e[i + 1];
            "'" === _a23 ? i += 1 : n ? n = !1 : "{" !== _a23 && "}" !== _a23 || (n = !0);
          } else if ("{" === _t19) n || (a += 1);else if ("}" === _t19 && (n || (a -= 1), 0 === a)) return [e.substring(1, i), e.substring(i + 1).trim()];

          i += 1;
        }

        return [null, null];
      }

      function A(e) {
        var _N, _N2, _R, _R2;

        var a = [null, {
          other: e
        }];

        var _ref11 = function (e) {
          if (!(e.length > 1 && "{" === e[0] && "}" === e[e.length - 1])) return [null, null];
          var a = e.indexOf(",");
          if (-1 === a) return [null, null];
          var n = e.indexOf(",", a + 1);
          if (-1 === n) return [null, null];
          var i = e.substring(1, a).trim(),
              t = e.substring(a + 1, n).trim();
          return /^[\w_]+$/.test(i) && "plural" === t ? [i, e.substring(n + 1, e.length - 1).trim()] : [null, null];
        }(e),
            _ref12 = _slicedToArray(_ref11, 2),
            n = _ref12[0],
            i = _ref12[1];

        if (null == n) return a;
        var t = {};
        var s, o;
        if ((_N = N(i), _N2 = _slicedToArray(_N, 2), s = _N2[0], i = _N2[1]), null == s) return a;
        if ((_R = R(i.trim()), _R2 = _slicedToArray(_R, 2), o = _R2[0], i = _R2[1]), null == o) return a;

        for (t[s] = o; i.trim();) {
          var _N3, _N4, _R3, _R4;

          if ((_N3 = N(i.trim()), _N4 = _slicedToArray(_N3, 2), s = _N4[0], i = _N4[1]), null == s) return a;
          if ((_R3 = R(i.trim()), _R4 = _slicedToArray(_R3, 2), o = _R4[0], i = _R4[1]), null == o) return a;
          t[s] = o;
        }

        return (1 !== Object.keys(t).length || "other" in t) && "one" in t && "other" in t ? [n, t] : a;
      }

      function F(e) {
        var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "???";
        var n = ["{".concat(a, ", plural,")];

        var _iterator15 = _createForOfIteratorHelper(z),
            _step15;

        try {
          for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
            var _a24 = _step15.value;

            if (_a24 in e) {
              var _i29 = e[_a24];
              n.push(" ".concat(_a24, " {").concat(_i29, "}"));
            }
          }
        } catch (err) {
          _iterator15.e(err);
        } finally {
          _iterator15.f();
        }

        return n.push("}"), n.join("");
      }

      function q(e) {
        var a = A(e)[1];
        return Object.keys(a).length > 1;
      }

      var L = /*#__PURE__*/function () {
        function L() {
          _classCallCheck(this, L);

          this.cdsHost = "https://cds.svc.transifex.net", this.token = "", this.secret = "", this.filterTags = "", this.fetchTimeout = 0, this.fetchInterval = 250, this.cache = new t(), this.missingPolicy = new o(), this.errorPolicy = new s(), this.stringRenderer = new l(), this.currentLocale = "", this.locales = [], this.languages = [], this.childInstances = [];
        }

        _createClass(L, [{
          key: "init",
          value: function init(e) {
            var a = this;
            ["cdsHost", "token", "secret", "cache", "filterTags", "fetchTimeout", "fetchInterval", "missingPolicy", "errorPolicy", "stringRenderer", "currentLocale"].forEach(function (n) {
              void 0 !== e[n] && (a[n] = e[n]);
            }), this.fetchedTags = {};
          }
        }, {
          key: "translate",
          value: function translate(e, a) {
            return this.translateLocale(this.currentLocale, e, a);
          }
        }, {
          key: "translateLocale",
          value: function translateLocale(e, a, n) {
            try {
              var _i30 = this.cache.get(d(a, n), e);

              _i30 || (_i30 = this.cache.get(f(a, n), e)), _i30 && _i30.startsWith("{???") && q(a) && (_i30 = "{".concat(a.substring(1, a.indexOf(",")).trim()).concat(_i30.substring(4)));

              var _t20 = !1;

              if (_i30 || (_t20 = !0, _i30 = a), n && n._escapeVars) {
                var _a25 = {};
                Object.keys(n).forEach(function (e) {
                  var i = n[e];
                  _a25[e] = x(i) ? h(i) : i;
                }), _i30 = this.stringRenderer.render(_i30, e, _a25);
              } else _i30 = this.stringRenderer.render(_i30, e, n);

              return _t20 && e && (_i30 = this.missingPolicy.handle(_i30, e)), x(_i30) || (_i30 = "".concat(_i30)), _i30;
            } catch (i) {
              return this.errorPolicy.handle(i, "".concat(a), e, n);
            }
          }
        }, {
          key: "fetchTranslations",
          value: function () {
            var _fetchTranslations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
              var _this15 = this;

              var n,
                  i,
                  t,
                  _n23,
                  _s10,
                  _o4,
                  _r4,
                  _n24,
                  _r3,
                  _a26,
                  _args = arguments;

              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      n = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                      i = n.filterTags || this.filterTags;

                      if (!(!n.refresh && !this.cache.isStale(e) && (!i && this.cache.hasTranslations(e) || i && -1 !== (this.fetchedTags[e] || []).indexOf(i)))) {
                        _context.next = 4;
                        break;
                      }

                      return _context.abrupt("return");

                    case 4:
                      i && (e in this.fetchedTags || (this.fetchedTags[e] = []), -1 === this.fetchedTags[e].indexOf(i) && this.fetchedTags[e].push(i));

                      t = function t(a) {
                        return C(w, {
                          localeCode: e,
                          filterTags: i
                        }, _this15), a;
                      };

                      _context.prev = 6;
                      C(b, {
                        localeCode: e,
                        filterTags: i
                      }, this);
                      _s10 = 202;
                      _o4 = Date.now();

                    case 10:
                      if (!(202 === _s10)) {
                        _context.next = 25;
                        break;
                      }

                      _r4 = "".concat(this.cdsHost, "/content/").concat(e);
                      i && (_r4 = "".concat(_r4, "?filter[tags]=").concat(i));
                      _context.next = 15;
                      return a().get(_r4, {
                        headers: {
                          Authorization: "Bearer ".concat(this.token),
                          "Accept-version": "v2",
                          "X-NATIVE-SDK": "txjs/node/4.2.1"
                        }
                      });

                    case 15:
                      _n23 = _context.sent;
                      _s10 = _n23.status;

                      if (!(this.fetchTimeout > 0 && Date.now() - _o4 >= this.fetchTimeout)) {
                        _context.next = 19;
                        break;
                      }

                      throw t(new Error("Fetch translations timeout"));

                    case 19:
                      _context.t0 = 202 === _s10 && this.fetchInterval > 0;

                      if (!_context.t0) {
                        _context.next = 23;
                        break;
                      }

                      _context.next = 23;
                      return g(this.fetchInterval);

                    case 23:
                      _context.next = 10;
                      break;

                    case 25:
                      _n24 = _n23, _r3 = _n24.data;

                      if (!(!_r3 || !_r3.data)) {
                        _context.next = 28;
                        break;
                      }

                      throw t(new Error("Could not fetch translations"));

                    case 28:
                      _a26 = {};
                      Object.keys(_r3.data).forEach(function (e) {
                        _r3.data[e].string && (_a26[e] = _r3.data[e].string);
                      }), this.cache.update(e, _a26), C(y, {
                        localeCode: e,
                        filterTags: i
                      }, this);
                      _context.next = 35;
                      break;

                    case 32:
                      _context.prev = 32;
                      _context.t1 = _context["catch"](6);
                      throw t(_context.t1);

                    case 35:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, this, [[6, 32]]);
            }));

            function fetchTranslations(_x) {
              return _fetchTranslations.apply(this, arguments);
            }

            return fetchTranslations;
          }()
        }, {
          key: "invalidateCDS",
          value: function () {
            var _invalidateCDS = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
              var e,
                  n,
                  _args2 = arguments;
              return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      e = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};

                      if (this.token) {
                        _context2.next = 3;
                        break;
                      }

                      throw new Error("token is not defined");

                    case 3:
                      if (this.secret) {
                        _context2.next = 5;
                        break;
                      }

                      throw new Error("secret is not defined");

                    case 5:
                      n = e.purge ? "purge" : "invalidate";
                      _context2.next = 8;
                      return a().post("".concat(this.cdsHost, "/").concat(n), {}, {
                        headers: {
                          Authorization: "Bearer ".concat(this.token, ":").concat(this.secret),
                          "Accept-version": "v2",
                          "Content-Type": "application/json;charset=utf-8",
                          "X-NATIVE-SDK": "txjs/node/4.2.1"
                        }
                      });

                    case 8:
                      return _context2.abrupt("return", _context2.sent.data);

                    case 9:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, this);
            }));

            function invalidateCDS() {
              return _invalidateCDS.apply(this, arguments);
            }

            return invalidateCDS;
          }()
        }, {
          key: "pushSource",
          value: function () {
            var _pushSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
              var n,
                  i,
                  t,
                  s,
                  o,
                  _e25,
                  _n25,
                  _args3 = arguments;

              return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      n = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};

                      if (this.token) {
                        _context3.next = 3;
                        break;
                      }

                      throw new Error("token is not defined");

                    case 3:
                      if (this.secret) {
                        _context3.next = 5;
                        break;
                      }

                      throw new Error("secret is not defined");

                    case 5:
                      i = {
                        Authorization: "Bearer ".concat(this.token, ":").concat(this.secret),
                        "Accept-version": "v2",
                        "Content-Type": "application/json;charset=utf-8",
                        "X-NATIVE-SDK": "txjs/node/4.2.1"
                      };
                      _context3.next = 8;
                      return a().post("".concat(this.cdsHost, "/content"), {
                        data: e,
                        meta: {
                          purge: !!n.purge,
                          override_tags: !!n.overrideTags
                        }
                      }, {
                        headers: i
                      });

                    case 8:
                      t = _context3.sent;
                      s = "".concat(this.cdsHost).concat(t.data.data.links.job);

                      if (!n.noWait) {
                        _context3.next = 12;
                        break;
                      }

                      return _context3.abrupt("return", {
                        jobUrl: s
                      });

                    case 12:
                      o = {
                        status: ""
                      };

                    case 13:
                      _context3.next = 15;
                      return g(1500);

                    case 15:
                      _context3.next = 17;
                      return a().get(s, {
                        headers: i
                      });

                    case 17:
                      _e25 = _context3.sent;
                      _n25 = _e25.data.data;
                      o = _objectSpread(_objectSpread({}, _n25.details || {}), {}, {
                        errors: _n25.errors || [],
                        status: _n25.status
                      });

                    case 20:
                      if ("pending" === o.status || "processing" === o.status) {
                        _context3.next = 13;
                        break;
                      }

                    case 21:
                      return _context3.abrupt("return", _objectSpread({
                        jobUrl: s
                      }, o));

                    case 22:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, this);
            }));

            function pushSource(_x2) {
              return _pushSource.apply(this, arguments);
            }

            return pushSource;
          }()
        }, {
          key: "getLocales",
          value: function () {
            var _getLocales = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
              var _this16 = this;

              var e,
                  n,
                  _e26,
                  _i31,
                  _t21,
                  _e27,
                  _s11,
                  _args4 = arguments;

              return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      e = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};

                      if (!(!e.refresh && this.locales.length > 0)) {
                        _context4.next = 3;
                        break;
                      }

                      return _context4.abrupt("return", _toConsumableArray(this.locales));

                    case 3:
                      if (this.token) {
                        _context4.next = 5;
                        break;
                      }

                      return _context4.abrupt("return", []);

                    case 5:
                      n = function n(e) {
                        return C(S, null, _this16), e;
                      };

                      _context4.prev = 6;
                      C(j, null, this);
                      _i31 = 202;
                      _t21 = Date.now();

                    case 10:
                      if (!(202 === _i31)) {
                        _context4.next = 23;
                        break;
                      }

                      _context4.next = 13;
                      return a().get("".concat(this.cdsHost, "/languages"), {
                        headers: {
                          Authorization: "Bearer ".concat(this.token),
                          "Accept-version": "v2",
                          "X-NATIVE-SDK": "txjs/node/4.2.1"
                        }
                      });

                    case 13:
                      _e26 = _context4.sent;
                      _i31 = _e26.status;

                      if (!(this.fetchTimeout > 0 && Date.now() - _t21 >= this.fetchTimeout)) {
                        _context4.next = 17;
                        break;
                      }

                      throw n(new Error("Get locales timeout"));

                    case 17:
                      _context4.t0 = 202 === _i31 && this.fetchInterval > 0;

                      if (!_context4.t0) {
                        _context4.next = 21;
                        break;
                      }

                      _context4.next = 21;
                      return g(this.fetchInterval);

                    case 21:
                      _context4.next = 10;
                      break;

                    case 23:
                      _e27 = _e26, _s11 = _e27.data;

                      if (!(!_s11 || !_s11.data)) {
                        _context4.next = 26;
                        break;
                      }

                      throw n(new Error("Could not fetch languages"));

                    case 26:
                      this.languages = _s11.data, this.locales = this.languages.map(function (e) {
                        return e.code;
                      }), C(_, null, this);
                      _context4.next = 32;
                      break;

                    case 29:
                      _context4.prev = 29;
                      _context4.t1 = _context4["catch"](6);
                      throw n(_context4.t1);

                    case 32:
                      return _context4.abrupt("return", _toConsumableArray(this.locales));

                    case 33:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4, this, [[6, 29]]);
            }));

            function getLocales() {
              return _getLocales.apply(this, arguments);
            }

            return getLocales;
          }()
        }, {
          key: "getCurrentLocale",
          value: function getCurrentLocale() {
            return this.currentLocale;
          }
        }, {
          key: "isCurrent",
          value: function isCurrent(e) {
            return e === this.currentLocale;
          }
        }, {
          key: "setCurrentLocale",
          value: function () {
            var _setCurrentLocale = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e) {
              return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      if (!this.isCurrent(e)) {
                        _context5.next = 5;
                        break;
                      }

                      _context5.next = 3;
                      return this._syncInstances(this.childInstances);

                    case 3:
                      _context5.next = 16;
                      break;

                    case 5:
                      if (e) {
                        _context5.next = 10;
                        break;
                      }

                      this.currentLocale = "";
                      _context5.next = 9;
                      return this._syncInstances(this.childInstances);

                    case 9:
                      return _context5.abrupt("return", void C(k, this.currentLocale, this));

                    case 10:
                      _context5.next = 12;
                      return this.fetchTranslations(e);

                    case 12:
                      this.currentLocale = e;
                      _context5.next = 15;
                      return this._syncInstances(this.childInstances);

                    case 15:
                      C(k, e, this);

                    case 16:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5, this);
            }));

            function setCurrentLocale(_x3) {
              return _setCurrentLocale.apply(this, arguments);
            }

            return setCurrentLocale;
          }()
        }, {
          key: "getLanguages",
          value: function () {
            var _getLanguages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
              var e,
                  _args6 = arguments;
              return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      e = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
                      _context6.next = 3;
                      return this.getLocales(e);

                    case 3:
                      return _context6.abrupt("return", _toConsumableArray(this.languages));

                    case 4:
                    case "end":
                      return _context6.stop();
                  }
                }
              }, _callee6, this);
            }));

            function getLanguages() {
              return _getLanguages.apply(this, arguments);
            }

            return getLanguages;
          }()
        }, {
          key: "controllerOf",
          value: function () {
            var _controllerOf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(e) {
              return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      if (!(e === this)) {
                        _context7.next = 2;
                        break;
                      }

                      throw new Error("Cannot add self as instance");

                    case 2:
                      if (!(-1 !== e.childInstances.indexOf(this))) {
                        _context7.next = 4;
                        break;
                      }

                      throw new Error("Cycle reference error, instance is controller of this");

                    case 4:
                      this.childInstances.push(e);
                      _context7.next = 7;
                      return this._syncInstances([e]);

                    case 7:
                      return _context7.abrupt("return", e);

                    case 8:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, _callee7, this);
            }));

            function controllerOf(_x4) {
              return _controllerOf.apply(this, arguments);
            }

            return controllerOf;
          }()
        }, {
          key: "_syncInstances",
          value: function () {
            var _syncInstances2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e) {
              var a, _n26;

              return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                while (1) {
                  switch (_context8.prev = _context8.next) {
                    case 0:
                      a = this.getCurrentLocale();

                      if (!a) {
                        _context8.next = 15;
                        break;
                      }

                      _n26 = 0;

                    case 3:
                      if (!(_n26 < e.length)) {
                        _context8.next = 15;
                        break;
                      }

                      if (!(e[_n26].getCurrentLocale() !== a)) {
                        _context8.next = 12;
                        break;
                      }

                      _context8.prev = 5;
                      _context8.next = 8;
                      return e[_n26].fetchTranslations(a);

                    case 8:
                      _context8.next = 12;
                      break;

                    case 10:
                      _context8.prev = 10;
                      _context8.t0 = _context8["catch"](5);

                    case 12:
                      _n26++;
                      _context8.next = 3;
                      break;

                    case 15:
                      e.forEach(function (e) {
                        e.getCurrentLocale() !== a && (e.currentLocale = a, C(k, a, e));
                      });

                    case 16:
                    case "end":
                      return _context8.stop();
                  }
                }
              }, _callee8, this, [[5, 10]]);
            }));

            function _syncInstances(_x5) {
              return _syncInstances2.apply(this, arguments);
            }

            return _syncInstances;
          }()
        }]);

        return L;
      }();

      var B = {
        a: "ȧ",
        A: "Ȧ",
        b: "ƀ",
        B: "Ɓ",
        c: "ƈ",
        C: "Ƈ",
        d: "ḓ",
        D: "Ḓ",
        e: "ḗ",
        E: "Ḗ",
        f: "ƒ",
        F: "Ƒ",
        g: "ɠ",
        G: "Ɠ",
        h: "ħ",
        H: "Ħ",
        i: "ī",
        I: "Ī",
        j: "ĵ",
        J: "Ĵ",
        k: "ķ",
        K: "Ķ",
        l: "ŀ",
        L: "Ŀ",
        m: "ḿ",
        M: "Ḿ",
        n: "ƞ",
        N: "Ƞ",
        o: "ǿ",
        O: "Ǿ",
        p: "ƥ",
        P: "Ƥ",
        q: "ɋ",
        Q: "Ɋ",
        r: "ř",
        R: "Ř",
        s: "ş",
        S: "Ş",
        t: "ŧ",
        T: "Ŧ",
        v: "ṽ",
        V: "Ṽ",
        u: "ŭ",
        U: "Ŭ",
        w: "ẇ",
        W: "Ẇ",
        x: "ẋ",
        X: "Ẋ",
        y: "ẏ",
        Y: "Ẏ",
        z: "ẑ",
        Z: "Ẑ"
      },
          P = /*#__PURE__*/function () {
        function P() {
          _classCallCheck(this, P);
        }

        _createClass(P, [{
          key: "handle",
          value: function handle(e, a) {
            return e.split(/__txnative__/).map(function (e) {
              var a = "";

              for (var _n27 = 0; _n27 < e.length; _n27 += 1) {
                var _i32 = e.charAt(_n27);

                if (B[_i32]) {
                  var _e28 = _i32.toLowerCase();

                  a += "a" === _e28 || "e" === _e28 || "o" === _e28 || "u" === _e28 ? B[_i32] + B[_i32] : B[_i32];
                } else a += _i32;
              }

              return a;
            }).join("__txnative__");
          }
        }]);

        return P;
      }(),
          D = o,
          $ = s,
          I = /*#__PURE__*/function () {
        function I() {
          _classCallCheck(this, I);
        }

        _createClass(I, [{
          key: "handle",
          value: function handle(e, a, n, i) {
            throw e || new Error("Error translating \"".concat(a, "\""));
          }
        }]);

        return I;
      }(),
          U = l,
          M = function M(e) {
        var a = new L();
        return a.t = a.translate.bind(a), e && a.init(e), a;
      },
          H = new L(),
          W = H.translate.bind(H);
    }(), i;
  }();
});